export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateLDN: { input: any; output: any; }
  FileDataInput: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JWT: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AiSettingsInput = {
  apiKey: Scalars['String']['input'];
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  n?: InputMaybe<Scalars['Int']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  userPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityHeatmap = {
  __typename?: 'ActivityHeatmap';
  avgAttempted?: Maybe<Scalars['Float']['output']>;
  avgScore?: Maybe<Scalars['Float']['output']>;
  dailyProgress?: Maybe<Array<Maybe<DailyProgress>>>;
};

/** Input is part of the admin notification creation mutation */
export type AddAdminNotificationInput = {
  actionType: NotificationActionType;
  description: Scalars['String']['input'];
  type: NotificationType;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type AddChapterHighlightInput = {
  chapterId: Scalars['Int']['input'];
  highlights?: InputMaybe<Array<InputMaybe<HighlightInput>>>;
};

/** Input is part of the notification creation mutation */
export type AddNotificationInput = {
  actionType: NotificationActionType;
  commentId?: InputMaybe<Scalars['Int']['input']>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fromUserCommentId?: InputMaybe<Scalars['Int']['input']>;
  fromUserId?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type: NotificationType;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddQuestionHighlightInput = {
  highlights?: InputMaybe<Array<InputMaybe<HighlightInput>>>;
  questionId: Scalars['Int']['input'];
};

export type AddQuestionLearningPointInput = {
  questionId: Scalars['Int']['input'];
  userPoint: Scalars['Int']['input'];
};

/** Admin mutations only allowed by administrator users */
export type AdminMutation = {
  __typename?: 'AdminMutation';
  /** Creates an announcement Notification for all users */
  addNotification?: Maybe<Notification>;
  /** Creates many announcement Notifications for all users */
  addNotifications?: Maybe<Array<Maybe<Notification>>>;
  /** Moves existing accounts to the university and creates missing ones SSO-only. Max 500 emails. */
  addSsoUsers: Array<AdminSsoProvisionResult>;
  /** Each entry is a user id (digits) or an email. Max 500. Never creates users. */
  addUniversityAccountStudents: UniversityAccountAddStudentsResult;
  /** Re index the algolia */
  algoliaSync?: Maybe<Scalars['Boolean']['output']>;
  /** clone content */
  cloneContent?: Maybe<ResultData>;
  /** Sync the sendgrid contacts */
  contactSync?: Maybe<ResultData>;
  /** Get the sync status */
  contactSyncStatus?: Maybe<ResultData>;
  createAssets: Array<Picture>;
  createBlog?: Maybe<BlogPost>;
  createJob?: Maybe<Job>;
  createJobAssets: Array<JobAsset>;
  createJobChat?: Maybe<JobChat>;
  createJobRecord?: Maybe<JobRecord>;
  createJobRemark?: Maybe<JobRemark>;
  createPrompt: Prompt;
  /** Creates a university-admin login, or re-attaches an existing one that has no account */
  createUniversityAdmin: UniversityAccountAdmin;
  deleteBlogs?: Maybe<Scalars['Boolean']['output']>;
  /** delete files from aws */
  deleteFiles?: Maybe<ResultData>;
  /** delete images from DB and AWS */
  deleteImages?: Maybe<ResultData>;
  deleteJob?: Maybe<Scalars['Boolean']['output']>;
  deleteJobChat?: Maybe<Scalars['Boolean']['output']>;
  deleteJobChats?: Maybe<Scalars['Boolean']['output']>;
  deleteJobRecord?: Maybe<Scalars['Boolean']['output']>;
  deleteJobRemark?: Maybe<Scalars['Boolean']['output']>;
  deletePrompts: Scalars['Boolean']['output'];
  /** Deletes a question */
  deleteQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** delete records */
  deleteRecords?: Maybe<ResultData>;
  deleteStation?: Maybe<ResultData>;
  /** Deletes the account and its memberships; admin user rows stay but can no longer log in */
  deleteUniversityAccount: Scalars['Boolean']['output'];
  downloadBatch?: Maybe<Scalars['String']['output']>;
  /** download images */
  downloadImages?: Maybe<ResultData>;
  downloadOsceSessionData: ResultData;
  duplicateJob?: Maybe<Job>;
  duplicateJobRecord?: Maybe<JobRecord>;
  /** get product transactions and total payments */
  getProductTransactions?: Maybe<ResultData>;
  highYield?: Maybe<Scalars['String']['output']>;
  /** Import a validated batchId into a db */
  importBatch?: Maybe<ValidatorResult>;
  importJobRecords: ImportResult;
  /** Manage a question comment */
  manageQuestionComment?: Maybe<Scalars['Boolean']['output']>;
  manageUserSubs?: Maybe<Scalars['Boolean']['output']>;
  markStudyGroupRefundManual: StudyGroupAdminMember;
  /** Run a prompt through AI and get results */
  promptLab?: Maybe<Array<Maybe<PromptLabResult>>>;
  /** get queue status */
  queueStatus?: Maybe<ResultData>;
  redisCall?: Maybe<Scalars['String']['output']>;
  /** Refresh materialzied view */
  refreshMtv?: Maybe<Scalars['Boolean']['output']>;
  /** Re populate the wiki links */
  refreshWiki?: Maybe<Scalars['Boolean']['output']>;
  removeAssets?: Maybe<Scalars['Boolean']['output']>;
  removeJobAssets?: Maybe<Scalars['Boolean']['output']>;
  /** Removes memberships only. Returns the number removed. */
  removeUniversityAccountStudents: Scalars['Int']['output'];
  /** Removes the admin's membership; the user row stays but can no longer log in */
  removeUniversityAdmin: Scalars['Boolean']['output'];
  /** Reset question difficulty */
  resetQueDifficulty?: Maybe<Scalars['Boolean']['output']>;
  /** Reset a question */
  resetQuestion?: Maybe<Scalars['Boolean']['output']>;
  retryStudyGroupRefund: StudyGroupAdminMember;
  sendPushNotification?: Maybe<Scalars['String']['output']>;
  sendTopicNotification?: Maybe<Scalars['String']['output']>;
  setUniversityAdminPassword: Scalars['Boolean']['output'];
  /** Update a batch visibility */
  toggleVisibility?: Maybe<ValidatorResult>;
  /** Update a validated batch into a db */
  updateBatch?: Maybe<ValidatorResult>;
  updateBlog?: Maybe<BlogPost>;
  updateChapter?: Maybe<Chapter>;
  updateJob?: Maybe<Job>;
  updateJobRecord?: Maybe<JobRecord>;
  updateJobRecordStatus?: Maybe<Array<Maybe<JobRecord>>>;
  updateJobRemark?: Maybe<JobRemark>;
  updateJobStatus?: Maybe<Job>;
  updatePrompt: Prompt;
  /** Update a question */
  updateQuestion?: Maybe<Question>;
  updateStation?: Maybe<OsceStation>;
  /** upload files to AWS */
  uploadFiles?: Maybe<ResultData>;
  /** upload images to DB and AWS */
  uploadImages?: Maybe<ResultData>;
  upsertGroupDiscountConfig: GroupDiscountConfig;
  upsertSsoConnection: AdminSsoConnection;
  upsertUniversityAccount: UniversityAccount;
  /** Validates the book markdown and if all okay returns a batchId */
  validateBook?: Maybe<ValidatorResult>;
  /** Validates the mock test markdown and if all okay returns a batchId */
  validateMockTest?: Maybe<ValidatorResult>;
  /** Validates the question markdown and if all okay returns a batchId */
  validateQuestions?: Maybe<ValidatorResult>;
  /** Validates the station markdown and if all okay returns a batchId */
  validateStations?: Maybe<ValidatorResult>;
  validateUcatQuestions?: Maybe<ValidatorResult>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationAddNotificationArgs = {
  data: AddAdminNotificationInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationAddNotificationsArgs = {
  data: Array<AddAdminNotificationInput>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationAddSsoUsersArgs = {
  connectionId: Scalars['Int']['input'];
  emails: Array<Scalars['String']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationAddUniversityAccountStudentsArgs = {
  accountId: Scalars['Int']['input'];
  identifiers: Array<Scalars['String']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationAlgoliaSyncArgs = {
  index: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCloneContentArgs = {
  destination: Scalars['Int']['input'];
  file: Scalars['FileDataInput']['input'];
  source: Scalars['Int']['input'];
  type: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationContactSyncArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationContactSyncStatusArgs = {
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreateAssetsArgs = {
  inputs: Array<CreateAssetsInput>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreateBlogArgs = {
  input: CreateBlogInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreateJobArgs = {
  input: CreateJobInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreateJobAssetsArgs = {
  inputs: Array<JobAssetInput>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreateJobChatArgs = {
  input: CreateJobChatInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreateJobRecordArgs = {
  input: CreateJobRecordInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreateJobRemarkArgs = {
  input: CreateJobRemarkInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreatePromptArgs = {
  input: CreatePromptInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationCreateUniversityAdminArgs = {
  accountId: Scalars['Int']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteBlogsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteFilesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentFolder?: InputMaybe<Scalars['String']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteImagesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteJobArgs = {
  id: Scalars['ID']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteJobChatArgs = {
  id: Scalars['ID']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteJobChatsArgs = {
  jobId: Scalars['ID']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteJobRecordArgs = {
  id: Scalars['ID']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteJobRemarkArgs = {
  id: Scalars['ID']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeletePromptsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteQuestionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteRecordsArgs = {
  input: DeleteRecordsInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteStationArgs = {
  stationId: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDeleteUniversityAccountArgs = {
  id: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDownloadBatchArgs = {
  apiKey: Scalars['String']['input'];
  batchId: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDownloadImagesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDownloadOsceSessionDataArgs = {
  osceMarksheetId: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDuplicateJobArgs = {
  id: Scalars['ID']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationDuplicateJobRecordArgs = {
  id: Scalars['ID']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationGetProductTransactionsArgs = {
  input: ProductTransactionInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationHighYieldArgs = {
  chapterIds: Array<Scalars['Int']['input']>;
  settings: AiSettingsInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationImportBatchArgs = {
  batchId: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationImportJobRecordsArgs = {
  file: Scalars['FileDataInput']['input'];
  format: JobBulkFormat;
  jobId: Scalars['ID']['input'];
  jobType: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationManageQuestionCommentArgs = {
  ids: Array<Scalars['ID']['input']>;
  operation: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationManageUserSubsArgs = {
  cancelAtPeriodEnd: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emailNotification?: InputMaybe<EmailInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  stripePriceIds: Array<Scalars['String']['input']>;
  usernames: Array<InputMaybe<Scalars['String']['input']>>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationMarkStudyGroupRefundManualArgs = {
  memberId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationPromptLabArgs = {
  input: AiSettingsInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationQueueStatusArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationRedisCallArgs = {
  input: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationRefreshMtvArgs = {
  name: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationRefreshWikiArgs = {
  chapterIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationRemoveAssetsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationRemoveJobAssetsArgs = {
  ids: Array<Scalars['ID']['input']>;
  unlink?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationRemoveUniversityAccountStudentsArgs = {
  accountId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationRemoveUniversityAdminArgs = {
  userId: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationResetQuestionArgs = {
  ids: Array<Scalars['ID']['input']>;
  operation: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationRetryStudyGroupRefundArgs = {
  memberId: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationSendPushNotificationArgs = {
  data: FcmInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationSendTopicNotificationArgs = {
  data: FcmInput;
  topic: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationSetUniversityAdminPasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationToggleVisibilityArgs = {
  input: VisibilityInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateBatchArgs = {
  batchId: Scalars['String']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateBlogArgs = {
  id: Scalars['Int']['input'];
  input: UpdateBlogInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateChapterArgs = {
  input: UpdateChapterInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateJobArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateJobRecordArgs = {
  createdAssetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  deletedAssetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  input: JobRecordDataInput;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateJobRecordStatusArgs = {
  ids: Array<Scalars['ID']['input']>;
  status: Scalars['Int']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateJobRemarkArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobRemarkInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateJobStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['Int']['input'];
  statusOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdatePromptArgs = {
  id: Scalars['Int']['input'];
  input: UpdatePromptInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateQuestionArgs = {
  input: UpdateQuestionInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpdateStationArgs = {
  input: UpdateStationInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUploadFilesArgs = {
  file: Scalars['FileDataInput']['input'];
  parentFolder?: InputMaybe<Scalars['String']['input']>;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUploadImagesArgs = {
  file: Scalars['FileDataInput']['input'];
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpsertGroupDiscountConfigArgs = {
  input: UpsertGroupDiscountConfigInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpsertSsoConnectionArgs = {
  input: AdminSsoConnectionInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationUpsertUniversityAccountArgs = {
  input: UniversityAccountInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationValidateBookArgs = {
  input: ValidateBookInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationValidateMockTestArgs = {
  input: ValidateMockTestInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationValidateQuestionsArgs = {
  input: ValidateQuestionInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationValidateStationsArgs = {
  input: ValidateStationInput;
};


/** Admin mutations only allowed by administrator users */
export type AdminMutationValidateUcatQuestionsArgs = {
  input: ValidateUcatQuestionInput;
};

export type AdminQuery = {
  __typename?: 'AdminQuery';
  /** adminMarksheet is the admin-panel equivalent of marksheet(id) — same resolver, same data */
  adminMarksheet?: Maybe<Marksheet>;
  appUsageGraph?: Maybe<Array<Maybe<TimeSeriesData>>>;
  chapter?: Maybe<Chapter>;
  database?: Maybe<DatabaseFmv>;
  dropdownOptions?: Maybe<Array<Maybe<BreakdownValue>>>;
  earnings?: Maybe<Array<Maybe<Revenue>>>;
  earningsGraph?: Maybe<Array<Maybe<TimeSeriesData>>>;
  getDownloadUrl?: Maybe<MuxAsset>;
  getIdDetails?: Maybe<Array<Maybe<IdDetails>>>;
  getJob?: Maybe<Job>;
  getJobAssets: Array<JobAsset>;
  getJobChats: Array<JobChatList>;
  getJobRecord?: Maybe<JobRecord>;
  getJobRecords: Array<JobRecord>;
  getJobRemarks: Array<JobRemark>;
  getJobs: JobList;
  getUserToken?: Maybe<Scalars['String']['output']>;
  getVideo?: Maybe<MuxAsset>;
  groupDiscountConfigs: Array<GroupDiscountConfig>;
  importStats?: Maybe<ImportStats>;
  osceAiCorrectionsOverTime: OsceAiCorrectionsOverTime;
  osceAiCostOverTime: OsceAiCostOverTime;
  osceAiLatencyOverTime: OsceAiLatencyOverTime;
  osceAiRecentSessions: OsceAiRecentSessionsResult;
  osceAiSessionsByStation: Array<OsceAiSessionsByStation>;
  osceAiSessionsOverTime: OsceAiSessionsOverTime;
  osceAiStatsSummary: OsceAiKpiOverview;
  osceAiTimeoutsOverTime: OsceAiTimeoutsOverTime;
  osceAiTokensByPhase: Array<OsceAiTokenByPhase>;
  osceMarksheet?: Maybe<OsceMarksheet>;
  osceMarksheetStat: OsceMarksheetStat;
  prompt?: Maybe<Prompt>;
  prompts: Array<Prompt>;
  question?: Maybe<Question>;
  questionStats?: Maybe<QuestionStats>;
  refunds?: Maybe<Array<Maybe<Revenue>>>;
  sendgridLists?: Maybe<Array<Maybe<SendgridList>>>;
  ssoConnection?: Maybe<AdminSsoConnection>;
  ssoConnectionUsers: AdminSsoUsersPage;
  ssoConnections: Array<AdminSsoConnection>;
  ssoStats: AdminSsoStats;
  studyGroup?: Maybe<StudyGroupAdmin>;
  studyGroupDiscountsOverTime: Array<StudyGroupDiscountsOverTimePoint>;
  studyGroupStats: StudyGroupAdminStats;
  studyGroupUsageByProduct: Array<StudyGroupUsageByProduct>;
  studyGroups: StudyGroupAdminList;
  /** Cached for an hour; refresh: true to rebuild. No dates = last 90 days */
  studyGroupsOverTime: Array<StudyGroupsOverTimePoint>;
  tutorAiCostOverTime: TutorAiCostOverTime;
  tutorAiLatencyOverTime: TutorAiLatencyOverTime;
  tutorAiMarksheets: TutorAiMarksheetsResult;
  tutorAiSessionsByProduct: Array<TutorAiSessionsByProduct>;
  tutorAiSessionsOverTime: TutorAiSessionsOverTime;
  tutorAiStatsSummary: TutorAiKpiOverview;
  tutorAiTimeoutsOverTime: TutorAiTimeoutsOverTime;
  tutorAiTokensByPhase: Array<TutorAiTokenByPhase>;
  tutorAiTokensOverTime: TutorAiTokensOverTime;
  tutorConversationDetail?: Maybe<TutorConversationDetail>;
  tutorConversationsByMarksheet: Array<TutorConversationSummary>;
  universityAccount?: Maybe<UniversityAccount>;
  universityAccountAdmins: Array<UniversityAccountAdmin>;
  universityAccountStudents: UniversityAccountStudentsPage;
  universityAccounts: Array<UniversityAccount>;
  userBreakdown?: Maybe<UserBreakdown>;
  userCancellationReasons?: Maybe<CancellationReason>;
  userFeedbacks?: Maybe<Feedback>;
  userFeedbacksGraph?: Maybe<Array<Maybe<TimeSeriesData>>>;
  userSessions?: Maybe<Array<Maybe<UserSession>>>;
  userStatus?: Maybe<UserStatus>;
};


export type AdminQueryAdminMarksheetArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryAppUsageGraphArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryChapterArgs = {
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryDropdownOptionsArgs = {
  conditionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  entitlementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  presentationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type AdminQueryEarningsArgs = {
  classYear?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  source?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  universityId?: InputMaybe<Scalars['Int']['input']>;
  useNetEarning?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdminQueryEarningsGraphArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  source?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<Scalars['Int']['input']>;
  universityId?: InputMaybe<Scalars['Int']['input']>;
  useNetEarning?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryGetDownloadUrlArgs = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  museId?: InputMaybe<Scalars['String']['input']>;
};


export type AdminQueryGetIdDetailsArgs = {
  ids: Array<Scalars['ID']['input']>;
  table: Scalars['String']['input'];
};


export type AdminQueryGetJobArgs = {
  id: Scalars['ID']['input'];
};


export type AdminQueryGetJobAssetsArgs = {
  jobId: Scalars['ID']['input'];
};


export type AdminQueryGetJobChatsArgs = {
  jobId: Scalars['ID']['input'];
};


export type AdminQueryGetJobRecordArgs = {
  id: Scalars['ID']['input'];
};


export type AdminQueryGetJobRecordsArgs = {
  jobId: Scalars['ID']['input'];
};


export type AdminQueryGetJobRemarksArgs = {
  jobId: Scalars['ID']['input'];
};


export type AdminQueryGetJobsArgs = {
  filter?: InputMaybe<JobsFilterInput>;
  page: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type AdminQueryGetUserTokenArgs = {
  username: Scalars['String']['input'];
};


export type AdminQueryGetVideoArgs = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  museId?: InputMaybe<Scalars['String']['input']>;
};


export type AdminQueryImportStatsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceAiCorrectionsOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceAiCostOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceAiLatencyOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceAiRecentSessionsArgs = {
  mode?: InputMaybe<Scalars['Int']['input']>;
  osceMarksheetId?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  stationId?: InputMaybe<Scalars['Int']['input']>;
  take: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryOsceAiSessionsByStationArgs = {
  attempted?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  osceTypeId: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceAiSessionsOverTimeArgs = {
  attempted?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  osceTypeId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceAiStatsSummaryArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceAiTimeoutsOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  mode?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceAiTokensByPhaseArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryOsceMarksheetArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryOsceMarksheetStatArgs = {
  osceMarksheetId: Scalars['Int']['input'];
};


export type AdminQueryPromptArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryPromptsArgs = {
  codePrefix?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryQuestionStatsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryRefundsArgs = {
  classYear?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  source?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  universityId?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQuerySsoConnectionArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQuerySsoConnectionUsersArgs = {
  domainOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQuerySsoStatsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdminQueryStudyGroupArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryStudyGroupDiscountsOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productTypeId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryStudyGroupStatsArgs = {
  filter?: InputMaybe<StudyGroupAdminFilter>;
};


export type AdminQueryStudyGroupUsageByProductArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryStudyGroupsArgs = {
  filter?: InputMaybe<StudyGroupAdminFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryStudyGroupsOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productTypeId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorAiCostOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorAiLatencyOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorAiMarksheetsArgs = {
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  take: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryTutorAiSessionsByProductArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorAiSessionsOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorAiStatsSummaryArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorAiTimeoutsOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorAiTokensByPhaseArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorAiTokensOverTimeArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryTutorConversationDetailArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryTutorConversationsByMarksheetArgs = {
  marksheetId: Scalars['Int']['input'];
};


export type AdminQueryUniversityAccountArgs = {
  id: Scalars['Int']['input'];
};


export type AdminQueryUniversityAccountAdminsArgs = {
  accountId: Scalars['Int']['input'];
};


export type AdminQueryUniversityAccountStudentsArgs = {
  accountId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryUniversityAccountsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AdminQueryUserBreakdownArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  ucat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdminQueryUserCancellationReasonsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryUserFeedbacksArgs = {
  description?: InputMaybe<Scalars['Boolean']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryUserFeedbacksGraphArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryUserSessionsArgs = {
  email: Scalars['String']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
};


export type AdminQueryUserStatusArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  ucat?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * University SSO (Microsoft Entra) management for the admin panel. See docs/sso-entra.md.
 * Reads: any admin. Writes: SUPER_ADMIN only.
 */
export type AdminSsoConnection = {
  __typename?: 'AdminSsoConnection';
  createdAt?: Maybe<Scalars['Date']['output']>;
  emailDomains: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** Password login and reset are blocked for these domains */
  ssoRequired: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  universityId?: Maybe<Scalars['Int']['output']>;
  universityName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** false: the LiveKit agent doesn't record voice OSCE sessions */
  voiceRecording: Scalars['Boolean']['output'];
};

export type AdminSsoConnectionInput = {
  emailDomains: Array<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Defaults to the university name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to a slug of the university name */
  slug?: InputMaybe<Scalars['String']['input']>;
  ssoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Entra Directory (tenant) ID */
  tenantId: Scalars['String']['input'];
  universityId: Scalars['Int']['input'];
  voiceRecording?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminSsoConnectionStats = {
  __typename?: 'AdminSsoConnectionStats';
  activeLast30d: Scalars['Int']['output'];
  connectionId: Scalars['Int']['output'];
  /** Users whose email domain is one of the connection's domains */
  domainUsers: Scalars['Int']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Users who have signed in with SSO at least once */
  linkedUsers: Scalars['Int']['output'];
  /** Domain users with an unusable password (SSO-only accounts) */
  ssoOnlyUsers: Scalars['Int']['output'];
  /** Users whose universityId is the connection's university */
  universityUsers: Scalars['Int']['output'];
};

export enum AdminSsoProvisionOutcome {
  /** New SSO-only account created (no subscription) */
  CREATED = 'CREATED',
  /** Existing account already in this university */
  EXISTING = 'EXISTING',
  FAILED = 'FAILED',
  /** Existing account moved to this university */
  MOVED = 'MOVED',
  SKIPPED = 'SKIPPED'
}

export type AdminSsoProvisionResult = {
  __typename?: 'AdminSsoProvisionResult';
  email: Scalars['String']['output'];
  outcome: AdminSsoProvisionOutcome;
  reason?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AdminSsoStats = {
  __typename?: 'AdminSsoStats';
  perConnection: Array<AdminSsoConnectionStats>;
  totals: AdminSsoStatsTotals;
};

export type AdminSsoStatsTotals = {
  __typename?: 'AdminSsoStatsTotals';
  activeLast30d: Scalars['Int']['output'];
  connections: Scalars['Int']['output'];
  domainUsers: Scalars['Int']['output'];
  enabledConnections: Scalars['Int']['output'];
  linkedUsers: Scalars['Int']['output'];
  ssoOnlyUsers: Scalars['Int']['output'];
  ssoRequiredConnections: Scalars['Int']['output'];
};

export type AdminSsoUser = {
  __typename?: 'AdminSsoUser';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  linked: Scalars['Boolean']['output'];
  ssoOnly: Scalars['Boolean']['output'];
  universityId?: Maybe<Scalars['Int']['output']>;
  username: Scalars['String']['output'];
};

export type AdminSsoUsersPage = {
  __typename?: 'AdminSsoUsersPage';
  rows: Array<AdminSsoUser>;
  total: Scalars['Int']['output'];
};

export type AssetInput = {
  choiceLabel?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  index: Scalars['Int']['input'];
  typeId: Scalars['Int']['input'];
};

/** Attachment is used by the feedback SupportTicket */
export type Attachment = {
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  title_link: Scalars['String']['input'];
};

export type Author = {
  __typename?: 'Author';
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BlogMeta = {
  __typename?: 'BlogMeta';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BlogMetaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BlogPost = {
  __typename?: 'BlogPost';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  meta?: Maybe<BlogMeta>;
  picture?: Maybe<Picture>;
  pictureId?: Maybe<Scalars['ID']['output']>;
  relatedBlogPosts?: Maybe<Array<Maybe<BlogPost>>>;
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<BlogTag>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BlogTag = {
  __typename?: 'BlogTag';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BookProduct = {
  __typename?: 'BookProduct';
  ISBN?: Maybe<Scalars['Int']['output']>;
  authors?: Maybe<Array<Maybe<Author>>>;
  avatar?: Maybe<Scalars['String']['output']>;
  chapters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  heroImg?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pages?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BreakdownValue = {
  __typename?: 'BreakdownValue';
  description?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  metaData?: Maybe<BreakdownValue>;
  value?: Maybe<Scalars['String']['output']>;
};

/** BuildMarksheetInput is used when building a Marksheet from the PreBuildMarksheet info */
export type BuildMarksheetInput = {
  buildRef?: InputMaybe<Scalars['Int']['input']>;
  isTest: Scalars['Boolean']['input'];
  /** pass if group study */
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  secondsPerQuestion?: InputMaybe<Scalars['Int']['input']>;
  seenCorrect?: InputMaybe<Scalars['Int']['input']>;
  seenIncorrect?: InputMaybe<Scalars['Int']['input']>;
  unseen?: InputMaybe<Scalars['Int']['input']>;
};

/** BuildTodoInput is used to build a Todo from the PrebuildTodo info */
export type BuildTodoInput = {
  buildRef?: InputMaybe<Scalars['Int']['input']>;
  seen?: InputMaybe<Scalars['Int']['input']>;
  unseen?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildUcatMarksheetInput = {
  conceptIds: Array<InputMaybe<Scalars['Int']['input']>>;
  duration: Scalars['Int']['input'];
  entitlementId: Scalars['Int']['input'];
  /** pass if group study */
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  setCount?: InputMaybe<Scalars['Int']['input']>;
  topicIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type BuilderConfig = {
  difficulty?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  secondsPerQuestion?: InputMaybe<Scalars['Int']['input']>;
  seenCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  seenIncorrect?: InputMaybe<Scalars['Boolean']['input']>;
  unseen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuilderConfigData = {
  __typename?: 'BuilderConfigData';
  difficulty?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  numberOfQuestions?: Maybe<Scalars['Int']['output']>;
  secondsPerQuestion?: Maybe<Scalars['Int']['output']>;
  seenCorrect?: Maybe<Scalars['Boolean']['output']>;
  seenIncorrect?: Maybe<Scalars['Boolean']['output']>;
  unseen?: Maybe<Scalars['Boolean']['output']>;
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  feedbacks?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Card/QuesCard/Flashcard */
export type Card = {
  __typename?: 'Card';
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  question?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Topic>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/**
 * Chapter is below Concept, but are not unique and can be shared between Concept
 * this includes all content for the Quesbook and Questions including explanation,
 * pictures and files
 */
export type Chapter = {
  __typename?: 'Chapter';
  createdAt?: Maybe<Scalars['Date']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<File>>>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  summary?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChapterHighlight = {
  __typename?: 'ChapterHighlight';
  chapter?: Maybe<Chapter>;
  chapterId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type Circuit = {
  __typename?: 'Circuit';
  /** the current user's latest session for this circuit (null if never started); resume when not completed */
  circuitSession?: Maybe<CircuitSession>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preDefined?: Maybe<Scalars['Boolean']['output']>;
  stations?: Maybe<Array<Maybe<OsceStation>>>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['Int']['output']>;
};

export type CircuitSession = {
  __typename?: 'CircuitSession';
  /** the in-progress marksheet for the active station */
  activeMarksheet?: Maybe<OsceMarksheet>;
  activeStation?: Maybe<OsceStation>;
  activeStationId?: Maybe<Scalars['Int']['output']>;
  /** stations attempted so far (junction rows) */
  attemptedCount?: Maybe<Scalars['Int']['output']>;
  circuit?: Maybe<Circuit>;
  circuitId?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  /** stations whose marksheet has ended */
  completedCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** all attempted stations + their result marksheets (end-of-circuit view) */
  marksheets?: Maybe<Array<Maybe<CircuitSessionMarksheet>>>;
  mode?: Maybe<Scalars['String']['output']>;
  /** stored average score over completed stations */
  score?: Maybe<Scalars['Float']['output']>;
  /** circuit station count captured at create (denominator for progress) */
  totalStations?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CircuitSessionMarksheet = {
  __typename?: 'CircuitSessionMarksheet';
  circuitSessionId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  osceMarksheet?: Maybe<OsceMarksheet>;
  osceMarksheetId?: Maybe<Scalars['Int']['output']>;
  osceStation?: Maybe<OsceStation>;
  osceStationId?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CircuitStationInput = {
  osceStationId: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** Concept is below Topic and can be considered headings within a chapter e.g. Heart failure */
export type Concept = {
  __typename?: 'Concept';
  chapter?: Maybe<Chapter>;
  chapterId?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyFeedCards?: Maybe<Scalars['Int']['output']>;
  /** specify if concept available for demo mode */
  demo?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlement?: Maybe<Entitlement>;
  entitlementId?: Maybe<Scalars['Int']['output']>;
  greenCards?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redCards?: Maybe<Scalars['Int']['output']>;
  /** Learning status */
  status?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  topicId?: Maybe<Scalars['Int']['output']>;
  totalCards?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  totalVideos?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userChapter?: Maybe<UserConceptChapter>;
  userNote?: Maybe<UserConceptNote>;
  videos?: Maybe<Array<Maybe<Video>>>;
  yellowCards?: Maybe<Scalars['Int']['output']>;
};

export type Condition = {
  __typename?: 'Condition';
  bodySystemId?: Maybe<Scalars['Int']['output']>;
  /** 0=unchanged, 1=renamed, 2=new. */
  changeType?: Maybe<Scalars['Int']['output']>;
  concepts?: Maybe<Array<Maybe<Concept>>>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /**
   * specify if condition available for demo mode
   * @deprecated Legacy UKMLA content map. Not set on UKMLA 2026 rows
   */
  demo?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  /** Legacy names that differ from this row's name. */
  legacyNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  questionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** @deprecated Legacy UKMLA content map. Not set on UKMLA 2026 rows */
  topic?: Maybe<UkmlaTopic>;
  /** @deprecated Legacy UKMLA content map. Use bodySystemId instead */
  topicId?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CreateAssetsInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['FileDataInput']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  overlay?: InputMaybe<Scalars['Boolean']['input']>;
  sensitive?: InputMaybe<Scalars['Boolean']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBlogInput = {
  body: Scalars['String']['input'];
  meta: BlogMetaInput;
  pictureId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
  tagIds: Array<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CreateCircuitInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  stations?: InputMaybe<Array<CircuitStationInput>>;
  visibility?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateJobChatInput = {
  jobId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateJobInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  members?: InputMaybe<Array<JobMemberInput>>;
  metadata?: InputMaybe<JobMetaDataInput>;
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  status: Scalars['Int']['input'];
  totalRecords?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['Int']['input'];
};

export type CreateJobRecordInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  data: JobRecordDataInput;
  jobId: Scalars['ID']['input'];
  referenceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateJobRemarkInput = {
  createdBy: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
  recordId?: InputMaybe<Scalars['ID']['input']>;
  remark: Scalars['String']['input'];
};

/** CreatePresetInput is used on the editing a preset mutation */
export type CreatePresetInput = {
  conceptIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePromptInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<PromptFormat>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRecordReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Array<RecordReviewMemberInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateStationInput = {
  actorBrief?: InputMaybe<Scalars['String']['input']>;
  aiConfig?: InputMaybe<Scalars['JSON']['input']>;
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<Array<AssetInput>>;
  candidateBrief?: InputMaybe<Scalars['String']['input']>;
  clinicalData?: InputMaybe<Scalars['JSON']['input']>;
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Int']['input']>;
  entitlementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  examinerBrief?: InputMaybe<Scalars['String']['input']>;
  examinerQuestions?: InputMaybe<Array<ExaminerQuestionInput>>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  hiddenName?: InputMaybe<Scalars['String']['input']>;
  llmActorBrief?: InputMaybe<Scalars['String']['input']>;
  marks?: InputMaybe<Array<JobStationMarkInput>>;
  name: Scalars['String']['input'];
  osceTypeId?: InputMaybe<Scalars['Int']['input']>;
  phaseTimers?: InputMaybe<Scalars['JSON']['input']>;
  pictureId?: InputMaybe<Scalars['Int']['input']>;
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  visibility?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWeeklyRecordReviewInput = {
  dislikesThreshold?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<RecordReviewMemberInput>>;
  percentageGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  percentageLessThan?: InputMaybe<Scalars['Int']['input']>;
  questionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type DailyProgress = {
  __typename?: 'DailyProgress';
  date?: Maybe<Scalars['Date']['output']>;
  dateString?: Maybe<Scalars['String']['output']>;
  intensity?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  totalAttempted?: Maybe<Scalars['Int']['output']>;
  totalCorrect?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalIncorrect?: Maybe<Scalars['Int']['output']>;
};

export type DatabaseFmv = {
  __typename?: 'DatabaseFMV';
  functions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  materializedViews?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  views?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DateResultMarksheetPair = {
  __typename?: 'DateResultMarksheetPair';
  date?: Maybe<Scalars['Date']['output']>;
  result?: Maybe<Array<Maybe<Marksheet>>>;
};

export type DateResultOsceMarksheetPair = {
  __typename?: 'DateResultOsceMarksheetPair';
  date?: Maybe<Scalars['Date']['output']>;
  result?: Maybe<Array<Maybe<OsceMarksheet>>>;
};

export type DeleteRecordsInput = {
  reason: Scalars['String']['input'];
  recordIds: Array<Scalars['Int']['input']>;
  type: Scalars['Int']['input'];
};

export type Dose = {
  __typename?: 'Dose';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type Drug = {
  __typename?: 'Drug';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type Duration = {
  __typename?: 'Duration';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export enum EGenerateStationStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  READY = 'READY'
}

export enum EMarksheetAction {
  CHOICE_SELECTED = 'CHOICE_SELECTED',
  CONNECT = 'CONNECT',
  CONTINUE = 'CONTINUE',
  DISCONNECT = 'DISCONNECT',
  END = 'END',
  KICK = 'KICK',
  LEFT = 'LEFT',
  PAUSE = 'PAUSE',
  PRESTART = 'PRESTART',
  QUESTION_CHANGE = 'QUESTION_CHANGE',
  SELECT = 'SELECT',
  START = 'START'
}

export enum EMarksheetState {
  LOBBY = 'LOBBY',
  PRESTART = 'PRESTART',
  RESULT = 'RESULT',
  STATION = 'STATION'
}

export type EditCircuitInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stations?: InputMaybe<Array<CircuitStationInput>>;
  visibility?: InputMaybe<Scalars['Int']['input']>;
};

/** EditPresetInput is used on the editing a preset mutation */
export type EditPresetInput = {
  conceptIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmailInput = {
  subject?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Entitlement is a subtype of Product */
export type Entitlement = {
  __typename?: 'Entitlement';
  id?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<Topic>>>;
};

export type EntitlementType = {
  __typename?: 'EntitlementType';
  completedQuestions?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  dailyFeedCards?: Maybe<Scalars['Int']['output']>;
  greenCards?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partialQuestions?: Maybe<Scalars['Int']['output']>;
  redCards?: Maybe<Scalars['Int']['output']>;
  totalCards?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  yellowCards?: Maybe<Scalars['Int']['output']>;
};

export type ExaminerQuestion = {
  __typename?: 'ExaminerQuestion';
  index?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type ExaminerQuestionInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

/** FCMNotificationInput is used to redirect the mobile user to the URL */
export type FcmDataInput = {
  url?: InputMaybe<Scalars['String']['input']>;
};

/** FCMInput is used to publish mobile notificaitons */
export type FcmInput = {
  data?: InputMaybe<FcmDataInput>;
  notification: FcmNotificationInput;
};

/** FCMNotificationInput is to provide the text info in the notification */
export type FcmNotificationInput = {
  body: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  average?: Maybe<Scalars['Float']['output']>;
  feedbacks?: Maybe<Array<Maybe<ReviewData>>>;
  ratings?: Maybe<Array<Maybe<Rating>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** File is used for downloadable files for the Concept/Quesbook and Video */
export type File = {
  __typename?: 'File';
  conceptId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  url: Scalars['String']['output'];
  videoId?: Maybe<Scalars['Int']['output']>;
};

/** Question stats in date range that match filters; same shape as data used when inserting into record_review (no members). */
export type FilteredRecordReview = {
  __typename?: 'FilteredRecordReview';
  attemptPercentage?: Maybe<Scalars['Float']['output']>;
  attemptPercentageSinceLastEdit?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  firstAttemptPercentage?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  newComments?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  question?: Maybe<Question>;
  reason?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  totalComments?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  votePercentage?: Maybe<Scalars['Float']['output']>;
};

export type FilteredRecordReviewList = {
  __typename?: 'FilteredRecordReviewList';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  nextCursor?: Maybe<Scalars['Int']['output']>;
  result: Array<FilteredRecordReview>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FilteredRecordReviewOptions = {
  dislikesThreshold?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  percentageGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  percentageLessThan?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FlaggedQuestionInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type ForcedChecks = {
  concept?: InputMaybe<Scalars['Boolean']['input']>;
  condition?: InputMaybe<Scalars['Boolean']['input']>;
  presentation?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  station?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['Boolean']['input']>;
  topic?: InputMaybe<Scalars['Boolean']['input']>;
  ukmlaTopic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ForcedInserts = {
  concept?: InputMaybe<Scalars['Boolean']['input']>;
  condition?: InputMaybe<Scalars['Boolean']['input']>;
  presentation?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['Boolean']['input']>;
  station?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['Boolean']['input']>;
  topic?: InputMaybe<Scalars['Boolean']['input']>;
  ukmlaTopic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Frequency = {
  __typename?: 'Frequency';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type GenerateStationInput = {
  osceTypeId: Scalars['Int']['input'];
  prompt: Scalars['String']['input'];
};

export type GenerateStationResult = {
  __typename?: 'GenerateStationResult';
  error?: Maybe<Scalars['String']['output']>;
  station?: Maybe<GeneratedStation>;
  status: EGenerateStationStatus;
};

/** Immediate response from generateStation - poll generateStationStatus with this sessionId */
export type GenerateStationSession = {
  __typename?: 'GenerateStationSession';
  sessionId: Scalars['String']['output'];
};

/** AI-generated draft station content for prefilling the create-station form; nothing is persisted */
export type GeneratedStation = {
  __typename?: 'GeneratedStation';
  actorBrief?: Maybe<Scalars['String']['output']>;
  candidateBrief?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<Scalars['Int']['output']>;
  examinerBrief?: Maybe<Scalars['String']['output']>;
  examinerQuestions?: Maybe<Array<ExaminerQuestion>>;
  explanation?: Maybe<Scalars['String']['output']>;
  marks?: Maybe<Array<GeneratedStationMark>>;
  name?: Maybe<Scalars['String']['output']>;
  osceTypeId?: Maybe<Scalars['Int']['output']>;
};

/** flat mark row, same shape as JobStationMarkInput, ready to pass straight into createStation */
export type GeneratedStationMark = {
  __typename?: 'GeneratedStationMark';
  excludeFromAi?: Maybe<Scalars['Boolean']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type GroupDiscountConfig = {
  __typename?: 'GroupDiscountConfig';
  /** Product-level switch: students can start groups for this product */
  enabled: Scalars['Boolean']['output'];
  maxMembers: Scalars['Int']['output'];
  /** Every public plan of the product; joiners can buy any of them */
  plans: Array<StudyGroupProduct>;
  /** Product type name, e.g. MRCP PACES Video Course */
  productName: Scalars['String']['output'];
  productTypeId: Scalars['Int']['output'];
  tiers: Array<GroupDiscountTier>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  windowDays: Scalars['Int']['output'];
};

export type GroupDiscountOffer = {
  __typename?: 'GroupDiscountOffer';
  maxMembers: Scalars['Int']['output'];
  maxPercent: Scalars['Int']['output'];
  /** Every public plan of the product; joiners can buy any of them */
  plans: Array<StudyGroupProduct>;
  /** Product type name, e.g. MRCP PACES Video Course */
  productName: Scalars['String']['output'];
  productTypeId: Scalars['Int']['output'];
  tiers: Array<GroupDiscountTier>;
  windowDays: Scalars['Int']['output'];
};

export type GroupDiscountTier = {
  __typename?: 'GroupDiscountTier';
  minMembers: Scalars['Int']['output'];
  percent: Scalars['Int']['output'];
};

export type GroupDiscountTierInput = {
  minMembers: Scalars['Int']['input'];
  percent: Scalars['Int']['input'];
};

export type HighlightInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['Int']['input'];
  part?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['Int']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type HighlightNode = {
  __typename?: 'HighlightNode';
  color?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Int']['output']>;
  part?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type IrtParameters = {
  __typename?: 'IRTParameters';
  difficulty: Scalars['Float']['output'];
  discrimination: Scalars['Float']['output'];
  guessing: Scalars['Float']['output'];
};

export type IrtParametersInput = {
  difficulty: Scalars['Float']['input'];
  discrimination: Scalars['Float']['input'];
  guessing: Scalars['Float']['input'];
};

export type IdDetails = {
  __typename?: 'IdDetails';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ImportResult = {
  __typename?: 'ImportResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ImportStats = {
  __typename?: 'ImportStats';
  chapterCount?: Maybe<Scalars['Int']['output']>;
  mockTestBatches?: Maybe<Scalars['Int']['output']>;
  questionCount?: Maybe<Scalars['Int']['output']>;
  stationCount?: Maybe<Scalars['Int']['output']>;
  totalBatches?: Maybe<Scalars['Int']['output']>;
};

export type Job = {
  __typename?: 'Job';
  assetCount: Scalars['Int']['output'];
  assets: Array<JobAsset>;
  chatCount: Scalars['Int']['output'];
  chats: Array<JobChat>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByUser?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['Date']['output'];
  history: Array<JobHistory>;
  id: Scalars['UUID']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<JobMember>;
  metadata: JobMetaData;
  name: Scalars['String']['output'];
  /** priority is mapped to EJobPriority */
  priority: Scalars['Int']['output'];
  /** productId is mapped to EProductType */
  productId?: Maybe<Scalars['Int']['output']>;
  publishedCount: Scalars['Int']['output'];
  recordCount: Scalars['Int']['output'];
  records: Array<JobRecord>;
  remarkCount: Scalars['Int']['output'];
  remarks: Array<JobRemark>;
  resolvedCount: Scalars['Int']['output'];
  setCount: Scalars['Int']['output'];
  /** status is mapped to EJobStatus */
  status: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
  trial: Scalars['Boolean']['output'];
  /** type is mapped to EJobType */
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type JobAsset = {
  __typename?: 'JobAsset';
  choiceLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
  jobId: Scalars['UUID']['output'];
  picture: Picture;
  pictureId: Scalars['String']['output'];
  recordId?: Maybe<Scalars['UUID']['output']>;
  type: Scalars['Int']['output'];
};

export type JobAssetInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  choiceLabel?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['FileDataInput']['input'];
  index: Scalars['Int']['input'];
  jobId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  overlay?: InputMaybe<Scalars['Boolean']['input']>;
  recordId?: InputMaybe<Scalars['ID']['input']>;
  sensitive?: InputMaybe<Scalars['Boolean']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['Int']['input'];
};

export enum JobBulkFormat {
  CSV = 'CSV',
  JSON = 'JSON'
}

export type JobChapterMeta = {
  __typename?: 'JobChapterMeta';
  entitlementIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  topicId?: Maybe<Scalars['Int']['output']>;
};

export type JobChapterMetaInput = {
  entitlementIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  topicId?: InputMaybe<Scalars['Int']['input']>;
};

export type JobChat = {
  __typename?: 'JobChat';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  jobId: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type JobChatList = {
  __typename?: 'JobChatList';
  chats: Array<JobChat>;
  date: Scalars['Date']['output'];
  total: Scalars['Int']['output'];
};

export type JobCount = {
  __typename?: 'JobCount';
  count: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
};

export type JobHistory = {
  __typename?: 'JobHistory';
  action: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobId: Scalars['UUID']['output'];
  recordId?: Maybe<Scalars['UUID']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type JobList = {
  __typename?: 'JobList';
  counts: Array<JobCount>;
  results: Array<Job>;
  total: Scalars['Int']['output'];
};

export type JobMember = {
  __typename?: 'JobMember';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  jobId: Scalars['UUID']['output'];
  role: Scalars['Int']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type JobMemberInput = {
  role: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type JobMetaData = {
  __typename?: 'JobMetaData';
  chapter?: Maybe<JobChapterMeta>;
  mockTest?: Maybe<JobMockTestMeta>;
  question?: Maybe<JobQuestionMeta>;
  station?: Maybe<JobStationMeta>;
};

export type JobMetaDataInput = {
  chapter?: InputMaybe<JobChapterMetaInput>;
  mockTest?: InputMaybe<JobMockTestMetaInput>;
  question?: InputMaybe<JobQuestionMetaInput>;
  station?: InputMaybe<JobStationMetaInput>;
};

export type JobMetricsFilterInput = {
  attemptType?: InputMaybe<Scalars['Int']['input']>;
};

export type JobMockTestMeta = {
  __typename?: 'JobMockTestMeta';
  isNew?: Maybe<Scalars['Boolean']['output']>;
  mockTestId?: Maybe<Scalars['Int']['output']>;
  passingMark?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type JobMockTestMetaInput = {
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  mockTestId?: InputMaybe<Scalars['Int']['input']>;
  passingMark?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type JobQuestionMeta = {
  __typename?: 'JobQuestionMeta';
  conceptId?: Maybe<Scalars['Int']['output']>;
  entitlementIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  topicId?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type JobQuestionMetaInput = {
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  entitlementIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  topicId?: InputMaybe<Scalars['Int']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type JobRecord = {
  __typename?: 'JobRecord';
  aiGenerated: Scalars['Boolean']['output'];
  assets: Array<JobAsset>;
  chapter?: Maybe<Chapter>;
  chapterId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByUser?: Maybe<User>;
  data?: Maybe<JobRecordData>;
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
  job: Job;
  jobId: Scalars['UUID']['output'];
  metricsSummary?: Maybe<JobRecordMetricsSummary>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['Int']['output']>;
  referenceCount?: Maybe<Scalars['Int']['output']>;
  referenceId?: Maybe<Scalars['UUID']['output']>;
  remarks: Array<JobRemark>;
  station?: Maybe<OsceStation>;
  stationId?: Maybe<Scalars['Int']['output']>;
  /** status is mapped to EJobRecordStatus */
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type JobRecordMetricsSummaryArgs = {
  filter: JobMetricsFilterInput;
};

export type JobRecordChapter = {
  __typename?: 'JobRecordChapter';
  concept?: Maybe<Scalars['String']['output']>;
  entitlementIds?: Maybe<Array<Scalars['Int']['output']>>;
  explanation?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type JobRecordChapterInput = {
  concept?: InputMaybe<Scalars['String']['input']>;
  entitlementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type JobRecordChoiceSummary = {
  __typename?: 'JobRecordChoiceSummary';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  votes?: Maybe<Scalars['Int']['output']>;
};

export type JobRecordData = JobRecordChapter | JobRecordMockTest | JobRecordQuestion | JobRecordStation;

export type JobRecordDataInput = {
  chapter?: InputMaybe<JobRecordChapterInput>;
  mockTest?: InputMaybe<JobRecordMockTestInput>;
  question?: InputMaybe<JobRecordQuestionInput>;
  station?: InputMaybe<JobRecordStationInput>;
};

export type JobRecordMetricsSummary = {
  __typename?: 'JobRecordMetricsSummary';
  avgTimeTaken?: Maybe<Scalars['Float']['output']>;
  correct?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  incorrect?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type JobRecordMockTest = {
  __typename?: 'JobRecordMockTest';
  answer?: Maybe<Scalars['JSON']['output']>;
  cases?: Maybe<Array<QuestionRecordCase>>;
  choices: Array<QuestionRecordChoice>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  irtParameters?: Maybe<IrtParameters>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  prescriptions?: Maybe<Array<PrescriptionAnswerData>>;
  question?: Maybe<Scalars['String']['output']>;
  stem?: Maybe<Scalars['String']['output']>;
  subTypeId?: Maybe<Scalars['String']['output']>;
  themeIds?: Maybe<Array<Scalars['Int']['output']>>;
  topicId?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type JobRecordMockTestInput = {
  answer?: InputMaybe<Scalars['JSON']['input']>;
  cases?: InputMaybe<Array<QuestionRecordCaseInput>>;
  choices?: InputMaybe<Array<QuestionRecordChoiceInput>>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  irtParameters?: InputMaybe<IrtParametersInput>;
  learningPoint?: InputMaybe<Scalars['String']['input']>;
  prescriptions?: InputMaybe<Array<PrescriptionAnswerInput>>;
  question?: InputMaybe<Scalars['String']['input']>;
  stem?: InputMaybe<Scalars['String']['input']>;
  subTypeId?: InputMaybe<Scalars['String']['input']>;
  themeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  topicId?: InputMaybe<Scalars['Int']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type JobRecordQuestion = {
  __typename?: 'JobRecordQuestion';
  answer?: Maybe<Scalars['JSON']['output']>;
  cases?: Maybe<Array<QuestionRecordCase>>;
  choices: Array<QuestionRecordChoice>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Scalars['Int']['output']>>;
  conditionIds?: Maybe<Array<Scalars['Int']['output']>>;
  entitlementIds?: Maybe<Array<Scalars['Int']['output']>>;
  explanation?: Maybe<Scalars['String']['output']>;
  irtParameters?: Maybe<IrtParameters>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  prescriptions?: Maybe<Array<PrescriptionAnswerData>>;
  presentationAreaIds?: Maybe<Array<Scalars['Int']['output']>>;
  presentationIds?: Maybe<Array<Scalars['Int']['output']>>;
  question?: Maybe<Scalars['String']['output']>;
  stem?: Maybe<Scalars['String']['output']>;
  subTypeId?: Maybe<Scalars['String']['output']>;
  themeIds?: Maybe<Array<Scalars['Int']['output']>>;
  topicId?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  ukmlaTopicId?: Maybe<Scalars['Int']['output']>;
};

export type JobRecordQuestionInput = {
  answer?: InputMaybe<Scalars['JSON']['input']>;
  cases?: InputMaybe<Array<QuestionRecordCaseInput>>;
  choices?: InputMaybe<Array<QuestionRecordChoiceInput>>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  conditionAreaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  entitlementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  irtParameters?: InputMaybe<IrtParametersInput>;
  learningPoint?: InputMaybe<Scalars['String']['input']>;
  prescriptions?: InputMaybe<Array<PrescriptionAnswerInput>>;
  presentationAreaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  presentationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  question?: InputMaybe<Scalars['String']['input']>;
  stem?: InputMaybe<Scalars['String']['input']>;
  subTypeId?: InputMaybe<Scalars['String']['input']>;
  themeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  topicId?: InputMaybe<Scalars['Int']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
  ukmlaTopicId?: InputMaybe<Scalars['Int']['input']>;
};

export type JobRecordStation = {
  __typename?: 'JobRecordStation';
  actorBrief?: Maybe<Scalars['String']['output']>;
  candidateBrief?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<Scalars['Int']['output']>;
  entitlementIds?: Maybe<Array<Scalars['Int']['output']>>;
  examinerBrief?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  hiddenName?: Maybe<Scalars['String']['output']>;
  llmActorBrief?: Maybe<Scalars['String']['output']>;
  marks: Array<JobStationMark>;
  name?: Maybe<Scalars['String']['output']>;
  osceTypeId?: Maybe<Scalars['Int']['output']>;
  topicIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type JobRecordStationInput = {
  actorBrief?: InputMaybe<Scalars['String']['input']>;
  aiConfig?: InputMaybe<Scalars['JSON']['input']>;
  candidateBrief?: InputMaybe<Scalars['String']['input']>;
  clinicalData?: InputMaybe<Scalars['JSON']['input']>;
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  entitlementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  examinerBrief?: InputMaybe<Scalars['String']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  hiddenName?: InputMaybe<Scalars['String']['input']>;
  llmActorBrief?: InputMaybe<Scalars['String']['input']>;
  marks: Array<JobStationMarkInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  osceTypeId?: InputMaybe<Scalars['Int']['input']>;
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JobRemark = {
  __typename?: 'JobRemark';
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['ID']['output'];
  createdByUser: User;
  id: Scalars['Int']['output'];
  jobId: Scalars['UUID']['output'];
  recordId?: Maybe<Scalars['UUID']['output']>;
  remark: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  resolvedBy?: Maybe<Scalars['ID']['output']>;
  resolvedByUser?: Maybe<User>;
  /** status is mapped to EJobRemarkStatus */
  status: Scalars['Int']['output'];
};

export type JobStationMark = {
  __typename?: 'JobStationMark';
  excludeFromAi?: Maybe<Scalars['Boolean']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type JobStationMarkInput = {
  excludeFromAi?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type JobStationMeta = {
  __typename?: 'JobStationMeta';
  entitlementIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type JobStationMetaInput = {
  entitlementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type JobsFilterInput = {
  dbType?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type LineItemInput = {
  price?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type LivekitSession = {
  __typename?: 'LivekitSession';
  roomName: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Marksheet = {
  __typename?: 'Marksheet';
  activeUsers?: Maybe<Array<Maybe<User>>>;
  agoraId?: Maybe<Scalars['String']['output']>;
  builderConfig?: Maybe<BuilderConfigData>;
  /** Every tutor thread in this quiz — one batched load for the thread switcher */
  chats: Array<TutorConversation>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  completedEntitlementIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** @deprecated This field is deprecated. Please use MarksheetStats.correct instead. */
  correct?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentMarkId?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  entitlement?: Maybe<Entitlement>;
  entitlementId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated This field is deprecated. Please use MarksheetStats.incorrect instead. */
  incorrect?: Maybe<Scalars['Int']['output']>;
  isTestMarksheet?: Maybe<Scalars['Boolean']['output']>;
  marks?: Maybe<Array<Maybe<MarksheetMark>>>;
  mockTest?: Maybe<MockTest>;
  mockTestId?: Maybe<Scalars['Int']['output']>;
  passingMark?: Maybe<Scalars['Int']['output']>;
  preBuildData?: Maybe<PreBuildMarksheet>;
  scores?: Maybe<MarksheetScores>;
  sections?: Maybe<Array<Maybe<MarksheetSection>>>;
  sessionId?: Maybe<Scalars['String']['output']>;
  solo?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  stats?: Maybe<MarksheetStats>;
  /** @deprecated This field is deprecated. Please use MarksheetStats.timeTaken instead. */
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topicConceptData?: Maybe<Scalars['String']['output']>;
  topicIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  topicNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated This field is deprecated. Please use MarksheetStats.total instead. */
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This field is deprecated. Please use Marksheet.entitlement instead. */
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type MarksheetFeedback = {
  __typename?: 'MarksheetFeedback';
  correct?: Maybe<Scalars['Int']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  marksheetId?: Maybe<Scalars['ID']['output']>;
  mockTestId?: Maybe<Scalars['Int']['output']>;
  passingMark?: Maybe<Scalars['Int']['output']>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topics?: Maybe<Array<Maybe<MarksheetTopicFeedback>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MarksheetFilterInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  solo: Scalars['Boolean']['input'];
};

export type MarksheetInfo = {
  __typename?: 'MarksheetInfo';
  action?: Maybe<Scalars['Int']['output']>;
  activeUsers?: Maybe<Array<Maybe<User>>>;
  agoraId?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  marksheetId?: Maybe<Scalars['Int']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

/** MarksheetMark is the saved user answer when answering a Question */
export type MarksheetMark = {
  __typename?: 'MarksheetMark';
  createdAt?: Maybe<Scalars['Date']['output']>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  /**
   * @deprecated(reason: "This field is deprecated. Please compute from !!mark.")
   * @deprecated This field is deprecated. Please compute from mark.
   */
  isAnswered?: Maybe<Scalars['Boolean']['output']>;
  /** tells if the question is in the user's daily stack */
  isInDailyStack?: Maybe<Scalars['Boolean']['output']>;
  mark?: Maybe<Scalars['String']['output']>;
  marksheet?: Maybe<Marksheet>;
  marksheetId?: Maybe<Scalars['Int']['output']>;
  maxScore?: Maybe<Scalars['Float']['output']>;
  question?: Maybe<Question>;
  questionChoiceId?: Maybe<Scalars['Int']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  striked?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weightedMaxScore?: Maybe<Scalars['Float']['output']>;
  weightedScore?: Maybe<Scalars['Float']['output']>;
};

export type MarksheetMarkInfo = {
  __typename?: 'MarksheetMarkInfo';
  action?: Maybe<Scalars['Int']['output']>;
  isAnswered?: Maybe<Scalars['Boolean']['output']>;
  mark?: Maybe<Scalars['String']['output']>;
  markId?: Maybe<Scalars['Int']['output']>;
  markIndex?: Maybe<Scalars['Int']['output']>;
  marksheetId?: Maybe<Scalars['Int']['output']>;
  newMarkId?: Maybe<Scalars['Int']['output']>;
  questionChoiceId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  striked?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
};

/** MarksheetOptions are options to load a user's previous Marksheets */
export type MarksheetOptions = {
  lastId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  mockTestId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  solo: Scalars['Boolean']['input'];
  updatedAfter?: InputMaybe<Scalars['Date']['input']>;
};

export type MarksheetScores = {
  __typename?: 'MarksheetScores';
  cohortSize?: Maybe<Scalars['Int']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  decile?: Maybe<Scalars['Int']['output']>;
  heuristicScore?: Maybe<Scalars['Int']['output']>;
  normalizedScore?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  /** fallback */
  rawScore?: Maybe<Scalars['Float']['output']>;
  sectionScores?: Maybe<Scalars['JSON']['output']>;
  sjtBand?: Maybe<Scalars['Int']['output']>;
  /** IRT */
  thetaScore?: Maybe<Scalars['Int']['output']>;
  /** PRIMARY */
  ucatScore?: Maybe<Scalars['Int']['output']>;
};

export type MarksheetSection = {
  __typename?: 'MarksheetSection';
  attempted?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  correct?: Maybe<Scalars['Int']['output']>;
  entitlementId?: Maybe<Scalars['Int']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  marks?: Maybe<Array<Maybe<MarksheetMark>>>;
  name?: Maybe<Scalars['String']['output']>;
  partial?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  scaledScore?: Maybe<Scalars['Int']['output']>;
  sjtBand?: Maybe<Scalars['Int']['output']>;
  timeLimitSeconds?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Marksheet is a collection of Questions */
export type MarksheetStats = {
  __typename?: 'MarksheetStats';
  attempts?: Maybe<Scalars['Int']['output']>;
  correct?: Maybe<Scalars['Int']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  maxPossibleScore?: Maybe<Scalars['Float']['output']>;
  partial?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  totalSets?: Maybe<Scalars['Int']['output']>;
};

export type MarksheetTopicFeedback = {
  __typename?: 'MarksheetTopicFeedback';
  avgScore?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  topicId?: Maybe<Scalars['ID']['output']>;
};

export type MarksheetTrackerOptions = {
  order?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  solo: Scalars['Boolean']['input'];
};

/** MarksheetWindowFilterInput are filters to load a user's previous Marksheets */
export type MarksheetWindowFilterInput = {
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  solo: Scalars['Boolean']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** MockTest is used by mock test view */
export type MockTest = {
  __typename?: 'MockTest';
  /** @deprecated This field is deprecated. Please use lastMarksheet.stats.correct instead. */
  correct?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated This field is deprecated. Please use lastMarksheet.stats.incorrect instead. */
  incorrect?: Maybe<Scalars['Int']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  lastMarksheet?: Maybe<Marksheet>;
  /** @deprecated This field is deprecated. Please use lastMarksheet.endedAt instead. */
  lastMarksheetEndedAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated This field is deprecated. Please use lastMarksheet.id instead. */
  lastMarksheetId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This field is deprecated. Please use lastMarksheet.startedAt instead. */
  lastMarksheetStartedAt?: Maybe<Scalars['Date']['output']>;
  passingMark?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is deprecated. Please use lastMarksheet.stats.totalQuestions instead. */
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This field is deprecated. Please use lastMarksheet.stats.totalSets instead. */
  totalSets?: Maybe<Scalars['Int']['output']>;
  /** typeId is based on EMockTestType */
  typeId?: Maybe<Scalars['Int']['output']>;
};

/** MockTestType is based on EMockTestType */
export type MockTestType = {
  __typename?: 'MockTestType';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MockTypeStats = {
  __typename?: 'MockTypeStats';
  completedQuestions?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partialQuestions?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

export type ModifyMarksheetInput = {
  /** Action can be any of the EMarksheetAction */
  action: Scalars['Int']['input'];
  /** current entitlement id */
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  /** marksheet id */
  marksheetId: Scalars['Int']['input'];
  preStartData?: InputMaybe<PreStartData>;
  /** to change the marksheet state */
  state?: InputMaybe<Scalars['Int']['input']>;
};

export type ModifyMarksheetMarkInput = {
  /** Action can be any of the EMarksheetAction */
  action: Scalars['Int']['input'];
  mark?: InputMaybe<Scalars['String']['input']>;
  markId: Scalars['Int']['input'];
  /** marksheet id */
  marksheetId: Scalars['Int']['input'];
  /** used specifically when changing the currentMarkId in marksheet */
  newMarkId?: InputMaybe<Scalars['Int']['input']>;
  questionChoiceId?: InputMaybe<Scalars['Int']['input']>;
  striked?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeTaken?: InputMaybe<Scalars['Int']['input']>;
};

export type ModifyOsceMarksheetInput = {
  /** Action can be any of the EOsceMarksheetAction */
  action: Scalars['Int']['input'];
  /** osceMarksheetId id */
  osceMarksheetId: Scalars['Int']['input'];
  /** Phase can be any of the EOsceStationPhase */
  phase?: InputMaybe<OsceStationPhase>;
  /** to change the marksheet state */
  state?: InputMaybe<Scalars['Int']['input']>;
};

/** Unrestricted mutations */
export type Mutation = {
  __typename?: 'Mutation';
  admin?: Maybe<AdminMutation>;
  customerPortal?: Maybe<Scalars['String']['output']>;
  loginAdmin?: Maybe<Scalars['String']['output']>;
  /** University-panel login (university admins only; they cannot use any other login). days is capped at 7. */
  loginUniversityAdmin?: Maybe<Scalars['String']['output']>;
  loginUser?: Maybe<Scalars['String']['output']>;
  /** Exchange the one-time code from the Entra SSO callback (/api/auth/sso/callback) for a JWT. Mobile (platform=mobile) must send the PKCE codeVerifier. */
  loginWithSso?: Maybe<Scalars['String']['output']>;
  registerAdmin?: Maybe<Scalars['Boolean']['output']>;
  registerUser?: Maybe<Scalars['String']['output']>;
  resetPassword?: Maybe<Scalars['String']['output']>;
  /** Emails a reset link — to the university panel for university admins, the student app otherwise */
  resetPasswordPrep?: Maybe<Scalars['String']['output']>;
  restricted?: Maybe<RestrictedMutation>;
  /** Persists a single answer for an in-progress sample quiz attempt, keyed by refId */
  saveSampleQuizMark: SampleQuizMark;
  stripeHomepageCheckoutSession?: Maybe<Scalars['String']['output']>;
  submitSampleQuizReport: Scalars['String']['output'];
  validUserToken?: Maybe<ValidUserToken>;
};


/** Unrestricted mutations */
export type MutationCustomerPortalArgs = {
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


/** Unrestricted mutations */
export type MutationLoginAdminArgs = {
  days: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** Unrestricted mutations */
export type MutationLoginUniversityAdminArgs = {
  days: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** Unrestricted mutations */
export type MutationLoginUserArgs = {
  days: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** Unrestricted mutations */
export type MutationLoginWithSsoArgs = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  days: Scalars['Int']['input'];
};


/** Unrestricted mutations */
export type MutationRegisterAdminArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** Unrestricted mutations */
export type MutationRegisterUserArgs = {
  userData: RegisterUser;
};


/** Unrestricted mutations */
export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Unrestricted mutations */
export type MutationResetPasswordPrepArgs = {
  username: Scalars['String']['input'];
};


/** Unrestricted mutations */
export type MutationSaveSampleQuizMarkArgs = {
  mark: SampleQuizMarkInput;
  marksheetId: Scalars['Int']['input'];
  refId: Scalars['UUID']['input'];
};


/** Unrestricted mutations */
export type MutationStripeHomepageCheckoutSessionArgs = {
  lineItems: Array<LineItemInput>;
};


/** Unrestricted mutations */
export type MutationSubmitSampleQuizReportArgs = {
  input: SubmitSampleQuizReportInput;
};

export type MuxAsset = {
  __typename?: 'MuxAsset';
  id?: Maybe<Scalars['String']['output']>;
  master_access?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Notifications of the Application */
export type Notification = {
  __typename?: 'Notification';
  /** Denoted what type of action this notification is originated from eg LIKE,DISLIKE */
  actionType?: Maybe<NotificationActionType>;
  /** Notification linked with which comment, so that we can fetch comment message */
  comment?: Maybe<QuestionComment>;
  commentId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** Description or message for this notification */
  description?: Maybe<Scalars['String']['output']>;
  /** id of user that this notification come from or originated from */
  fromUser?: Maybe<User>;
  /** Notification linked with which comment, so that we can fetch comment message */
  fromUserComment?: Maybe<QuestionComment>;
  fromUserCommentId?: Maybe<Scalars['Int']['output']>;
  fromUserId?: Maybe<Scalars['Int']['output']>;
  /** Flag that tells this notification is global/visible to everyone */
  global?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Flag that Tells that this notification is being read/seen by user */
  read?: Maybe<Scalars['Boolean']['output']>;
  /** Denoted the type of this notification */
  type?: Maybe<NotificationType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** id of user that this notification belong to */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum NotificationActionType {
  ACCEPTED = 'ACCEPTED',
  DISLIKE = 'DISLIKE',
  /** ANNOUNCEMENT */
  FEATURE = 'FEATURE',
  INFORMATION = 'INFORMATION',
  LIKE = 'LIKE',
  /** COMMENT */
  REPLY = 'REPLY',
  /** FRIEND_REQUEST */
  REQUESTED = 'REQUESTED'
}

/** NotificationFilterInput are filters to load a user's notifications */
export type NotificationFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum NotificationType {
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  COMMENT = 'COMMENT',
  FRIEND_REQUEST = 'FRIEND_REQUEST'
}

export type OsceAiCorrectionsDataPoint = {
  __typename?: 'OsceAiCorrectionsDataPoint';
  date: Scalars['String']['output'];
  marksAdded: Scalars['Int']['output'];
  marksRemoved: Scalars['Int']['output'];
  verdictCorrections: Scalars['Int']['output'];
};

export type OsceAiCorrectionsKpi = {
  __typename?: 'OsceAiCorrectionsKpi';
  additionRate: Scalars['Float']['output'];
  correctionRate: Scalars['Float']['output'];
  deletionRate: Scalars['Float']['output'];
  marksAdded: Scalars['Int']['output'];
  marksRemoved: Scalars['Int']['output'];
  totalMarks: Scalars['Int']['output'];
  verdictCorrections: Scalars['Int']['output'];
};

export type OsceAiCorrectionsOverTime = {
  __typename?: 'OsceAiCorrectionsOverTime';
  kpi: OsceAiCorrectionsKpi;
  series: Array<OsceAiCorrectionsDataPoint>;
};

export type OsceAiCostDataPoint = {
  __typename?: 'OsceAiCostDataPoint';
  date: Scalars['String']['output'];
  llmCachedTokens: Scalars['Float']['output'];
  llmCost: Scalars['Float']['output'];
  llmInputTokens: Scalars['Float']['output'];
  llmOutputTokens: Scalars['Float']['output'];
  llmReasoningTokens: Scalars['Float']['output'];
  sttAudioSeconds: Scalars['Float']['output'];
  sttCost: Scalars['Float']['output'];
  ttsAudioSeconds: Scalars['Float']['output'];
  ttsChars: Scalars['Float']['output'];
  ttsCost: Scalars['Float']['output'];
};

export type OsceAiCostKpi = {
  __typename?: 'OsceAiCostKpi';
  llmCachedTokens: Scalars['Float']['output'];
  llmInputTokens: Scalars['Float']['output'];
  llmOutputTokens: Scalars['Float']['output'];
  llmReasoningTokens: Scalars['Float']['output'];
  llmTotal: Scalars['Float']['output'];
  sttAudioSeconds: Scalars['Float']['output'];
  sttTotal: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  ttsAudioSeconds: Scalars['Float']['output'];
  ttsChars: Scalars['Float']['output'];
  ttsTotal: Scalars['Float']['output'];
};

export type OsceAiCostOverTime = {
  __typename?: 'OsceAiCostOverTime';
  kpi: OsceAiCostKpi;
  series: Array<OsceAiCostDataPoint>;
};

export type OsceAiKpiOverview = {
  __typename?: 'OsceAiKpiOverview';
  avgSessionMinutes: Scalars['Float']['output'];
  chatSessions: Scalars['Int']['output'];
  costPerSession: Scalars['Float']['output'];
  e2eAvgLatencyMs: Scalars['Float']['output'];
  e2eAvgTftMs: Scalars['Float']['output'];
  endOfTurnDelay: Scalars['Float']['output'];
  groupStudySessions: Scalars['Int']['output'];
  interruptionCount: Scalars['Int']['output'];
  llmAvgLatencyMs: Scalars['Float']['output'];
  llmCachedTokens: Scalars['Float']['output'];
  llmCost: Scalars['Float']['output'];
  llmInputTokens: Scalars['Float']['output'];
  llmOutputTokens: Scalars['Float']['output'];
  llmReasoningTokens: Scalars['Float']['output'];
  llmTimeoutCount: Scalars['Int']['output'];
  markschemeLatencyMs: Scalars['Float']['output'];
  resultLatencyMs: Scalars['Float']['output'];
  standardSessions: Scalars['Int']['output'];
  sttAudioSeconds: Scalars['Float']['output'];
  sttAvgLatencyMs: Scalars['Float']['output'];
  sttCost: Scalars['Float']['output'];
  sttTimeoutCount: Scalars['Int']['output'];
  timeoutDistinctQuizCount: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
  totalSessionMinutes: Scalars['Float']['output'];
  totalSessions: Scalars['Int']['output'];
  transcriptConfidence: Scalars['Float']['output'];
  ttsAudioSeconds: Scalars['Float']['output'];
  ttsAvgLatencyMs: Scalars['Float']['output'];
  ttsChars: Scalars['Float']['output'];
  ttsCost: Scalars['Float']['output'];
  ttsTimeoutCount: Scalars['Int']['output'];
  uniqueStations: Scalars['Int']['output'];
  uniqueUsers: Scalars['Int']['output'];
  voiceSessions: Scalars['Int']['output'];
};

export type OsceAiLatencyOverTime = {
  __typename?: 'OsceAiLatencyOverTime';
  kpi: OsceAiTimingKpi;
  percentiles: Array<OsceAiLatencyPercentilePoint>;
  series: Array<OsceAiLatencySeriesPoint>;
};

export type OsceAiLatencyPercentilePoint = {
  __typename?: 'OsceAiLatencyPercentilePoint';
  date: Scalars['String']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
  p99: Scalars['Float']['output'];
};

export type OsceAiLatencySeriesPoint = {
  __typename?: 'OsceAiLatencySeriesPoint';
  date: Scalars['String']['output'];
  e2eLatency: Scalars['Float']['output'];
  e2eTft: Scalars['Float']['output'];
  endOfTurnDelay: Scalars['Float']['output'];
  llmInference: Scalars['Float']['output'];
  llmTft: Scalars['Float']['output'];
  llmTtfs: Scalars['Float']['output'];
  markschemeLatencyMs: Scalars['Float']['output'];
  resultLatencyMs: Scalars['Float']['output'];
  sttInference: Scalars['Float']['output'];
  ttsInference: Scalars['Float']['output'];
  ttsTfb: Scalars['Float']['output'];
};

export type OsceAiRecentSession = {
  __typename?: 'OsceAiRecentSession';
  corrected: Scalars['Boolean']['output'];
  e2eLatency: Scalars['Float']['output'];
  e2eTft: Scalars['Float']['output'];
  endOfTurnDelay: Scalars['Float']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  globalScore?: Maybe<Scalars['Int']['output']>;
  hasTimeout?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  markschemeLatencyMs: Scalars['Float']['output'];
  mode: OsceAiSessionMode;
  resultLatencyMs: Scalars['Float']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  startedAt: Scalars['Float']['output'];
  stationId: Scalars['String']['output'];
  stationName: Scalars['String']['output'];
  timeTaken?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OsceAiRecentSessionsResult = {
  __typename?: 'OsceAiRecentSessionsResult';
  items: Array<OsceAiRecentSession>;
  total: Scalars['Int']['output'];
};

export enum OsceAiSessionMode {
  CHAT = 'CHAT',
  STANDARD = 'STANDARD',
  VOICE = 'VOICE'
}

export type OsceAiSessionsByOsceType = {
  __typename?: 'OsceAiSessionsByOsceType';
  chat: Scalars['Int']['output'];
  groupStudy: Scalars['Int']['output'];
  osceTypeId: Scalars['Int']['output'];
  osceTypeName: Scalars['String']['output'];
  standard: Scalars['Int']['output'];
  voice: Scalars['Int']['output'];
};

export type OsceAiSessionsByStation = {
  __typename?: 'OsceAiSessionsByStation';
  chat: Scalars['Int']['output'];
  groupStudy: Scalars['Int']['output'];
  standard: Scalars['Int']['output'];
  stationId: Scalars['Int']['output'];
  stationName: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  voice: Scalars['Int']['output'];
};

export type OsceAiSessionsDataPoint = {
  __typename?: 'OsceAiSessionsDataPoint';
  chat: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  groupStudy: Scalars['Int']['output'];
  standard: Scalars['Int']['output'];
  voice: Scalars['Int']['output'];
};

export type OsceAiSessionsKpi = {
  __typename?: 'OsceAiSessionsKpi';
  chat: Scalars['Int']['output'];
  groupStudy: Scalars['Int']['output'];
  standard: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  voice: Scalars['Int']['output'];
};

export type OsceAiSessionsOverTime = {
  __typename?: 'OsceAiSessionsOverTime';
  byOsceType: Array<OsceAiSessionsByOsceType>;
  kpi: OsceAiSessionsKpi;
  series: Array<OsceAiSessionsDataPoint>;
};

export enum OsceAiStatsPhase {
  examination = 'examination',
  examiner = 'examiner',
  generation = 'generation',
  markscheme = 'markscheme',
  patient = 'patient',
  result = 'result'
}

export type OsceAiTimeoutsDataPoint = {
  __typename?: 'OsceAiTimeoutsDataPoint';
  date: Scalars['String']['output'];
  llmTimeoutCount: Scalars['Int']['output'];
  sttTimeoutCount: Scalars['Int']['output'];
  timeoutDistinctQuizCount: Scalars['Int']['output'];
  totalTimeoutCount: Scalars['Int']['output'];
  ttsTimeoutCount: Scalars['Int']['output'];
};

export type OsceAiTimeoutsKpi = {
  __typename?: 'OsceAiTimeoutsKpi';
  llmTimeoutCount: Scalars['Int']['output'];
  sttTimeoutCount: Scalars['Int']['output'];
  timeoutDistinctQuizCount: Scalars['Int']['output'];
  totalTimeoutCount: Scalars['Int']['output'];
  ttsTimeoutCount: Scalars['Int']['output'];
};

export type OsceAiTimeoutsOverTime = {
  __typename?: 'OsceAiTimeoutsOverTime';
  kpi: OsceAiTimeoutsKpi;
  series: Array<OsceAiTimeoutsDataPoint>;
};

export type OsceAiTimingKpi = {
  __typename?: 'OsceAiTimingKpi';
  e2eLatency: Scalars['Float']['output'];
  e2eTft: Scalars['Float']['output'];
  endOfTurnDelay: Scalars['Float']['output'];
  llmInference: Scalars['Float']['output'];
  llmTft: Scalars['Float']['output'];
  llmTtfs: Scalars['Float']['output'];
  markschemeLatencyMs: Scalars['Float']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
  p99: Scalars['Float']['output'];
  resultLatencyMs: Scalars['Float']['output'];
  sttInference: Scalars['Float']['output'];
  ttsInference: Scalars['Float']['output'];
  ttsTfb: Scalars['Float']['output'];
};

export type OsceAiTokenByPhase = {
  __typename?: 'OsceAiTokenByPhase';
  cachedTokens: Scalars['Float']['output'];
  inputTokens: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
  phase: OsceAiStatsPhase;
};

/** Token chunk while streaming station chat */
export type OsceChatStreamChunk = {
  __typename?: 'OsceChatStreamChunk';
  done: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  /** Full message; populated when done is true */
  message?: Maybe<Scalars['String']['output']>;
  osceMarksheetId: Scalars['Int']['output'];
  phase: OsceStationPhase;
  token?: Maybe<Scalars['String']['output']>;
};

/** OsceDashboard used for dashboard screen */
export type OsceDashboard = {
  __typename?: 'OsceDashboard';
  avgScore?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  lastSessionId?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  types?: Maybe<Array<Maybe<OsceType>>>;
};

/** OsceGroup subscription response for group roles */
export type OsceGroup = {
  __typename?: 'OsceGroup';
  /** members will always return an array of the 4 roles in the OSCE station */
  members?: Maybe<Array<Maybe<OsceMarksheetUser>>>;
  osceMarksheetId?: Maybe<Scalars['Int']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

/** Marksheet for user scores in OSCE */
export type OsceMarksheet = {
  __typename?: 'OsceMarksheet';
  activeUsers?: Maybe<Array<Maybe<User>>>;
  /** uuid4 for grouping marksheets of multiple users for group study and the channel for voice/video */
  agoraId?: Maybe<Scalars['String']['output']>;
  /** the circuit session this marksheet belongs to, if it was built as part of a circuit */
  circuitSession?: Maybe<CircuitSession>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** correct marks in station */
  correct?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  entitlement?: Maybe<Entitlement>;
  entitlementId?: Maybe<Scalars['Int']['output']>;
  /** written feedback from examiner */
  feedback?: Maybe<Scalars['String']['output']>;
  feedbackReaction?: Maybe<OsceMarksheetFeedbackReaction>;
  feedbackTime?: Maybe<Scalars['Int']['output']>;
  /** global score 0-4 */
  globalScore?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** tells if marksheet is time constraint or not */
  isTimed?: Maybe<Scalars['Boolean']['output']>;
  livekitSessionId?: Maybe<Scalars['String']['output']>;
  marks?: Maybe<Array<Maybe<OsceMarksheetMark>>>;
  /** members will always return an array of the 4 roles in the OSCE station */
  members?: Maybe<Array<Maybe<OsceMarksheetUser>>>;
  messages?: Maybe<Array<Maybe<OsceMarksheetMessage>>>;
  mode?: Maybe<OsceMarksheetMode>;
  osceStation?: Maybe<OsceStation>;
  osceStationId?: Maybe<Scalars['Int']['output']>;
  pausedAt?: Maybe<Scalars['Date']['output']>;
  phase?: Maybe<OsceStationPhase>;
  productId?: Maybe<Scalars['Int']['output']>;
  readingTime?: Maybe<Scalars['Int']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  /** overall percentage for the station */
  score?: Maybe<Scalars['Float']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  solo?: Maybe<Scalars['Boolean']['output']>;
  /** stage will return EOsceStage READING | STATION | FEEDBACK */
  stage?: Maybe<Scalars['Int']['output']>;
  stageTime?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  /** state will return EOsceStationState LOBBY | STATION_BUILDER | PRESTART | STATION | RESULT */
  state?: Maybe<Scalars['Int']['output']>;
  stationTime?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<OsceMarksheetSummary>;
  timeRemaining?: Maybe<Scalars['String']['output']>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  /** total marks in station */
  total?: Maybe<Scalars['Int']['output']>;
  totalStationTime?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type OsceMarksheetAction = {
  __typename?: 'OsceMarksheetAction';
  action?: Maybe<Scalars['Int']['output']>;
  activeUsers?: Maybe<Array<Maybe<User>>>;
  agoraId?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  globalScore?: Maybe<Scalars['Int']['output']>;
  marks?: Maybe<Array<Maybe<OsceMarksheetMark>>>;
  members?: Maybe<Array<Maybe<OsceMarksheetUser>>>;
  osceMarksheetId?: Maybe<Scalars['Int']['output']>;
  osceStationId?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type OsceMarksheetFeedbackReaction = {
  __typename?: 'OsceMarksheetFeedbackReaction';
  feedback?: Maybe<Scalars['String']['output']>;
  reaction?: Maybe<Scalars['Int']['output']>;
};

export type OsceMarksheetHeaderFeedback = {
  __typename?: 'OsceMarksheetHeaderFeedback';
  header?: Maybe<Scalars['String']['output']>;
  improvements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  strengths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summary?: Maybe<Scalars['String']['output']>;
};

/**
 * MarksheetMarks are only saved on the original role=actor OsceMarksheet,
 * however these are loaded from all other marksheets when requested
 */
export type OsceMarksheetMark = {
  __typename?: 'OsceMarksheetMark';
  comment1?: Maybe<Scalars['String']['output']>;
  comment2?: Maybe<Scalars['String']['output']>;
  corrected?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  mark?: Maybe<Scalars['Int']['output']>;
  osceMarksheetId?: Maybe<Scalars['Int']['output']>;
  osceStationMark?: Maybe<OsceStationMark>;
  osceStationMarkId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  secondaryMark?: Maybe<Scalars['Int']['output']>;
  selectedChoice?: Maybe<Scalars['Int']['output']>;
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type OsceMarksheetMessage = {
  __typename?: 'OsceMarksheetMessage';
  chat_message?: Maybe<Scalars['JSON']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  phase?: Maybe<OsceStationPhase>;
  phaseType?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum OsceMarksheetMode {
  CHAT = 'CHAT',
  STANDARD = 'STANDARD',
  VOICE = 'VOICE'
}

export type OsceMarksheetOptions = {
  lastId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  solo: Scalars['Boolean']['input'];
};

export type OsceMarksheetStat = {
  __typename?: 'OsceMarksheetStat';
  additionRate: Scalars['Float']['output'];
  audioUrl?: Maybe<Scalars['String']['output']>;
  correctionRate: Scalars['Float']['output'];
  deletionRate: Scalars['Float']['output'];
  e2eLatency: Scalars['Float']['output'];
  e2eTft: Scalars['Float']['output'];
  endOfTurnDelay?: Maybe<Scalars['Float']['output']>;
  interruptionCount?: Maybe<Scalars['Int']['output']>;
  llmCachedTokens: Scalars['Float']['output'];
  llmCost: Scalars['Float']['output'];
  llmInference: Scalars['Float']['output'];
  llmInputTokens: Scalars['Float']['output'];
  llmOutputTokens: Scalars['Float']['output'];
  llmTft: Scalars['Float']['output'];
  llmTimeoutCount?: Maybe<Scalars['Int']['output']>;
  llmTtfs: Scalars['Float']['output'];
  marksAdded: Scalars['Int']['output'];
  marksRemoved: Scalars['Int']['output'];
  markschemeLatencyMs: Scalars['Float']['output'];
  resultLatencyMs: Scalars['Float']['output'];
  sttAudioSeconds?: Maybe<Scalars['Float']['output']>;
  sttCost?: Maybe<Scalars['Float']['output']>;
  sttInference?: Maybe<Scalars['Float']['output']>;
  sttTimeoutCount?: Maybe<Scalars['Int']['output']>;
  totalMarks: Scalars['Int']['output'];
  transcriptConfidence?: Maybe<Scalars['Float']['output']>;
  ttsAudioSeconds?: Maybe<Scalars['Float']['output']>;
  ttsChars?: Maybe<Scalars['Float']['output']>;
  ttsCost?: Maybe<Scalars['Float']['output']>;
  ttsInference?: Maybe<Scalars['Float']['output']>;
  ttsTfb?: Maybe<Scalars['Float']['output']>;
  ttsTimeoutCount?: Maybe<Scalars['Int']['output']>;
  turnLatency: Array<OsceMarksheetTurnLatency>;
};

export type OsceMarksheetSummary = {
  __typename?: 'OsceMarksheetSummary';
  commentary?: Maybe<Scalars['String']['output']>;
  examinerFeedback?: Maybe<Scalars['String']['output']>;
  headerFeedback?: Maybe<Array<Maybe<OsceMarksheetHeaderFeedback>>>;
  improvements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overallSummary?: Maybe<Scalars['String']['output']>;
  strengths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OsceMarksheetTurnLatency = {
  __typename?: 'OsceMarksheetTurnLatency';
  e2eLatency: Scalars['Float']['output'];
  endOfTurnDelay: Scalars['Float']['output'];
  llmTft: Scalars['Float']['output'];
  llmTtfs: Scalars['Float']['output'];
  sttInference: Scalars['Float']['output'];
  ttsTfb: Scalars['Float']['output'];
  turn: Scalars['Int']['output'];
};

export type OsceMarksheetUser = {
  __typename?: 'OsceMarksheetUser';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  osceMarksheetId?: Maybe<Scalars['Int']['output']>;
  /** candidate = 0, actor = 1, examiner = 2, observer = 3 */
  role?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** OsceMarksheetWindowFilterInput are filters to load a user's previous OsceMarksheets */
export type OsceMarksheetWindowFilterInput = {
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  solo: Scalars['Boolean']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type OsceMarksheetsList = {
  __typename?: 'OsceMarksheetsList';
  results?: Maybe<Array<Maybe<OsceMarksheet>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OsceMatchmakingAction = {
  __typename?: 'OsceMatchmakingAction';
  classYear?: Maybe<Scalars['String']['output']>;
  classYearGroup?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  grouped?: Maybe<Scalars['Boolean']['output']>;
  lastSyncAt?: Maybe<Scalars['Int']['output']>;
  matchedUsers?: Maybe<Scalars['Int']['output']>;
  osceMarksheetId?: Maybe<Scalars['Int']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OsceStation = {
  __typename?: 'OsceStation';
  actorBrief?: Maybe<Scalars['String']['output']>;
  actorPictures?: Maybe<Array<Maybe<Picture>>>;
  aiConfig?: Maybe<Scalars['JSON']['output']>;
  aiEnabled?: Maybe<Scalars['Boolean']['output']>;
  avgScore?: Maybe<Scalars['Float']['output']>;
  candidateBrief?: Maybe<Scalars['String']['output']>;
  candidatePictures?: Maybe<Array<Maybe<Picture>>>;
  clinicalData?: Maybe<Scalars['JSON']['output']>;
  clinicalPictures?: Maybe<Array<Maybe<Picture>>>;
  completedMarks?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlement?: Maybe<Entitlement>;
  entitlements?: Maybe<Array<Entitlement>>;
  examinerBrief?: Maybe<Scalars['String']['output']>;
  examinerPictures?: Maybe<Array<Maybe<Picture>>>;
  examinerQuestions?: Maybe<Array<ExaminerQuestion>>;
  /** Walkthrough explanation for the station */
  explanation?: Maybe<Scalars['String']['output']>;
  hiddenName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastOsceMarksheet?: Maybe<OsceMarksheet>;
  /** @deprecated Use lastOsceMarksheet instead */
  lastOsceMarksheetId?: Maybe<Scalars['Int']['output']>;
  llmActorBrief?: Maybe<Scalars['String']['output']>;
  /** Checklist of marks */
  marks?: Maybe<Array<Maybe<OsceStationMark>>>;
  name?: Maybe<Scalars['String']['output']>;
  osceType?: Maybe<OsceType>;
  osceTypeId?: Maybe<Scalars['Int']['output']>;
  phaseTimers?: Maybe<Scalars['JSON']['output']>;
  picture?: Maybe<Picture>;
  pictureId?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  preDefined?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use lastOsceMarksheet.score instead */
  score?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  topics?: Maybe<Array<Maybe<Topic>>>;
  totalMarks?: Maybe<Scalars['Int']['output']>;
  totalVideos?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userNote?: Maybe<UserStationNote>;
  videos?: Maybe<Array<Maybe<Video>>>;
  visibility?: Maybe<Scalars['Int']['output']>;
  walkthroughPictures?: Maybe<Array<Maybe<Picture>>>;
};


export type OsceStationAvgScoreArgs = {
  solo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OsceStationLastOsceMarksheetArgs = {
  solo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** checklist item for station */
export type OsceStationMark = {
  __typename?: 'OsceStationMark';
  choices?: Maybe<Array<Maybe<StationMarkChoice>>>;
  excludeFromAi?: Maybe<Scalars['Boolean']['output']>;
  /** header groups multiple marks together */
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  osceStationId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export enum OsceStationPhase {
  EXAMINATION = 'EXAMINATION',
  EXAMINER = 'EXAMINER',
  PATIENT = 'PATIENT'
}

export type OsceStats = {
  __typename?: 'OsceStats';
  avgScore?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  markschemeLatencyMs?: Maybe<Scalars['Float']['output']>;
  resultLatencyMs?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  types?: Maybe<Array<Maybe<OsceTypes>>>;
};

export type OsceTimer = {
  __typename?: 'OsceTimer';
  osceMarksheetId?: Maybe<Scalars['Int']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  /** stage will return EOsceStage */
  stage?: Maybe<Scalars['Int']['output']>;
  /** state will return EOsceTimerState */
  state?: Maybe<Scalars['Int']['output']>;
  timeRemaining?: Maybe<Scalars['String']['output']>;
  totalStationTime?: Maybe<Scalars['String']['output']>;
};

/** OsceType is the equivalent of Topics for OSCEs */
export type OsceType = {
  __typename?: 'OsceType';
  avgScore?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};


/** OsceType is the equivalent of Topics for OSCEs */
export type OsceTypeAvgScoreArgs = {
  solo: Scalars['Boolean']['input'];
};


/** OsceType is the equivalent of Topics for OSCEs */
export type OsceTypeCompletedArgs = {
  solo: Scalars['Boolean']['input'];
};

export type OsceTypes = {
  __typename?: 'OsceTypes';
  avgScore?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OverwriteInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['Boolean']['input']>;
  resetLikes?: InputMaybe<Scalars['Boolean']['input']>;
  resetProgress?: InputMaybe<Scalars['Boolean']['input']>;
  resetVotes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaginatedMarksheet = {
  __typename?: 'PaginatedMarksheet';
  results?: Maybe<Array<Maybe<Marksheet>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedOsceMarksheet = {
  __typename?: 'PaginatedOsceMarksheet';
  results?: Maybe<Array<Maybe<DateResultOsceMarksheetPair>>>;
  score?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedUserFlaggedQuestion = {
  __typename?: 'PaginatedUserFlaggedQuestion';
  results?: Maybe<Array<Maybe<UserFlaggedQuestion>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedWindowMarksheet = {
  __typename?: 'PaginatedWindowMarksheet';
  results?: Maybe<Array<Maybe<DateResultMarksheetPair>>>;
  score?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Picture include the URL lookup for their content */
export type Picture = {
  __typename?: 'Picture';
  caption?: Maybe<Scalars['String']['output']>;
  choiceId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** path provides a overlay URL path for the picture */
  overlayPath?: Maybe<Scalars['String']['output']>;
  /** 256 x 256px size */
  overlayPath256?: Maybe<Scalars['String']['output']>;
  /** 512 x 512px size */
  overlayPath512?: Maybe<Scalars['String']['output']>;
  /** path provides a URL path for the picture */
  path?: Maybe<Scalars['String']['output']>;
  /** 256 x 256px size */
  path256?: Maybe<Scalars['String']['output']>;
  /** 512 x 512px size */
  path512?: Maybe<Scalars['String']['output']>;
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  /** thumbhash representation */
  thumbhash?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Topic>;
  topicId?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** PreBuildMarksheet is used to provide user specific stats on a collection of Questions */
export type PreBuildMarksheet = {
  __typename?: 'PreBuildMarksheet';
  buildRef?: Maybe<Scalars['Int']['output']>;
  seenCorrect?: Maybe<Scalars['Int']['output']>;
  seenIncorrect?: Maybe<Scalars['Int']['output']>;
  unseen?: Maybe<Scalars['Int']['output']>;
};

/** PreBuildTodo is used to provide user specific stats on a collection of Cards */
export type PreBuildTodo = {
  __typename?: 'PreBuildTodo';
  buildRef?: Maybe<Scalars['Int']['output']>;
  seen?: Maybe<Scalars['Int']['output']>;
  unseen?: Maybe<Scalars['Int']['output']>;
};

export type PreStartData = {
  /** to select the configuration to build the marksheet in Builder step */
  builderConfig?: InputMaybe<BuilderConfig>;
  /** topic concept selection data in lobby */
  topicConceptData?: InputMaybe<Scalars['String']['input']>;
};

export type PreStartMarksheetInfo = {
  __typename?: 'PreStartMarksheetInfo';
  action?: Maybe<Scalars['Int']['output']>;
  builderConfig?: Maybe<BuilderConfigData>;
  marksheetId: Scalars['Int']['output'];
  preBuildData?: Maybe<PreBuildMarksheet>;
  sessionId?: Maybe<Scalars['String']['output']>;
  topicConceptData?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type PrescribeAnswerData = {
  __typename?: 'PrescribeAnswerData';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type PrescriptionAnswer = {
  __typename?: 'PrescriptionAnswer';
  dose?: Maybe<PrescribeAnswerData>;
  drug?: Maybe<PrescribeAnswerData>;
  duration?: Maybe<PrescribeAnswerData>;
  frequency?: Maybe<PrescribeAnswerData>;
  route?: Maybe<PrescribeAnswerData>;
};

export type PrescriptionAnswerData = {
  __typename?: 'PrescriptionAnswerData';
  doseId?: Maybe<Scalars['Int']['output']>;
  doseVisible?: Maybe<Scalars['Boolean']['output']>;
  drugId?: Maybe<Scalars['Int']['output']>;
  drugVisible?: Maybe<Scalars['Boolean']['output']>;
  durationId?: Maybe<Scalars['Int']['output']>;
  durationVisible?: Maybe<Scalars['Boolean']['output']>;
  frequencyId?: Maybe<Scalars['Int']['output']>;
  frequencyVisible?: Maybe<Scalars['Boolean']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  routeId?: Maybe<Scalars['Int']['output']>;
  routeVisible?: Maybe<Scalars['Boolean']['output']>;
};

export type PrescriptionAnswerInput = {
  doseId?: InputMaybe<Scalars['Int']['input']>;
  doseVisible?: InputMaybe<Scalars['Boolean']['input']>;
  drugId?: InputMaybe<Scalars['Int']['input']>;
  drugVisible?: InputMaybe<Scalars['Boolean']['input']>;
  durationId?: InputMaybe<Scalars['Int']['input']>;
  durationVisible?: InputMaybe<Scalars['Boolean']['input']>;
  frequencyId?: InputMaybe<Scalars['Int']['input']>;
  frequencyVisible?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  routeVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrescriptionResult = {
  __typename?: 'PrescriptionResult';
  result?: Maybe<Array<Maybe<PrescriptionType>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PrescriptionType = Dose | Drug | Duration | Frequency | Route;

export type Presentation = {
  __typename?: 'Presentation';
  /** 0=unchanged, 1=renamed, 2=new. */
  changeType?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /**
   * specify if presentation available for demo mode
   * @deprecated Legacy UKMLA content map. Not set on UKMLA 2026 rows
   */
  demo?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  /** Legacy names that differ from this row's name. */
  legacyNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  questionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** @deprecated Legacy UKMLA content map. Not set on UKMLA 2026 rows */
  topic?: Maybe<UkmlaTopic>;
  /** @deprecated Legacy UKMLA content map. Not set on UKMLA 2026 rows */
  topicId?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Preset = {
  __typename?: 'Preset';
  completedCards?: Maybe<Scalars['Int']['output']>;
  completedQuestions?: Maybe<Scalars['Int']['output']>;
  concepts?: Maybe<Array<Maybe<Concept>>>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** entitlementId is based on EProductType */
  entitlement?: Maybe<Entitlement>;
  entitlementId?: Maybe<Scalars['Int']['output']>;
  greenCards?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redCards?: Maybe<Scalars['Int']['output']>;
  totalCards?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  yellowCards?: Maybe<Scalars['Int']['output']>;
};

export type ProductFeedback = {
  __typename?: 'ProductFeedback';
  createdAt?: Maybe<Scalars['Date']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Entitlement>;
  productId?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ProductStats = {
  __typename?: 'ProductStats';
  completedQuestions?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  dailyFeedCards?: Maybe<Scalars['Int']['output']>;
  greenCards?: Maybe<Scalars['Int']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  mockQuestions?: Maybe<Scalars['Int']['output']>;
  mockTypes?: Maybe<Array<Maybe<MockTypeStats>>>;
  redCards?: Maybe<Scalars['Int']['output']>;
  totalCards?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  types?: Maybe<Array<Maybe<EntitlementType>>>;
  userId?: Maybe<Scalars['ID']['output']>;
  yellowCards?: Maybe<Scalars['Int']['output']>;
};

export type ProductSubscription = {
  __typename?: 'ProductSubscription';
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** duration is the count of the interval for the subscription */
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** interval is the interval of the subscription (month, year, etc.) */
  interval?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  /** tells if subscription is renewable or not */
  subscription?: Maybe<Scalars['Boolean']['output']>;
  /** typeId is mapped to EProductType */
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type ProductTransactionInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  subBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Prompt = {
  __typename?: 'Prompt';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByUser?: Maybe<User>;
  format: PromptFormat;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  /** Mapped by admin UI (e.g. patient, examiner, markscheme) */
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
  versions: Array<PromptVersion>;
};

/** How `text` is interpreted: plain prompt text, or a JSON document */
export enum PromptFormat {
  json = 'json',
  text = 'text'
}

export type PromptLabMessage = {
  __typename?: 'PromptLabMessage';
  content?: Maybe<Scalars['String']['output']>;
  refusal?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type PromptLabResult = {
  __typename?: 'PromptLabResult';
  finishReason?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<PromptLabMessage>;
};

export type PromptVersion = {
  __typename?: 'PromptVersion';
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByUser?: Maybe<User>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Unrestricted queries */
export type Query = {
  __typename?: 'Query';
  admin?: Maybe<AdminQuery>;
  authors?: Maybe<Array<Maybe<Author>>>;
  blogPost?: Maybe<BlogPost>;
  blogPosts?: Maybe<Array<Maybe<BlogPost>>>;
  blogTags?: Maybe<Array<Maybe<BlogTag>>>;
  book?: Maybe<BookProduct>;
  books?: Maybe<Array<Maybe<BookProduct>>>;
  feedback?: Maybe<Array<Maybe<UserFeedback>>>;
  /** The product's group discount, or null when it's not enabled (pricing page teaser) */
  groupDiscountOffer?: Maybe<GroupDiscountOffer>;
  productEntitlements?: Maybe<Array<Maybe<Entitlement>>>;
  products?: Maybe<Array<Maybe<ProductSubscription>>>;
  quesBook?: Maybe<Array<Maybe<Topic>>>;
  restricted?: Maybe<RestrictedQuery>;
  sampleContent?: Maybe<SampleContent>;
  /** refId (client-generated) resumes an in-progress attempt, creating one on first use, and merges its saved marks in */
  sampleMarksheet?: Maybe<Marksheet>;
  sampleOsceMarksheet?: Maybe<OsceMarksheet>;
  sampleQuizReport?: Maybe<SampleQuizReport>;
  sampleTodo?: Maybe<Todo>;
  /** Invite page. Works without a token; send one to get viewerState */
  studyGroupInvite?: Maybe<StudyGroupInvite>;
  temp?: Maybe<Scalars['String']['output']>;
  universities?: Maybe<Array<Maybe<University>>>;
  usernameAvailable?: Maybe<Scalars['Boolean']['output']>;
  usernameProvisioned?: Maybe<Scalars['Boolean']['output']>;
  video?: Maybe<Video>;
  videos?: Maybe<Array<Maybe<Video>>>;
  zoomSignature?: Maybe<Scalars['String']['output']>;
};


/** Unrestricted queries */
export type QueryBlogPostArgs = {
  id: Scalars['Int']['input'];
};


/** Unrestricted queries */
export type QueryBlogPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Unrestricted queries */
export type QueryBookArgs = {
  id: Scalars['Int']['input'];
};


/** Unrestricted queries */
export type QueryFeedbackArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** Unrestricted queries */
export type QueryGroupDiscountOfferArgs = {
  productTypeId: Scalars['Int']['input'];
};


/** Unrestricted queries */
export type QueryProductEntitlementsArgs = {
  productId?: InputMaybe<Scalars['ID']['input']>;
};


/** Unrestricted queries */
export type QueryProductsArgs = {
  typeId: Scalars['Int']['input'];
};


/** Unrestricted queries */
export type QueryQuesBookArgs = {
  typeId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  videosOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Unrestricted queries */
export type QuerySampleMarksheetArgs = {
  marksheetId: Scalars['Int']['input'];
  refId?: InputMaybe<Scalars['UUID']['input']>;
};


/** Unrestricted queries */
export type QuerySampleOsceMarksheetArgs = {
  osceMarksheetId: Scalars['Int']['input'];
};


/** Unrestricted queries */
export type QuerySampleQuizReportArgs = {
  reportId: Scalars['UUID']['input'];
};


/** Unrestricted queries */
export type QuerySampleTodoArgs = {
  todoId: Scalars['Int']['input'];
};


/** Unrestricted queries */
export type QueryStudyGroupInviteArgs = {
  code: Scalars['String']['input'];
};


/** Unrestricted queries */
export type QueryTempArgs = {
  command?: InputMaybe<Scalars['String']['input']>;
};


/** Unrestricted queries */
export type QueryUniversitiesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};


/** Unrestricted queries */
export type QueryUsernameAvailableArgs = {
  username: Scalars['String']['input'];
};


/** Unrestricted queries */
export type QueryUsernameProvisionedArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


/** Unrestricted queries */
export type QueryVideoArgs = {
  id: Scalars['Int']['input'];
};


/** Unrestricted queries */
export type QueryVideosArgs = {
  filter: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  platform: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Unrestricted queries */
export type QueryZoomSignatureArgs = {
  meetingNumber: Scalars['String']['input'];
};

/** Question is the main single best answer type of question */
export type Question = {
  aiGenerated: Scalars['Boolean']['output'];
  areas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  avgTimeTaken?: Maybe<Scalars['Int']['output']>;
  bodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /** Choices are only used on typeId=[1,3,5,6,7] */
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  comments?: Maybe<Array<Maybe<QuestionComment>>>;
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctAttempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  elo?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<QuestionEntitlement>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectAttempts?: Maybe<Scalars['Int']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  itemParameters?: Maybe<IrtParameters>;
  jobRecord?: Maybe<JobRecord>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  partiallyCorrectAttempts?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  presentationAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  psaSectionId?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  recordReview?: Maybe<RecordReview>;
  revisions?: Maybe<Array<Maybe<QuestionRevision>>>;
  stem?: Maybe<Chapter>;
  stemId?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<Maybe<Theme>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  totalVotes?: Maybe<Scalars['Int']['output']>;
  tutorSuggestions: Array<TutorSuggestion>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

/** QuestionCase can be used for Extended Question Matching Answer */
export type QuestionCase = {
  __typename?: 'QuestionCase';
  case?: Maybe<Scalars['String']['output']>;
  /** specific explanation for this case */
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** label = a,b,c,d... */
  label?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type QuestionCaseInput = {
  case?: InputMaybe<Scalars['String']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
};

/** QuestionChoice can be used either for Single Best Answer or Multiple Answer questions */
export type QuestionChoice = {
  __typename?: 'QuestionChoice';
  answer?: Maybe<Scalars['Boolean']['output']>;
  /** specific explanation for this choice */
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** label = a,b,c,d... */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Picture>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  questionId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** votes are the number of times this choice has been selected by users */
  votes?: Maybe<Scalars['Int']['output']>;
};

export type QuestionChoiceInput = {
  answer?: InputMaybe<Scalars['Boolean']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
};

/** QuestionComment is used in Question */
export type QuestionComment = {
  __typename?: 'QuestionComment';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<QuestionComment>;
  parentId?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['Int']['output']>;
  /** Id of the content.record_review row created from this comment, if any */
  recordReviewId?: Maybe<Scalars['Int']['output']>;
  replies?: Maybe<Array<Maybe<QuestionComment>>>;
  review?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type QuestionCommentList = {
  __typename?: 'QuestionCommentList';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  nextCursor?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Array<Maybe<QuestionComment>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type QuestionCommentListOptions = {
  from?: InputMaybe<Scalars['Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  questionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  review?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type QuestionEmq = Question & {
  __typename?: 'QuestionEMQ';
  aiGenerated: Scalars['Boolean']['output'];
  /** Answer is `[string, string][]` */
  answer?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  areas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  avgTimeTaken?: Maybe<Scalars['Int']['output']>;
  bodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /** Cases are only used on typeId=[5] */
  cases?: Maybe<Array<Maybe<QuestionCase>>>;
  /** Choices are only used on typeId=[1,3,5,6,7] */
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  comments?: Maybe<Array<Maybe<QuestionComment>>>;
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctAttempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  elo?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<QuestionEntitlement>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectAttempts?: Maybe<Scalars['Int']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  itemParameters?: Maybe<IrtParameters>;
  jobRecord?: Maybe<JobRecord>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  partiallyCorrectAttempts?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  presentationAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  psaSectionId?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  recordReview?: Maybe<RecordReview>;
  revisions?: Maybe<Array<Maybe<QuestionRevision>>>;
  stem?: Maybe<Chapter>;
  stemId?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<Maybe<Theme>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  totalVotes?: Maybe<Scalars['Int']['output']>;
  tutorSuggestions: Array<TutorSuggestion>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

export type QuestionEntitlement = {
  __typename?: 'QuestionEntitlement';
  entitlementId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
};

export type QuestionHighlight = {
  __typename?: 'QuestionHighlight';
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type QuestionLearningPoint = {
  __typename?: 'QuestionLearningPoint';
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  questionId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

export type QuestionMultiA = Question & {
  __typename?: 'QuestionMultiA';
  aiGenerated: Scalars['Boolean']['output'];
  /** Answer is `[string[], string[]]` with answers for the left and right column */
  answer?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  areas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  avgTimeTaken?: Maybe<Scalars['Int']['output']>;
  bodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /** Choices are only used on typeId=[1,3,5,6,7] */
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  comments?: Maybe<Array<Maybe<QuestionComment>>>;
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctAttempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  elo?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<QuestionEntitlement>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectAttempts?: Maybe<Scalars['Int']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  itemParameters?: Maybe<IrtParameters>;
  jobRecord?: Maybe<JobRecord>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  partiallyCorrectAttempts?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  presentationAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  psaSectionId?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  recordReview?: Maybe<RecordReview>;
  revisions?: Maybe<Array<Maybe<QuestionRevision>>>;
  stem?: Maybe<Chapter>;
  stemId?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<Maybe<Theme>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  totalVotes?: Maybe<Scalars['Int']['output']>;
  tutorSuggestions: Array<TutorSuggestion>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

export type QuestionPrescription = Question & {
  __typename?: 'QuestionPrescription';
  aiGenerated: Scalars['Boolean']['output'];
  /** Answer is an array of correct prescriptions */
  answer?: Maybe<Array<Maybe<PrescriptionAnswer>>>;
  areas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  avgTimeTaken?: Maybe<Scalars['Int']['output']>;
  bodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /** Choices are only used on typeId=[1,3] */
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  comments?: Maybe<Array<Maybe<QuestionComment>>>;
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctAttempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  elo?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<QuestionEntitlement>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectAttempts?: Maybe<Scalars['Int']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  itemParameters?: Maybe<IrtParameters>;
  jobRecord?: Maybe<JobRecord>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  partiallyCorrectAttempts?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  prescriptions?: Maybe<Array<Maybe<PrescriptionAnswerData>>>;
  presentationAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  psaSectionId?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  recordReview?: Maybe<RecordReview>;
  revisions?: Maybe<Array<Maybe<QuestionRevision>>>;
  stem?: Maybe<Chapter>;
  stemId?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<Maybe<Theme>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  totalVotes?: Maybe<Scalars['Int']['output']>;
  tutorSuggestions: Array<TutorSuggestion>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

export type QuestionQa = Question & {
  __typename?: 'QuestionQA';
  aiGenerated: Scalars['Boolean']['output'];
  /** Answer is a `[string]` of the correct answer */
  answer?: Maybe<Array<Maybe<QuestionQaAnswer>>>;
  areas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  avgTimeTaken?: Maybe<Scalars['Int']['output']>;
  bodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /** Choices are only used on typeId=[1,3,5,6,7] */
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  comments?: Maybe<Array<Maybe<QuestionComment>>>;
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctAttempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  elo?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<QuestionEntitlement>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectAttempts?: Maybe<Scalars['Int']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  itemParameters?: Maybe<IrtParameters>;
  jobRecord?: Maybe<JobRecord>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  partiallyCorrectAttempts?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  presentationAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  psaSectionId?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  recordReview?: Maybe<RecordReview>;
  revisions?: Maybe<Array<Maybe<QuestionRevision>>>;
  stem?: Maybe<Chapter>;
  stemId?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<Maybe<Theme>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  totalVotes?: Maybe<Scalars['Int']['output']>;
  tutorSuggestions: Array<TutorSuggestion>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

export type QuestionQaAnswer = {
  __typename?: 'QuestionQAAnswer';
  dose?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

export type QuestionRanking = Question & {
  __typename?: 'QuestionRanking';
  aiGenerated: Scalars['Boolean']['output'];
  /** Answer is `string[]` */
  answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  areas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  avgTimeTaken?: Maybe<Scalars['Int']['output']>;
  bodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /** Choices are only used on typeId=[1,3,5,6,7] */
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  comments?: Maybe<Array<Maybe<QuestionComment>>>;
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctAttempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  elo?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<QuestionEntitlement>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectAttempts?: Maybe<Scalars['Int']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  itemParameters?: Maybe<IrtParameters>;
  jobRecord?: Maybe<JobRecord>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  partiallyCorrectAttempts?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  presentationAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  psaSectionId?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  recordReview?: Maybe<RecordReview>;
  revisions?: Maybe<Array<Maybe<QuestionRevision>>>;
  stem?: Maybe<Chapter>;
  stemId?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<Maybe<Theme>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  totalVotes?: Maybe<Scalars['Int']['output']>;
  tutorSuggestions: Array<TutorSuggestion>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

export type QuestionRecordCase = {
  __typename?: 'QuestionRecordCase';
  case: Scalars['String']['output'];
  explanation?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type QuestionRecordCaseInput = {
  case: Scalars['String']['input'];
  explanation?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type QuestionRecordChoice = {
  __typename?: 'QuestionRecordChoice';
  answer?: Maybe<Scalars['Boolean']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuestionRecordChoiceInput = {
  answer?: InputMaybe<Scalars['Boolean']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type QuestionRevision = {
  __typename?: 'QuestionRevision';
  answer?: Maybe<Scalars['String']['output']>;
  cases?: Maybe<Array<Maybe<QuestionCase>>>;
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  difficulty?: Maybe<Scalars['Int']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type QuestionSba = Question & {
  __typename?: 'QuestionSBA';
  aiGenerated: Scalars['Boolean']['output'];
  /** Answer is the `[choice.label]` */
  answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  areas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  avgTimeTaken?: Maybe<Scalars['Int']['output']>;
  bodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /** Choices are only used on typeId=[1,3,5,6,7] */
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  comments?: Maybe<Array<Maybe<QuestionComment>>>;
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctAttempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  elo?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<QuestionEntitlement>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectAttempts?: Maybe<Scalars['Int']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  itemParameters?: Maybe<IrtParameters>;
  jobRecord?: Maybe<JobRecord>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  partiallyCorrectAttempts?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  presentationAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  psaSectionId?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  recordReview?: Maybe<RecordReview>;
  revisions?: Maybe<Array<Maybe<QuestionRevision>>>;
  stem?: Maybe<Chapter>;
  stemId?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<Maybe<Theme>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  totalVotes?: Maybe<Scalars['Int']['output']>;
  tutorSuggestions: Array<TutorSuggestion>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

export type QuestionSelect3 = Question & {
  __typename?: 'QuestionSelect3';
  aiGenerated: Scalars['Boolean']['output'];
  /** Answer is `[string, string, string]` */
  answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  areas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  avgTimeTaken?: Maybe<Scalars['Int']['output']>;
  bodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /** Choices are only used on typeId=[1,3,5,6,7] */
  choices?: Maybe<Array<Maybe<QuestionChoice>>>;
  comments?: Maybe<Array<Maybe<QuestionComment>>>;
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  conditionAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctAttempts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** difficulty is based on EDifficultyType */
  difficulty?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  elo?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<QuestionEntitlement>>>;
  explanation?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Maybe<HighlightNode>>>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectAttempts?: Maybe<Scalars['Int']['output']>;
  /** isLikedByMe uses EQuestionLike enum */
  isLikedByMe?: Maybe<Scalars['Int']['output']>;
  itemParameters?: Maybe<IrtParameters>;
  jobRecord?: Maybe<JobRecord>;
  learningPoint?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  partiallyCorrectAttempts?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Picture>>>;
  presentationAreaIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  psaSectionId?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  recordReview?: Maybe<RecordReview>;
  revisions?: Maybe<Array<Maybe<QuestionRevision>>>;
  stem?: Maybe<Chapter>;
  stemId?: Maybe<Scalars['Int']['output']>;
  themes?: Maybe<Array<Maybe<Theme>>>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Topic>;
  totalTime?: Maybe<Scalars['Int']['output']>;
  totalVotes?: Maybe<Scalars['Int']['output']>;
  tutorSuggestions: Array<TutorSuggestion>;
  typeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userPoint?: Maybe<Scalars['Int']['output']>;
};

export type QuestionStats = {
  __typename?: 'QuestionStats';
  difficulties?: Maybe<Array<Maybe<Stats>>>;
  entitlements?: Maybe<Array<Maybe<Stats>>>;
  mockCategories?: Maybe<Array<Maybe<Stats>>>;
  mockTests?: Maybe<Array<Maybe<Stats>>>;
  totalMockQuestions?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

/** QuickBuildMarksheetInput is used when quick building a Marksheet */
export type QuickBuildMarksheetInput = {
  difficulty?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  secondsPerQuestion?: InputMaybe<Scalars['Int']['input']>;
  seenCorrect?: InputMaybe<Scalars['Int']['input']>;
  seenIncorrect?: InputMaybe<Scalars['Int']['input']>;
  totalQuestions?: InputMaybe<Scalars['Int']['input']>;
  unseen?: InputMaybe<Scalars['Int']['input']>;
};

export type Rating = {
  __typename?: 'Rating';
  count?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type RecordReport = {
  __typename?: 'RecordReport';
  actionedBy?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  members?: Maybe<Array<Maybe<RecordReportMember>>>;
  reason?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RecordReportList = {
  __typename?: 'RecordReportList';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  nextCursor?: Maybe<Scalars['Int']['output']>;
  result: Array<RecordReport>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RecordReportMember = {
  __typename?: 'RecordReportMember';
  id?: Maybe<Scalars['ID']['output']>;
  recordReportId?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type RecordReportOptions = {
  actionedBy?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  withRecords?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordReview = {
  __typename?: 'RecordReview';
  actionedBy?: Maybe<Scalars['Int']['output']>;
  chapter?: Maybe<Chapter>;
  comment?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdByUser?: Maybe<User>;
  id?: Maybe<Scalars['ID']['output']>;
  members?: Maybe<Array<Maybe<RecordReviewMember>>>;
  question?: Maybe<Question>;
  reason?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  station?: Maybe<OsceStation>;
  type?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RecordReviewList = {
  __typename?: 'RecordReviewList';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  nextCursor?: Maybe<Scalars['Int']['output']>;
  result: Array<RecordReview>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RecordReviewMember = {
  __typename?: 'RecordReviewMember';
  id?: Maybe<Scalars['ID']['output']>;
  recordReviewId?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type RecordReviewMemberInput = {
  role?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordReviewOptions = {
  actionedBy?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  recordIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

/** RegisterUser is used on the registration view */
export type RegisterUser = {
  classYear?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['Int']['input']>;
  username: Scalars['String']['input'];
};

/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutation = {
  __typename?: 'RestrictedMutation';
  /** acceptOsceMatchmaking and remove OSCE group from matchmaking if full */
  acceptOsceMatchmaking?: Maybe<Scalars['Boolean']['output']>;
  /** addChapterHighlight is a way to add highlights in chapter */
  addChapterHighlight?: Maybe<Array<Maybe<ChapterHighlight>>>;
  addFlaggedQuestion?: Maybe<UserFlaggedQuestion>;
  /** Creates a Notification */
  addNotification?: Maybe<Notification>;
  /** Creates multiple Notifications */
  addNotifications?: Maybe<Array<Maybe<Notification>>>;
  addProductFeedback?: Maybe<ProductFeedback>;
  /** addQuestionHighlight is a way to add highlights in question */
  addQuestionHighlight?: Maybe<Array<Maybe<QuestionHighlight>>>;
  /** addQuestionLearningPoint is a way to add learning point for user in question */
  addQuestionLearningPoint?: Maybe<Array<Maybe<QuestionLearningPoint>>>;
  addToDailyStack?: Maybe<AddToDailyStackData>;
  advanceCircuitSession?: Maybe<CircuitSession>;
  /**
   * agoraToken builds a token for use with Agora's audio/video channels
   * platformId = EPlatformId
   * channel = OsceMarksheet.agoraId
   * uid = user.id
   */
  agoraToken?: Maybe<Scalars['String']['output']>;
  answerTutorQuiz: TutorMessage;
  autoMarkOsceMarksheet?: Maybe<OsceMarksheet>;
  /** buildMarksheet is a way to build the marksheet */
  buildMarksheet?: Maybe<Marksheet>;
  buildMockTestMarksheet?: Maybe<Marksheet>;
  /** pass osceMarksheetId if in lobby mode */
  buildOsceMarksheet?: Maybe<OsceMarksheet>;
  /**
   * buildQuestionMarksheet is a way to build a marksheet from questionIds
   * or otherwise from a user's flagged questions
   */
  buildQuestionMarksheet?: Maybe<Marksheet>;
  buildTodo?: Maybe<Todo>;
  /** buildUcatMarksheet is a way to build the marksheet for ucat */
  buildUcatMarksheet?: Maybe<Marksheet>;
  /** cancelOsceMatchmaking and remove user from matchmaking */
  cancelOsceMatchmaking?: Maybe<Scalars['Boolean']['output']>;
  cancelSubscription?: Maybe<Subscription>;
  /**
   * changeOsceRole selects a new role for the user and publishes
   * it to the rest of the group
   */
  changeOsceRole?: Maybe<OsceMarksheet>;
  /**
   * checkOsceMatchmaking is manual way of checking the status instead of
   * waiting for the subscription osceMatchmaking() to return data
   */
  checkOsceMatchmaking?: Maybe<OsceMatchmakingAction>;
  contactUs?: Maybe<Scalars['String']['output']>;
  createAssets: Array<Picture>;
  createCircuit?: Maybe<Circuit>;
  createCircuitSession?: Maybe<CircuitSession>;
  /** createOrJoinOsceMarksheet */
  createOrJoinOsceMarksheet?: Maybe<OsceMarksheet>;
  createPreset?: Maybe<Preset>;
  createRecordReview?: Maybe<Array<Maybe<RecordReview>>>;
  createStation?: Maybe<OsceStation>;
  createVoiceSession?: Maybe<LivekitSession>;
  createWeeklyRecordReviews?: Maybe<Scalars['Boolean']['output']>;
  deleteCircuit?: Maybe<Scalars['Boolean']['output']>;
  deleteMarksheet?: Maybe<Scalars['Boolean']['output']>;
  deletePreset?: Maybe<Scalars['Boolean']['output']>;
  deleteRecordReports?: Maybe<Scalars['Boolean']['output']>;
  deleteRecordReviewByRecordIds?: Maybe<Scalars['Boolean']['output']>;
  deleteRecordReviews?: Maybe<Scalars['Boolean']['output']>;
  deleteStation?: Maybe<ResultData>;
  deleteTutorConversation: Scalars['Boolean']['output'];
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  deleteWeeklyRecordReviews?: Maybe<Scalars['Boolean']['output']>;
  duplicatePreset?: Maybe<Preset>;
  editCircuit?: Maybe<Circuit>;
  editPreset?: Maybe<Preset>;
  endCircuitSession?: Maybe<CircuitSession>;
  /** endMarksheet is a way to end the marksheet and calculate score */
  endMarksheet?: Maybe<Marksheet>;
  endMockTest?: Maybe<Marksheet>;
  endOsceMarksheet?: Maybe<OsceMarksheet>;
  endVoiceSession?: Maybe<Scalars['Boolean']['output']>;
  generateStation: GenerateStationSession;
  generateSummaryOsceMarksheet?: Maybe<OsceMarksheet>;
  /** leaveMarksheet is a way to let the user to leave group study */
  leaveMarksheet?: Maybe<Marksheet>;
  leaveOsceMarksheet?: Maybe<OsceMarksheet>;
  logoutUser?: Maybe<Scalars['Boolean']['output']>;
  /** Marks all notifications as seen/read for the logged-in user */
  markAllNotificationsAsRead?: Maybe<Array<Maybe<Notification>>>;
  /** Marks the notification as seen/read */
  markNotificationAsRead?: Maybe<Notification>;
  /**
   * markOsceMarksheetMark
   * Examiner to toggle a marksheet checkbox
   */
  markOsceMarksheetMark?: Maybe<OsceMarksheetMark>;
  /** modifyMarksheet is a way to let all the user to be in sync with latest marksheet changes */
  modifyMarksheet?: Maybe<Marksheet>;
  /** modifyMarksheetMark is a way to let all the user to be in sync with latest marksheet mark changes */
  modifyMarksheetMark?: Maybe<MarksheetMark>;
  /** modifyOsceMarksheet is a way to let all the user to be in sync with latest marksheet changes */
  modifyOsceMarksheet?: Maybe<OsceMarksheet>;
  /**
   * prestartOsceMarksheet moves the selected OSCE station into exam mode
   * for everyone EXCEPT the candidate
   * readingTime (seconds)
   * stationTime (minutes)
   * feedbackTime (minutes)
   */
  prestartOsceMarksheet?: Maybe<OsceMarksheet>;
  questionCommentLike?: Maybe<QuestionComment>;
  questionCommentRemove?: Maybe<QuestionComment>;
  questionComments?: Maybe<QuestionComment>;
  questionLike?: Maybe<Question>;
  /** quickBuildMarksheet is a way to quick build the marksheet */
  quickBuildMarksheet?: Maybe<Marksheet>;
  /** Thumbs on one assistant message. Pass rating: null to clear it. */
  rateTutorMessage: TutorMessage;
  reBuildMarksheet?: Maybe<Marksheet>;
  refreshDailyTask?: Maybe<Todo>;
  removeAssets?: Maybe<Scalars['Boolean']['output']>;
  removeFlaggedQuestion?: Maybe<Array<Maybe<UserFlaggedQuestion>>>;
  removeFromDailyStack?: Maybe<RemoveFromDailyStackData>;
  removeToken?: Maybe<Scalars['String']['output']>;
  renewToken?: Maybe<Scalars['JWT']['output']>;
  resetCategoryProgress?: Maybe<Scalars['Boolean']['output']>;
  resetProgress?: Maybe<User>;
  resumeCircuitSession?: Maybe<CircuitSession>;
  revealTutorHint: TutorMessage;
  /** saveMarksheets is a way to let the user to verify the answer that they have selected */
  saveMarksheets?: Maybe<Array<Maybe<Marksheet>>>;
  saveOsceMarksheet?: Maybe<OsceMarksheet>;
  saveTodos: Array<Maybe<Todo>>;
  /**
   * selectOsceMarksheetStation
   * Action for examiner to select the OSCE station for the group
   */
  selectOsceMarksheetStation?: Maybe<OsceMarksheet>;
  sendOsceChatMessage: Array<OsceMarksheetMessage>;
  setOsceMarksheetFeedback?: Maybe<OsceMarksheetFeedbackReaction>;
  /** startOrJoinMarksheet is a way to let the the user to start or join group Study */
  startOrJoinMarksheet?: Maybe<Marksheet>;
  /** startOsceMarksheet invites the candidate into the exam room */
  startOsceMarksheet?: Maybe<OsceMarksheet>;
  /**
   * startOsceMatchmaking server will add all users in
   * OsceMarksheet based on agoraId to matchmaking
   */
  startOsceMatchmaking?: Maybe<Scalars['Boolean']['output']>;
  /** startOsceTimer triggered by candidate to start the server-led timer */
  startOsceTimer?: Maybe<OsceMarksheet>;
  startStudyGroup: StudyGroup;
  streamOsceChatMessage: Scalars['String']['output'];
  /** The session survey, usually opened after a dislike. */
  submitTutorFeedback: TutorConversation;
  subscribeFCMTopic?: Maybe<Scalars['String']['output']>;
  syncSubscriptions?: Maybe<Scalars['Boolean']['output']>;
  tocAccept?: Maybe<Scalars['JWT']['output']>;
  toggleFlaggedMark?: Maybe<MarksheetMark>;
  /** toggleStrikeOptions is a way to strike marksheet options */
  toggleStrikeOptions?: Maybe<Array<Maybe<MarksheetMark>>>;
  /** Save (save: true) or unsave (save: false) a video to the user's watch later list */
  toggleVideoWatchLater?: Maybe<Video>;
  unsubscribeFCMTopic?: Maybe<Scalars['String']['output']>;
  updateRecordReport?: Maybe<RecordReport>;
  updateRecordReview?: Maybe<RecordReview>;
  updateStation?: Maybe<OsceStation>;
  updateSubscription?: Maybe<Scalars['Boolean']['output']>;
  updateUser?: Maybe<UpdatedUserAndJwt>;
  updateUserData?: Maybe<Scalars['Boolean']['output']>;
  updateUserSettings?: Maybe<UserSettings>;
  updateWeeklyRecordReview?: Maybe<WeeklyRecordReview>;
  updateWeeklyRecordReviewsState?: Maybe<Scalars['Boolean']['output']>;
  upsertConceptChapter?: Maybe<UserConceptChapter>;
  upsertConceptNote?: Maybe<UserConceptNote>;
  upsertStationNote?: Maybe<UserStationNote>;
  upsertToken?: Maybe<Token>;
  upsertUserConceptStatus?: Maybe<Array<Maybe<UserConceptStatus>>>;
  upsertUserStationStatus?: Maybe<Array<Maybe<UserStationStatus>>>;
  upsertUserVideoStatus?: Maybe<Array<Maybe<UserVideotatus>>>;
  videoWatched?: Maybe<Video>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAcceptOsceMatchmakingArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAddChapterHighlightArgs = {
  input: Array<AddChapterHighlightInput>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAddFlaggedQuestionArgs = {
  markId: Scalars['Int']['input'];
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAddNotificationArgs = {
  data: AddNotificationInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAddNotificationsArgs = {
  data: Array<AddNotificationInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAddProductFeedbackArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAddQuestionHighlightArgs = {
  input: Array<AddQuestionHighlightInput>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAddQuestionLearningPointArgs = {
  input: Array<AddQuestionLearningPointInput>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAddToDailyStackArgs = {
  conceptIds: Array<Scalars['Int']['input']>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAdvanceCircuitSessionArgs = {
  circuitSessionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAgoraTokenArgs = {
  channel: Scalars['String']['input'];
  platformId: Scalars['Int']['input'];
  uid: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAnswerTutorQuizArgs = {
  blockId: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
  optionId: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationAutoMarkOsceMarksheetArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  osceMarksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationBuildMarksheetArgs = {
  input?: InputMaybe<BuildMarksheetInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationBuildMockTestMarksheetArgs = {
  duration: Scalars['Int']['input'];
  mockTestId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationBuildOsceMarksheetArgs = {
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<OsceMarksheetMode>;
  osceMarksheetId?: InputMaybe<Scalars['Int']['input']>;
  osceStationId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationBuildQuestionMarksheetArgs = {
  questionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationBuildTodoArgs = {
  buildTodo: BuildTodoInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationBuildUcatMarksheetArgs = {
  input?: InputMaybe<BuildUcatMarksheetInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCancelOsceMatchmakingArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCancelSubscriptionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationChangeOsceRoleArgs = {
  role: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationContactUsArgs = {
  message: Scalars['String']['input'];
  slack: SupportTicket;
  subject: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreateAssetsArgs = {
  inputs: Array<CreateAssetsInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreateCircuitArgs = {
  input: CreateCircuitInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreateCircuitSessionArgs = {
  circuitId: Scalars['Int']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreateOrJoinOsceMarksheetArgs = {
  action: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreatePresetArgs = {
  data: CreatePresetInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreateRecordReviewArgs = {
  input: Array<CreateRecordReviewInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreateStationArgs = {
  input: CreateStationInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreateVoiceSessionArgs = {
  osceMarksheetId: Scalars['Int']['input'];
  phase: OsceStationPhase;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationCreateWeeklyRecordReviewsArgs = {
  input: CreateWeeklyRecordReviewInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeleteCircuitArgs = {
  circuitId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeleteMarksheetArgs = {
  marksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeletePresetArgs = {
  presetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeleteRecordReportsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeleteRecordReviewByRecordIdsArgs = {
  recordIds: Array<Scalars['ID']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeleteRecordReviewsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeleteStationArgs = {
  stationId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeleteTutorConversationArgs = {
  conversationId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDeleteWeeklyRecordReviewsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationDuplicatePresetArgs = {
  presetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationEditCircuitArgs = {
  circuitId: Scalars['Int']['input'];
  input: EditCircuitInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationEditPresetArgs = {
  data: EditPresetInput;
  presetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationEndCircuitSessionArgs = {
  circuitSessionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationEndMarksheetArgs = {
  marksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationEndMockTestArgs = {
  marksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationEndOsceMarksheetArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  globalScore?: InputMaybe<Scalars['Int']['input']>;
  osceMarksheetId: Scalars['Int']['input'];
  timeTaken?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationEndVoiceSessionArgs = {
  osceMarksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationGenerateStationArgs = {
  input: GenerateStationInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationGenerateSummaryOsceMarksheetArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  osceMarksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationLeaveMarksheetArgs = {
  marksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationLeaveOsceMarksheetArgs = {
  osceMarksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationLogoutUserArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationMarkNotificationAsReadArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationMarkOsceMarksheetMarkArgs = {
  corrected?: InputMaybe<Scalars['Boolean']['input']>;
  mark: Scalars['Int']['input'];
  osceMarksheetMarkId: Scalars['Int']['input'];
  secondaryMark?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationModifyMarksheetArgs = {
  input?: InputMaybe<ModifyMarksheetInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationModifyMarksheetMarkArgs = {
  input?: InputMaybe<ModifyMarksheetMarkInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationModifyOsceMarksheetArgs = {
  input?: InputMaybe<ModifyOsceMarksheetInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationPrestartOsceMarksheetArgs = {
  feedbackTime: Scalars['Int']['input'];
  isTimed?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<OsceMarksheetMode>;
  osceMarksheetId: Scalars['Int']['input'];
  readingTime: Scalars['Int']['input'];
  stationTime: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationQuestionCommentLikeArgs = {
  commentId: Scalars['Int']['input'];
  like?: InputMaybe<Scalars['Int']['input']>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationQuestionCommentRemoveArgs = {
  commentId: Scalars['Int']['input'];
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationQuestionCommentsArgs = {
  comment: Scalars['String']['input'];
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationQuestionLikeArgs = {
  like?: InputMaybe<Scalars['Int']['input']>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationQuickBuildMarksheetArgs = {
  input?: InputMaybe<QuickBuildMarksheetInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationRateTutorMessageArgs = {
  messageId: Scalars['ID']['input'];
  rating?: InputMaybe<TutorRating>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationReBuildMarksheetArgs = {
  conceptIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  questionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationRemoveAssetsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationRemoveFlaggedQuestionArgs = {
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationRemoveFromDailyStackArgs = {
  cardId?: InputMaybe<Scalars['Int']['input']>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  todoId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationRemoveTokenArgs = {
  token: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationResetCategoryProgressArgs = {
  conceptIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  stationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationResetProgressArgs = {
  cards?: InputMaybe<Scalars['Boolean']['input']>;
  questions?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationResumeCircuitSessionArgs = {
  circuitSessionId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationRevealTutorHintArgs = {
  blockId: Scalars['String']['input'];
  hintId: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSaveMarksheetsArgs = {
  input: Array<SaveMarksheetInput>;
  updatesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSaveOsceMarksheetArgs = {
  corrected?: InputMaybe<Scalars['Boolean']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  globalScore?: InputMaybe<Scalars['Int']['input']>;
  osceMarksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSaveTodosArgs = {
  todos: Array<TodoInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSelectOsceMarksheetStationArgs = {
  osceMarksheetId: Scalars['Int']['input'];
  osceStationId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSendOsceChatMessageArgs = {
  message: Scalars['String']['input'];
  osceMarksheetId: Scalars['Int']['input'];
  phase: OsceStationPhase;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSetOsceMarksheetFeedbackArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  osceMarksheetId?: InputMaybe<Scalars['Int']['input']>;
  reaction?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationStartOrJoinMarksheetArgs = {
  action: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationStartOsceMarksheetArgs = {
  osceMarksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationStartOsceMatchmakingArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationStartOsceTimerArgs = {
  osceMarksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationStartStudyGroupArgs = {
  productTypeId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationStreamOsceChatMessageArgs = {
  message: Scalars['String']['input'];
  osceMarksheetId: Scalars['Int']['input'];
  phase: OsceStationPhase;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSubmitTutorFeedbackArgs = {
  conversationId: Scalars['Int']['input'];
  feedback: TutorFeedbackInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSubscribeFcmTopicArgs = {
  token: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationSyncSubscriptionsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationToggleFlaggedMarkArgs = {
  isFlagged: Scalars['Boolean']['input'];
  markId: Scalars['Int']['input'];
  marksheetId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationToggleStrikeOptionsArgs = {
  input: Array<ToggleStrikeOptionsInput>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationToggleVideoWatchLaterArgs = {
  save: Scalars['Boolean']['input'];
  videoId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUnsubscribeFcmTopicArgs = {
  token: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateRecordReportArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRecordReportInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateRecordReviewArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRecordReviewInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateStationArgs = {
  input: UpdateStationInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateSubscriptionArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input: UserSubscriptionInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateUserArgs = {
  data: UserInput;
  id?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateUserDataArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input: UserAdminInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateUserSettingsArgs = {
  input: UserSettingsInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateWeeklyRecordReviewArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWeeklyRecordReviewInput;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpdateWeeklyRecordReviewsStateArgs = {
  ids: Array<Scalars['ID']['input']>;
  state: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpsertConceptChapterArgs = {
  conceptId: Scalars['Int']['input'];
  explanation: Scalars['String']['input'];
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpsertConceptNoteArgs = {
  conceptId: Scalars['Int']['input'];
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  note: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpsertStationNoteArgs = {
  note: Scalars['String']['input'];
  stationId: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpsertTokenArgs = {
  deviceId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpsertUserConceptStatusArgs = {
  conceptIds: Array<Scalars['Int']['input']>;
  status: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpsertUserStationStatusArgs = {
  osceStationIds: Array<Scalars['Int']['input']>;
  status: Scalars['Int']['input'];
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationUpsertUserVideoStatusArgs = {
  status: Scalars['Int']['input'];
  videoIds: Array<Scalars['Int']['input']>;
};


/**
 * Restricted mutations requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedMutationVideoWatchedArgs = {
  id: Scalars['Int']['input'];
};

/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQuery = {
  __typename?: 'RestrictedQuery';
  activityHeatmap?: Maybe<ActivityHeatmap>;
  chapter?: Maybe<Chapter>;
  circuit?: Maybe<Circuit>;
  circuitSession?: Maybe<CircuitSession>;
  circuitSessions?: Maybe<Array<Maybe<CircuitSession>>>;
  circuits?: Maybe<Array<Maybe<Circuit>>>;
  concept?: Maybe<Concept>;
  conceptNotes?: Maybe<Array<Maybe<UserConceptNote>>>;
  concepts?: Maybe<Array<Maybe<Concept>>>;
  dashboardOsce?: Maybe<OsceDashboard>;
  dropdownOptions?: Maybe<Array<Maybe<BreakdownValue>>>;
  filteredRecordReviews: FilteredRecordReviewList;
  flaggedQuestions?: Maybe<PaginatedUserFlaggedQuestion>;
  /**
   * flaggedQuestionsMarksheet creates a mock marksheet with all the flaggedQuestions
   * ONLY for review mode
   */
  flaggedQuestionsMarksheet?: Maybe<Marksheet>;
  generateStationStatus: GenerateStationResult;
  /**
   * heartbeat should be polled every second to let all users
   * know that there has not been a disconnection
   */
  heartbeat?: Maybe<Scalars['Boolean']['output']>;
  /**
   * heartbeat should be polled every second to let all users
   * know that there has not been a disconnection
   */
  heartbeatQbank?: Maybe<Scalars['Boolean']['output']>;
  latestPastMarksheetId?: Maybe<Scalars['Int']['output']>;
  latestSessionId?: Maybe<Scalars['String']['output']>;
  /** marksheet is a way to get latest data of the marksheet */
  marksheet?: Maybe<Marksheet>;
  marksheetFeedback?: Maybe<MarksheetFeedback>;
  marksheetList?: Maybe<PaginatedMarksheet>;
  marksheets?: Maybe<PaginatedMarksheet>;
  marksheetsTracker?: Maybe<Array<Maybe<DateResultMarksheetPair>>>;
  marksheetsWindow?: Maybe<PaginatedWindowMarksheet>;
  mockTest?: Maybe<MockTest>;
  mockTests?: Maybe<Array<Maybe<MockTest>>>;
  myStudyGroup?: Maybe<StudyGroup>;
  /** Get the notifications of the logged in user as paginated */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  osceBook?: Maybe<Array<Maybe<OsceStation>>>;
  osceChatMessages: Array<OsceMarksheetMessage>;
  osceMarksheet?: Maybe<OsceMarksheet>;
  osceMarksheets?: Maybe<OsceMarksheetsList>;
  osceMarksheetsWindow?: Maybe<PaginatedOsceMarksheet>;
  osceStation?: Maybe<OsceStation>;
  osceStationReplication?: Maybe<Array<Maybe<OsceStation>>>;
  osceStations?: Maybe<Array<Maybe<OsceStation>>>;
  osceStats?: Maybe<OsceStats>;
  osceTopics?: Maybe<Array<Maybe<Topic>>>;
  paceBook?: Maybe<Array<Maybe<Concept>>>;
  /** preBuildMarksheet is a way to pre build the marksheet */
  preBuildMarksheet?: Maybe<PreBuildMarksheet>;
  preBuildTodo?: Maybe<PreBuildTodo>;
  /**
   * 2026 twin of preBuildUkmlaMarksheet. Separate query, separate argument names:
   * 2026 ids passed to the legacy query would silently match unrelated legacy rows.
   */
  preBuildUkmla2026Marksheet?: Maybe<PreBuildMarksheet>;
  /** @deprecated Legacy UKMLA content map. Use preBuildUkmla2026Marksheet instead */
  preBuildUkmlaMarksheet?: Maybe<PreBuildMarksheet>;
  preDefinedPresets?: Maybe<Array<Maybe<Preset>>>;
  prescriptions?: Maybe<PrescriptionResult>;
  preset?: Maybe<Preset>;
  presets?: Maybe<Array<Maybe<Preset>>>;
  productStats?: Maybe<ProductStats>;
  quesBook?: Maybe<Array<Maybe<Topic>>>;
  /** It is a way to get data of the question */
  question?: Maybe<Question>;
  questionCommentsList: QuestionCommentList;
  recordReports: RecordReportList;
  recordReview?: Maybe<RecordReview>;
  recordReviews: RecordReviewList;
  /** Share of users per average-score bucket - question score for qbank products, station marksheet score for OSCE/PLAB2/PACES */
  scoreDistribution: ScoreDistribution;
  searchOsceStations?: Maybe<Array<Maybe<OsceStation>>>;
  stationNotes?: Maybe<Array<Maybe<UserStationNote>>>;
  studyGroupStartEligibility: StudyGroupStartEligibility;
  testBook?: Maybe<Array<Maybe<Topic>>>;
  todo?: Maybe<Todo>;
  topic?: Maybe<Topic>;
  /** topics filter is based one ETopicTypes */
  topics?: Maybe<Array<Maybe<Topic>>>;
  totalCards?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  tutorConversation?: Maybe<TutorConversation>;
  ucatAnalytics?: Maybe<Array<Maybe<UcatAnalytics>>>;
  ucatMockPerformance?: Maybe<Array<Maybe<UcatMockStats>>>;
  ucatOverallPerformance?: Maybe<Array<Maybe<UcatOverallStats>>>;
  ucatSectionPerformance?: Maybe<Array<Maybe<UcatSectionStats>>>;
  ucatThemeAnalytics?: Maybe<UcatThemeAnalytics>;
  /** The 2026 content map's Areas of Practice tab. Ordered by sortOrder; items A-Z. */
  ukmlaAreas?: Maybe<Array<Maybe<Ukmla2026Area>>>;
  /** The 2026 content map's Conditions by Body System tab. Ordered by sortOrder. */
  ukmlaBodySystems?: Maybe<Array<Maybe<Ukmla2026BodySystem>>>;
  /**
   * Every enabled presentation in the 2026 content map, grouped A-Z. Ordered by
   * letter (`#` last), then by name within each group.
   */
  ukmlaPresentations?: Maybe<Array<Maybe<Ukmla2026PresentationLetter>>>;
  /** @deprecated Legacy UKMLA content map. Use ukmlaBodySystems instead */
  ukmlaTopic?: Maybe<UkmlaTopic>;
  /** @deprecated Legacy UKMLA content map. Use ukmlaBodySystems, ukmlaPresentations or ukmlaAreas instead */
  ukmlaTopics?: Maybe<Array<Maybe<UkmlaTopic>>>;
  universityLeaderboard?: Maybe<UniversitiesRankingAndSpeciality>;
  user?: Maybe<User>;
  userActivity?: Maybe<UserActivity>;
  userInfo?: Maybe<User>;
  userStats?: Maybe<UserStats>;
  video?: Maybe<Video>;
  /**
   * Lean video list for the video library — videos for the current product with
   * the entitlement (and topic, for non-station products) they belong to.
   *
   * Pass `watchLater: true` for the user's saved videos, most recently saved
   * first. Any other value returns the whole product library, title-ordered.
   */
  videoLibrary?: Maybe<Array<Maybe<Video>>>;
  videos?: Maybe<Array<Maybe<Video>>>;
  weeklyRecordReview?: Maybe<WeeklyRecordReview>;
  weeklyRecordReviews: WeeklyRecordReviewList;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryActivityHeatmapArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryChapterArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryCircuitArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryCircuitSessionArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryCircuitSessionsArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryCircuitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryConceptArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryConceptNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryConceptsArgs = {
  id: Array<Scalars['Int']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryDashboardOsceArgs = {
  order?: InputMaybe<Scalars['Int']['input']>;
  solo: Scalars['Boolean']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryDropdownOptionsArgs = {
  conditionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  entitlementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  presentationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryFilteredRecordReviewsArgs = {
  options: FilteredRecordReviewOptions;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryFlaggedQuestionsArgs = {
  filter: FlaggedQuestionInput;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryFlaggedQuestionsMarksheetArgs = {
  questionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryGenerateStationStatusArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryHeartbeatArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryHeartbeatQbankArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMarksheetArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMarksheetFeedbackArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMarksheetListArgs = {
  options: MarksheetOptions;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMarksheetsArgs = {
  filter: MarksheetFilterInput;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMarksheetsTrackerArgs = {
  options: MarksheetTrackerOptions;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMarksheetsWindowArgs = {
  filter: MarksheetWindowFilterInput;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMockTestArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMockTestsArgs = {
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryMyStudyGroupArgs = {
  productTypeId: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryNotificationsArgs = {
  filter?: InputMaybe<NotificationFilterInput>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceBookArgs = {
  videosOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceChatMessagesArgs = {
  osceMarksheetId: Scalars['Int']['input'];
  phase?: InputMaybe<Array<OsceStationPhase>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceMarksheetArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceMarksheetsArgs = {
  options: OsceMarksheetOptions;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceMarksheetsWindowArgs = {
  filter: OsceMarksheetWindowFilterInput;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceStationArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceStationReplicationArgs = {
  lastId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  minUpdatedAt: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceStationsArgs = {
  attempted?: InputMaybe<Scalars['Boolean']['input']>;
  difficulty?: InputMaybe<Array<Scalars['Int']['input']>>;
  solo: Scalars['Boolean']['input'];
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryOsceStatsArgs = {
  solo: Scalars['Boolean']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryPreBuildMarksheetArgs = {
  conceptIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  difficulty?: InputMaybe<Array<Scalars['Int']['input']>>;
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  useAI?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryPreBuildTodoArgs = {
  conceptIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryPreBuildUkmla2026MarksheetArgs = {
  areaConditions?: InputMaybe<Array<Ukmla2026AreaItemInput>>;
  areaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  areaPresentations?: InputMaybe<Array<Ukmla2026AreaItemInput>>;
  bodySystemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  difficulty?: InputMaybe<Array<Scalars['Int']['input']>>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  presentationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  useAI?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryPreBuildUkmlaMarksheetArgs = {
  conditionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  difficulty?: InputMaybe<Array<Scalars['Int']['input']>>;
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
  presentationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  useAI?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryPreDefinedPresetsArgs = {
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryPrescriptionsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryPresetArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryPresetsArgs = {
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryProductStatsArgs = {
  entitlementId?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryQuesBookArgs = {
  typeId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  videosOnly?: InputMaybe<Scalars['Boolean']['input']>;
  withCards?: InputMaybe<Scalars['Boolean']['input']>;
  withQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  withVideos?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryQuestionArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryQuestionCommentsListArgs = {
  options: QuestionCommentListOptions;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryRecordReportsArgs = {
  options: RecordReportOptions;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryRecordReviewArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryRecordReviewsArgs = {
  options: RecordReviewOptions;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryScoreDistributionArgs = {
  compareClassYear?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQuerySearchOsceStationsArgs = {
  search: Scalars['String']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryStationNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryStudyGroupStartEligibilityArgs = {
  productTypeId: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryTestBookArgs = {
  entitlementId?: InputMaybe<Scalars['ID']['input']>;
  videosOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryTodoArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryTopicArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryTopicsArgs = {
  filter: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  withCards?: InputMaybe<Scalars['Boolean']['input']>;
  withQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  withVideos?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryTutorConversationArgs = {
  marksheetId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUcatAnalyticsArgs = {
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUcatMockPerformanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mockTypeId?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUcatOverallPerformanceArgs = {
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUcatSectionPerformanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mockTypeId?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUcatThemeAnalyticsArgs = {
  entitlementId?: InputMaybe<Scalars['Int']['input']>;
  themeId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUkmlaTopicArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUkmlaTopicsArgs = {
  order?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUniversityLeaderboardArgs = {
  limit: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUserActivityArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUserInfoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryUserStatsArgs = {
  classYear?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryVideoArgs = {
  id: Scalars['Int']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryVideoLibraryArgs = {
  watchLater?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryVideosArgs = {
  filter: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  platform: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryWeeklyRecordReviewArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Restricted queries requiring the header
 * {"Authorization": "Bearer JWT"}
 */
export type RestrictedQueryWeeklyRecordReviewsArgs = {
  options: WeeklyRecordReviewOptions;
};

export type ResultData = {
  __typename?: 'ResultData';
  batchId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  logFile?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  recordIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Revenue = {
  __typename?: 'Revenue';
  breakdown?: Maybe<Array<Maybe<Revenue>>>;
  duration?: Maybe<Scalars['Int']['output']>;
  entitlement?: Maybe<Entitlement>;
  invoiceCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subscriptionCount?: Maybe<Scalars['Int']['output']>;
  subscriptionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalEarning?: Maybe<Scalars['Float']['output']>;
};

export type ReviewData = {
  __typename?: 'ReviewData';
  average?: Maybe<Scalars['Float']['output']>;
  reviews?: Maybe<Array<Maybe<ProductFeedback>>>;
  spends?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type Route = {
  __typename?: 'Route';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

/** Collection of sample content for users to try */
export type SampleContent = {
  __typename?: 'SampleContent';
  marksheets?: Maybe<Array<Maybe<Marksheet>>>;
  osceMarksheets?: Maybe<Array<Maybe<OsceMarksheet>>>;
  todos?: Maybe<Array<Maybe<Todo>>>;
};

export type SampleQuizHighYieldFact = {
  __typename?: 'SampleQuizHighYieldFact';
  concept: Scalars['String']['output'];
  fact: Scalars['String']['output'];
  topic: Scalars['String']['output'];
  whyItMatters?: Maybe<Scalars['String']['output']>;
};

export type SampleQuizMark = {
  __typename?: 'SampleQuizMark';
  id: Scalars['Int']['output'];
  mark?: Maybe<Scalars['String']['output']>;
  questionChoiceId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Int']['output']>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
};

/** Partial MarksheetMark — same field names as MarksheetMark, only answer fields from FE */
export type SampleQuizMarkInput = {
  id: Scalars['Int']['input'];
  mark?: InputMaybe<Scalars['String']['input']>;
  questionChoiceId?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['Int']['input']>;
  timeTaken?: InputMaybe<Scalars['Int']['input']>;
};

export type SampleQuizReport = {
  __typename?: 'SampleQuizReport';
  attempted: Scalars['Int']['output'];
  band?: Maybe<Scalars['String']['output']>;
  correct: Scalars['Int']['output'];
  coverageTier: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  headline: Scalars['String']['output'];
  highYieldFacts: Array<SampleQuizHighYieldFact>;
  id: Scalars['UUID']['output'];
  marks: Array<SampleQuizMark>;
  marksheetId: Scalars['ID']['output'];
  paperLength: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  promoCode?: Maybe<Scalars['String']['output']>;
  promoExpiresAt?: Maybe<Scalars['Date']['output']>;
  recommendedFocus: Array<Scalars['String']['output']>;
  scorePercentage: Scalars['Float']['output'];
  strengths: Array<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  topicBreakdown: Array<SampleQuizTopicBreakdown>;
  weaknesses: Array<Scalars['String']['output']>;
};

export type SampleQuizTopicBreakdown = {
  __typename?: 'SampleQuizTopicBreakdown';
  attempted: Scalars['Int']['output'];
  correct: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
  percentage: Scalars['Float']['output'];
  topic: Scalars['String']['output'];
};

/** SaveMarksheetInput is used when answering a question */
export type SaveMarksheetInput = {
  /** choiceId is only used by typeId=1 (SBA questions) */
  choiceId?: InputMaybe<Scalars['Int']['input']>;
  /** mark is a JSON.stringify() of the MarksheetMark.mark */
  mark?: InputMaybe<Scalars['String']['input']>;
  markId: Scalars['Int']['input'];
  marksheetId: Scalars['Int']['input'];
  /** time taken to answer in seconds */
  timeTaken: Scalars['Int']['input'];
};

export type ScoreDistribution = {
  __typename?: 'ScoreDistribution';
  /** Always 10 buckets, ascending */
  buckets: Array<ScoreDistributionBucket>;
  /** Class year cohort applied, null when compared against everyone */
  classYear?: Maybe<Scalars['String']['output']>;
  meanScore?: Maybe<Scalars['Float']['output']>;
  totalUsers: Scalars['Int']['output'];
  /** Bucket the requesting user falls in, null when they have no attempts */
  userBucket?: Maybe<Scalars['Int']['output']>;
  /** Requesting user's average score, null when they have no attempts */
  userScore?: Maybe<Scalars['Float']['output']>;
};

export type ScoreDistributionBucket = {
  __typename?: 'ScoreDistributionBucket';
  /** Upper bound of the bucket in percent: 10, 20, ... 100 */
  bucket: Scalars['Int']['output'];
  /** Percentage of users in this bucket (0-100) */
  share: Scalars['Float']['output'];
  users: Scalars['Int']['output'];
};

export type SendgridList = {
  __typename?: 'SendgridList';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StationMarkChoice = {
  __typename?: 'StationMarkChoice';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type Stats = {
  __typename?: 'Stats';
  count?: Maybe<Scalars['Int']['output']>;
  firstAttemptScore?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastEditScore?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  voteScore?: Maybe<Scalars['Float']['output']>;
};

export type StudyGroup = {
  __typename?: 'StudyGroup';
  closedAt?: Maybe<Scalars['Date']['output']>;
  closesAt: Scalars['Date']['output'];
  code: Scalars['String']['output'];
  currentPercent: Scalars['Int']['output'];
  finalPercent?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** True once the close-out job has fixed finalPercent and queued refunds */
  isFinalised: Scalars['Boolean']['output'];
  isOrganiser: Scalars['Boolean']['output'];
  maxMembers: Scalars['Int']['output'];
  me: StudyGroupMyMembership;
  memberCount: Scalars['Int']['output'];
  members: Array<StudyGroupMember>;
  opensAt: Scalars['Date']['output'];
  /** Every public plan of the product; joiners can buy any of them */
  plans: Array<StudyGroupProduct>;
  /** Product type name, e.g. MRCP PACES Video Course */
  productName: Scalars['String']['output'];
  productTypeId: Scalars['Int']['output'];
  /** CLOSED as soon as closesAt passes, even before the close-out job has run */
  status: StudyGroupStatus;
  tiers: Array<GroupDiscountTier>;
};

export type StudyGroupAdmin = {
  __typename?: 'StudyGroupAdmin';
  closedAt?: Maybe<Scalars['Date']['output']>;
  closesAt: Scalars['Date']['output'];
  code: Scalars['String']['output'];
  failedRefundAmount: Scalars['Int']['output'];
  hasRefundProblem: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  maxMembers: Scalars['Int']['output'];
  memberCount: Scalars['Int']['output'];
  /** Only filled by studyGroup(id) */
  members?: Maybe<Array<StudyGroupAdminMember>>;
  opensAt: Scalars['Date']['output'];
  organiser: StudyGroupAdminUser;
  percent: Scalars['Int']['output'];
  /** Every public plan of the product; joiners can buy any of them */
  plans: Array<StudyGroupProduct>;
  /** Product type name, e.g. MRCP PACES Video Course */
  productName: Scalars['String']['output'];
  productTypeId: Scalars['Int']['output'];
  refundedAmount: Scalars['Int']['output'];
  status: StudyGroupStatus;
  tiers: Array<GroupDiscountTier>;
};

export type StudyGroupAdminFilter = {
  openedWithinDays?: InputMaybe<Scalars['Int']['input']>;
  productTypeId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StudyGroupAdminStatus>;
};

export type StudyGroupAdminList = {
  __typename?: 'StudyGroupAdminList';
  items: Array<StudyGroupAdmin>;
  total: Scalars['Int']['output'];
};

export type StudyGroupAdminMember = {
  __typename?: 'StudyGroupAdminMember';
  amountPaid: Scalars['Int']['output'];
  checkoutSessionId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  joinedAt: Scalars['Date']['output'];
  paidAt?: Maybe<Scalars['Date']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentSource: Scalars['String']['output'];
  /** The plan they paid for (an organiser's may be a bundle) */
  product?: Maybe<StudyGroupProduct>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refundAttempts: Scalars['Int']['output'];
  refundError?: Maybe<Scalars['String']['output']>;
  refundReference?: Maybe<Scalars['String']['output']>;
  refundStatus: StudyGroupRefundStatus;
  refundType: StudyGroupRefundType;
  refundedAt?: Maybe<Scalars['Date']['output']>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  role: StudyGroupMemberRole;
  status: StudyGroupMemberStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  user: StudyGroupAdminUser;
};

export type StudyGroupAdminStats = {
  __typename?: 'StudyGroupAdminStats';
  /** Closed groups only */
  averageFinalSize?: Maybe<Scalars['Float']['output']>;
  closedCount: Scalars['Int']['output'];
  /** All active members, organisers included */
  customersThroughGroups: Scalars['Int']['output'];
  failedRefundTotal: Scalars['Int']['output'];
  groupsStarted: Scalars['Int']['output'];
  joinedViaLink: Scalars['Int']['output'];
  openCount: Scalars['Int']['output'];
  refundedTotal: Scalars['Int']['output'];
};

export enum StudyGroupAdminStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  REFUND_PROBLEM = 'REFUND_PROBLEM'
}

export type StudyGroupAdminUser = {
  __typename?: 'StudyGroupAdminUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
};

export type StudyGroupDiscountsOverTimePoint = {
  __typename?: 'StudyGroupDiscountsOverTimePoint';
  /** YYYY-MM-DD, or YYYY-MM for wide ranges */
  date: Scalars['String']['output'];
  /** Refunds owed when groups closed, by close date (pence) */
  offered: Scalars['Int']['output'];
  /** Refunds actually paid out, by refund date (pence) */
  refunded: Scalars['Int']['output'];
};

export type StudyGroupInvite = {
  __typename?: 'StudyGroupInvite';
  closesAt: Scalars['Date']['output'];
  code: Scalars['String']['output'];
  currentPercent: Scalars['Int']['output'];
  maxMembers: Scalars['Int']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<StudyGroupInviteMember>;
  opensAt: Scalars['Date']['output'];
  organiserFirstName: Scalars['String']['output'];
  percentIfJoin: Scalars['Int']['output'];
  /** Every public plan of the product; joiners can buy any of them */
  plans: Array<StudyGroupProduct>;
  /** Product type name, e.g. MRCP PACES Video Course */
  productName: Scalars['String']['output'];
  productTypeId: Scalars['Int']['output'];
  /** At least this much back: estimate on the cheapest plan's list price; the real refund uses what was actually paid */
  refundIfJoin: Scalars['Int']['output'];
  state: StudyGroupInviteState;
  tiers: Array<GroupDiscountTier>;
  viewerState: StudyGroupViewerState;
};

export type StudyGroupInviteMember = {
  __typename?: 'StudyGroupInviteMember';
  firstName: Scalars['String']['output'];
  initials: Scalars['String']['output'];
  isOrganiser: Scalars['Boolean']['output'];
};

export enum StudyGroupInviteState {
  CLOSED = 'CLOSED',
  FULL = 'FULL',
  OPEN = 'OPEN'
}

export type StudyGroupMember = {
  __typename?: 'StudyGroupMember';
  amountPaid: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  initials: Scalars['String']['output'];
  isMe: Scalars['Boolean']['output'];
  joinedAt: Scalars['Date']['output'];
  refundEstimate: Scalars['Int']['output'];
  role: StudyGroupMemberRole;
};

export enum StudyGroupMemberRole {
  MEMBER = 'MEMBER',
  ORGANISER = 'ORGANISER'
}

export enum StudyGroupMemberStatus {
  ACTIVE = 'ACTIVE',
  /** Paid through the link but couldn't be counted — kept their purchase at full price */
  REJECTED = 'REJECTED'
}

export type StudyGroupMyMembership = {
  __typename?: 'StudyGroupMyMembership';
  amountPaid: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['Date']['output']>;
  /** Stripe-hosted receipt (payment + refund, has a PDF download). Set once the refund succeeds */
  receiptUrl?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  /** At the current (or final) percent */
  refundEstimate: Scalars['Int']['output'];
  refundStatus: StudyGroupRefundStatus;
  refundType: StudyGroupRefundType;
  refundedAt?: Maybe<Scalars['Date']['output']>;
  role: StudyGroupMemberRole;
};

export type StudyGroupProduct = {
  __typename?: 'StudyGroupProduct';
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  interval: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Stripe unit amount in pence */
  price: Scalars['Int']['output'];
  stripePriceId: Scalars['String']['output'];
  typeId: Scalars['Int']['output'];
};

export enum StudyGroupRefundStatus {
  FAILED = 'FAILED',
  MANUAL = 'MANUAL',
  NONE = 'NONE',
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED'
}

export enum StudyGroupRefundType {
  /** Reserved for app-store subscribers (Stripe account credit) — not issued yet */
  CREDIT = 'CREDIT',
  /** Partial refund to the card */
  REFUND = 'REFUND'
}

export enum StudyGroupStartBlocker {
  ALREADY_IN_GROUP = 'ALREADY_IN_GROUP',
  /** Only an app-store (iOS/Android) subscription — groups need a website (Stripe) purchase for now */
  APP_STORE_SUBSCRIPTION = 'APP_STORE_SUBSCRIPTION',
  NOT_ENABLED = 'NOT_ENABLED',
  NO_ACTIVE_SUBSCRIPTION = 'NO_ACTIVE_SUBSCRIPTION',
  /** Active subscription was granted or free — nothing to refund against */
  UNREFUNDABLE_SUBSCRIPTION = 'UNREFUNDABLE_SUBSCRIPTION'
}

export type StudyGroupStartEligibility = {
  __typename?: 'StudyGroupStartEligibility';
  blocker?: Maybe<StudyGroupStartBlocker>;
  canStart: Scalars['Boolean']['output'];
  /** The product's offer, when it's enabled */
  offer?: Maybe<GroupDiscountOffer>;
};

export enum StudyGroupStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export type StudyGroupUsageByProduct = {
  __typename?: 'StudyGroupUsageByProduct';
  groups: Scalars['Int']['output'];
  /** People counted in those groups, organisers included */
  members: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productTypeId: Scalars['Int']['output'];
  /** Pence */
  refunded: Scalars['Int']['output'];
};

export enum StudyGroupViewerState {
  ALREADY_MEMBER = 'ALREADY_MEMBER',
  /** No (valid) token sent */
  ANONYMOUS = 'ANONYMOUS',
  ELIGIBLE = 'ELIGIBLE',
  /** Has paid for this product (any plan, or a bundle that includes it) before — can't join; other products don't count */
  HAS_PRODUCT = 'HAS_PRODUCT',
  /** Already in another group for this product type */
  IN_OTHER_GROUP = 'IN_OTHER_GROUP'
}

export type StudyGroupsOverTimePoint = {
  __typename?: 'StudyGroupsOverTimePoint';
  /** YYYY-MM-DD, or YYYY-MM for wide ranges */
  date: Scalars['String']['output'];
  groupsStarted: Scalars['Int']['output'];
  /** People who joined through a link (organisers not included) */
  membersJoined: Scalars['Int']['output'];
};

export type SubmitSampleQuizReportInput = {
  email: Scalars['String']['input'];
  marks: Array<SampleQuizMarkInput>;
  marksheetId: Scalars['ID']['input'];
  productId: Scalars['Int']['input'];
  /** refId (from the sampleMarksheet/saveSampleQuizMark attempt) attaches AI-report diagnostics to that same marksheet_ai_logs row instead of creating a new one */
  refId?: InputMaybe<Scalars['UUID']['input']>;
  reportPath: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  classYear?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endedAt?: Maybe<Scalars['Date']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiced?: Maybe<Scalars['Float']['output']>;
  /** onMarksheetChange is a way to let all group devices know about change in marksheet data */
  onMarksheetChange?: Maybe<MarksheetInfo>;
  /** onMarksheetMarkChange is a way to let all group devices know about change in marksheet mark data */
  onMarksheetMarkChange?: Maybe<MarksheetMarkInfo>;
  /** onNotificationArise is a way to let latest notifications fetch */
  onNotificationArise?: Maybe<Array<Maybe<Notification>>>;
  /** onPreStartMarksheetChange is a way to let all group devices know about selection of preStart marksheet data */
  onPreStartMarksheetChange?: Maybe<PreStartMarksheetInfo>;
  osceChatStream?: Maybe<OsceChatStreamChunk>;
  /**
   * osceMarksheetActions is a way to let all group devices know when the
   * station has had a START, PAUSE, STOP, CONNECT or DISCONNECT action
   */
  osceMarksheetAction?: Maybe<OsceMarksheetAction>;
  /** osceMarksheetTimer provide a unified timer for all clients */
  osceMarksheetTimer?: Maybe<OsceTimer>;
  /**
   * osceMatchmaking is the way of letting users know when they have matched
   * into an OSCE group
   */
  osceMatchmaking?: Maybe<OsceMatchmakingAction>;
  /** osceMatchmakingUsers count of users currently looking for matchmaking */
  osceMatchmakingUsers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  osceRoleChange?: Maybe<OsceGroup>;
  periodEndAt?: Maybe<Scalars['Date']['output']>;
  product?: Maybe<ProductSubscription>;
  productId?: Maybe<Scalars['Int']['output']>;
  purchaseSource?: Maybe<Scalars['Int']['output']>;
  renewedAt?: Maybe<Scalars['Date']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};


export type SubscriptionOnMarksheetChangeArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionOnMarksheetMarkChangeArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionOnNotificationAriseArgs = {
  userId: Scalars['Int']['input'];
};


export type SubscriptionOnPreStartMarksheetChangeArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionOsceChatStreamArgs = {
  osceMarksheetId: Scalars['Int']['input'];
  phase?: InputMaybe<OsceStationPhase>;
};


export type SubscriptionOsceMarksheetActionArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionOsceMarksheetTimerArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionOsceMatchmakingArgs = {
  userId: Scalars['Int']['input'];
};


export type SubscriptionOsceRoleChangeArgs = {
  sessionId: Scalars['String']['input'];
};

/** SupportTicket is part of the feedback mutation */
export type SupportTicket = {
  attachments: Array<InputMaybe<Attachment>>;
  text: Scalars['String']['input'];
};

/** Theme for UCAT questions */
export type Theme = {
  __typename?: 'Theme';
  createdAt?: Maybe<Scalars['Date']['output']>;
  entitlement?: Maybe<Entitlement>;
  entitlementId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TimeSeriesData = {
  __typename?: 'TimeSeriesData';
  count?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Array<Maybe<TimeSeriesProductStats>>>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TimeSeriesProductStats = {
  __typename?: 'TimeSeriesProductStats';
  count?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Entitlement>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Todo is a collection of Cards */
export type Todo = {
  __typename?: 'Todo';
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyTask?: Maybe<Scalars['Boolean']['output']>;
  entitlementId?: Maybe<Scalars['Int']['output']>;
  greenCards?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  marks?: Maybe<Array<Maybe<TodoMark>>>;
  productId?: Maybe<Scalars['Int']['output']>;
  redCards?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<Topic>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  yellowCards?: Maybe<Scalars['Int']['output']>;
};

/** TodoInput is used when answering a card */
export type TodoInput = {
  markId: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
  /** time taken to answer in seconds */
  timeTaken: Scalars['Int']['input'];
  todoId: Scalars['Int']['input'];
};

/** TodoMark is the saved user answer when answering a Card */
export type TodoMark = {
  __typename?: 'TodoMark';
  card?: Maybe<Card>;
  cardId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  /** time taken to answer in seconds */
  timeTaken?: Maybe<Scalars['Int']['output']>;
  todoId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ToggleStrikeOptionsInput = {
  markId: Scalars['Int']['input'];
  marksheetId: Scalars['Int']['input'];
  striked: Array<InputMaybe<Scalars['Int']['input']>>;
};

/** Token is used for mobile push notifications */
export type Token = {
  __typename?: 'Token';
  createdAt?: Maybe<Scalars['Date']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Topics are the main chapters for Quesbook e.g. Cardiology */
export type Topic = {
  __typename?: 'Topic';
  completedConcepts?: Maybe<Scalars['Int']['output']>;
  completedVideos?: Maybe<Scalars['Int']['output']>;
  concepts?: Maybe<Array<Maybe<Concept>>>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyFeedCards?: Maybe<Scalars['Int']['output']>;
  /** specify if topic available for demo mode */
  demo?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Int']['output']>;
  entitlement?: Maybe<Entitlement>;
  entitlementId?: Maybe<Scalars['Int']['output']>;
  greenCards?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redCards?: Maybe<Scalars['Int']['output']>;
  revisingConcepts?: Maybe<Scalars['Int']['output']>;
  revisingVideos?: Maybe<Scalars['Int']['output']>;
  totalCards?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  totalVideos?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<TopicType>;
  /** typeId is based on ETopicType */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** concept status aggregation counts */
  unreadConcepts?: Maybe<Scalars['Int']['output']>;
  /** video status aggregation counts */
  unwatchedVideos?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  urgentConcepts?: Maybe<Scalars['Int']['output']>;
  urgentVideos?: Maybe<Scalars['Int']['output']>;
  videos?: Maybe<Array<Maybe<Video>>>;
  yellowCards?: Maybe<Scalars['Int']['output']>;
};


/** Topics are the main chapters for Quesbook e.g. Cardiology */
export type TopicConceptsArgs = {
  withCards?: InputMaybe<Scalars['Boolean']['input']>;
  withQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  withVideos?: InputMaybe<Scalars['Boolean']['input']>;
};

/** TopicType is based on ETopicType */
export type TopicType = {
  __typename?: 'TopicType';
  completedQuestions?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  dailyFeedCards?: Maybe<Scalars['Int']['output']>;
  greenCards?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redCards?: Maybe<Scalars['Int']['output']>;
  topics?: Maybe<Array<Maybe<Topic>>>;
  totalCards?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  yellowCards?: Maybe<Scalars['Int']['output']>;
};

export type TutorAdminMessage = {
  __typename?: 'TutorAdminMessage';
  blocks: Scalars['JSON']['output'];
  cachedTokens: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  llmCostUsd: Scalars['Float']['output'];
  llmError?: Maybe<Scalars['Boolean']['output']>;
  llmInferenceMs?: Maybe<Scalars['Int']['output']>;
  llmTtftMs?: Maybe<Scalars['Int']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  outputTokens: Scalars['Int']['output'];
  phase?: Maybe<Scalars['String']['output']>;
  preset?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  reasoningTokens: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  totalTokens: Scalars['Int']['output'];
};

export type TutorAiCostDataPoint = {
  __typename?: 'TutorAiCostDataPoint';
  cost: Scalars['Float']['output'];
  date: Scalars['String']['output'];
};

export type TutorAiCostKpi = {
  __typename?: 'TutorAiCostKpi';
  totalCost: Scalars['Float']['output'];
};

export type TutorAiCostOverTime = {
  __typename?: 'TutorAiCostOverTime';
  kpi: TutorAiCostKpi;
  series: Array<TutorAiCostDataPoint>;
};

export type TutorAiKpiOverview = {
  __typename?: 'TutorAiKpiOverview';
  avgE2eLatencyMs: Scalars['Float']['output'];
  avgFirstTokenMs: Scalars['Float']['output'];
  costPerSession: Scalars['Float']['output'];
  llmCachedTokens: Scalars['Float']['output'];
  llmInputTokens: Scalars['Float']['output'];
  llmOutputTokens: Scalars['Float']['output'];
  llmReasoningTokens: Scalars['Float']['output'];
  timeoutCount: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
  totalMessages: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
  uniqueMarksheets: Scalars['Int']['output'];
  uniqueUsers: Scalars['Int']['output'];
};

export type TutorAiLatencyOverTime = {
  __typename?: 'TutorAiLatencyOverTime';
  kpi: TutorAiTimingKpi;
  percentiles: Array<TutorAiLatencyPercentilePoint>;
  series: Array<TutorAiLatencySeriesPoint>;
};

export type TutorAiLatencyPercentilePoint = {
  __typename?: 'TutorAiLatencyPercentilePoint';
  date: Scalars['String']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
  p99: Scalars['Float']['output'];
};

export type TutorAiLatencySeriesPoint = {
  __typename?: 'TutorAiLatencySeriesPoint';
  date: Scalars['String']['output'];
  e2eLatencyMs: Scalars['Float']['output'];
  firstTokenMs: Scalars['Float']['output'];
};

export type TutorAiMarksheetSession = {
  __typename?: 'TutorAiMarksheetSession';
  conversationCount: Scalars['Int']['output'];
  firstCreatedAt: Scalars['Float']['output'];
  lastActivityAt: Scalars['Float']['output'];
  marksheetId: Scalars['Int']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type TutorAiMarksheetsResult = {
  __typename?: 'TutorAiMarksheetsResult';
  items: Array<TutorAiMarksheetSession>;
  total: Scalars['Int']['output'];
};

export enum TutorAiPhase {
  post_answer = 'post_answer',
  pre_answer = 'pre_answer'
}

export type TutorAiSessionsByProduct = {
  __typename?: 'TutorAiSessionsByProduct';
  count: Scalars['Int']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
};

export type TutorAiSessionsDataPoint = {
  __typename?: 'TutorAiSessionsDataPoint';
  date: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type TutorAiSessionsKpi = {
  __typename?: 'TutorAiSessionsKpi';
  totalCount: Scalars['Int']['output'];
};

export type TutorAiSessionsOverTime = {
  __typename?: 'TutorAiSessionsOverTime';
  kpi: TutorAiSessionsKpi;
  series: Array<TutorAiSessionsDataPoint>;
};

export type TutorAiTimeoutsDataPoint = {
  __typename?: 'TutorAiTimeoutsDataPoint';
  date: Scalars['String']['output'];
  timeoutCount: Scalars['Int']['output'];
  timeoutDistinctSessionCount: Scalars['Int']['output'];
};

export type TutorAiTimeoutsKpi = {
  __typename?: 'TutorAiTimeoutsKpi';
  timeoutCount: Scalars['Int']['output'];
  timeoutDistinctSessionCount: Scalars['Int']['output'];
};

export type TutorAiTimeoutsOverTime = {
  __typename?: 'TutorAiTimeoutsOverTime';
  kpi: TutorAiTimeoutsKpi;
  series: Array<TutorAiTimeoutsDataPoint>;
};

export type TutorAiTimingKpi = {
  __typename?: 'TutorAiTimingKpi';
  e2eLatencyMs: Scalars['Float']['output'];
  firstTokenMs: Scalars['Float']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
  p99: Scalars['Float']['output'];
};

export type TutorAiTokenByPhase = {
  __typename?: 'TutorAiTokenByPhase';
  cachedTokens: Scalars['Float']['output'];
  inputTokens: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
  phase: TutorAiPhase;
  reasoningTokens: Scalars['Float']['output'];
};

export type TutorAiTokensDataPoint = {
  __typename?: 'TutorAiTokensDataPoint';
  cachedTokens: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  inputTokens: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
  reasoningTokens: Scalars['Float']['output'];
};

export type TutorAiTokensKpi = {
  __typename?: 'TutorAiTokensKpi';
  cachedTokens: Scalars['Float']['output'];
  inputTokens: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
  reasoningTokens: Scalars['Float']['output'];
};

export type TutorAiTokensOverTime = {
  __typename?: 'TutorAiTokensOverTime';
  kpi: TutorAiTokensKpi;
  series: Array<TutorAiTokensDataPoint>;
};

/**
 * One ordered piece of an assistant message; only the fields for `type` are populated.
 * There is no separate markdown or diagram block — TEXT content IS markdown, so fenced
 * blocks (mermaid, latex, vega-lite) and :::directives all ride inside it.
 */
export type TutorBlock = {
  __typename?: 'TutorBlock';
  /** QUIZ / HINT / FOLLOW_UP — stable handle, unique within this message */
  blockId?: Maybe<Scalars['String']['output']>;
  /** TEXT — markdown */
  content?: Maybe<Scalars['String']['output']>;
  /** Escape hatch for future block kinds — no schema change needed */
  data?: Maybe<Scalars['JSON']['output']>;
  followUps?: Maybe<Array<TutorOption>>;
  hints?: Maybe<Array<TutorHint>>;
  options?: Maybe<Array<TutorOption>>;
  prompt?: Maybe<Scalars['String']['output']>;
  /** Populated only once answered */
  result?: Maybe<TutorQuizResult>;
  type: TutorBlockType;
};

export enum TutorBlockType {
  FOLLOW_UP = 'FOLLOW_UP',
  HINT = 'HINT',
  QUIZ = 'QUIZ',
  TEXT = 'TEXT'
}

export type TutorConversation = {
  __typename?: 'TutorConversation';
  createdAt: Scalars['Date']['output'];
  /** Null until the learner answers the survey */
  feedback?: Maybe<TutorFeedback>;
  id: Scalars['ID']['output'];
  lastActivityAt?: Maybe<Scalars['Date']['output']>;
  marksheetId?: Maybe<Scalars['Int']['output']>;
  messages: Array<TutorMessage>;
  questionId?: Maybe<Scalars['Int']['output']>;
  resources: Array<TutorResource>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TutorConversationDetail = {
  __typename?: 'TutorConversationDetail';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  lastActivityAt?: Maybe<Scalars['Date']['output']>;
  marksheetId?: Maybe<Scalars['Int']['output']>;
  messages: Array<TutorAdminMessage>;
  productId?: Maybe<Scalars['Int']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type TutorConversationSummary = {
  __typename?: 'TutorConversationSummary';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  lastActivityAt?: Maybe<Scalars['Date']['output']>;
  messageCount: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** The session survey — "was this useful, how are we doing". */
export type TutorFeedback = {
  __typename?: 'TutorFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  /** 1-5 */
  rating?: Maybe<Scalars['Int']['output']>;
};

export type TutorFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};

/** One rung of a hint ladder, in order. `text` is null until this rung is revealed. */
export type TutorHint = {
  __typename?: 'TutorHint';
  id: Scalars['String']['output'];
  revealedAt?: Maybe<Scalars['Date']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TutorMessage = {
  __typename?: 'TutorMessage';
  blocks: Array<TutorBlock>;
  conversationId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  phase?: Maybe<TutorPhase>;
  preset?: Maybe<TutorPreset>;
  ratedAt?: Maybe<Scalars['Date']['output']>;
  /** Thumbs this user left on the message; null when unrated */
  rating?: Maybe<TutorRating>;
  /** human | ai | system — matches osce_marksheet_messages */
  role: Scalars['String']['output'];
};

export type TutorOption = {
  __typename?: 'TutorOption';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum TutorPhase {
  POST_ANSWER = 'POST_ANSWER',
  PRE_ANSWER = 'PRE_ANSWER'
}

export enum TutorPreset {
  ELI5 = 'ELI5',
  EXAM_TECHNIQUE = 'EXAM_TECHNIQUE',
  NONE = 'NONE',
  SOCRATIC = 'SOCRATIC',
  STUDY_MODE = 'STUDY_MODE'
}

export type TutorQuizResult = {
  __typename?: 'TutorQuizResult';
  answeredAt?: Maybe<Scalars['Date']['output']>;
  correct?: Maybe<Scalars['Boolean']['output']>;
  /** Which option was right. Withheld until the learner answers. */
  correctOptionId?: Maybe<Scalars['String']['output']>;
  /** Withheld until the learner answers */
  rationale?: Maybe<Scalars['String']['output']>;
  selectedOptionId?: Maybe<Scalars['String']['output']>;
};

export enum TutorRating {
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE'
}

/** Something this conversation is grounded in — shown on the Resources tab. */
export type TutorResource = {
  __typename?: 'TutorResource';
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** quiz_question | quesbook | image | video | external — a string, not an enum, so new kinds need no schema change */
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** A quick-reply suggestion shown when a student opens the tutor on a question, before any message exists. */
export type TutorSuggestion = {
  __typename?: 'TutorSuggestion';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  source: TutorSuggestionSource;
  type: Scalars['Int']['output'];
  /** 0 for a GENERIC suggestion — not DB-backed, never actually tracked. */
  usageCount: Scalars['Int']['output'];
};

/** Admin-authored/edited suggestion. Omit `id` for a new one; pass it back to update an existing row in place (preserves its usageCount). */
export type TutorSuggestionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  type: Scalars['Int']['input'];
};

export enum TutorSuggestionSource {
  GENERATED = 'GENERATED',
  GENERIC = 'GENERIC'
}

export type UcatAnalytics = {
  __typename?: 'UcatAnalytics';
  avgScore?: Maybe<Scalars['Float']['output']>;
  avgTimeTaken?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  stats?: Maybe<Array<Maybe<UcatAnalyticsStats>>>;
  timeTaken?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UcatAnalyticsStats = {
  __typename?: 'UcatAnalyticsStats';
  avgScore?: Maybe<Scalars['Float']['output']>;
  avgTimeTaken?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  timeTaken?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum UcatMockAccessArrangement {
  UCAT = 'UCAT',
  UCATSA = 'UCATSA',
  UCATSEN = 'UCATSEN',
  UCATSEN50 = 'UCATSEN50',
  UCATSEN50SA = 'UCATSEN50SA',
  UCATSENSA = 'UCATSENSA'
}

export type UcatMockStats = {
  __typename?: 'UcatMockStats';
  correct?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  partial?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  scaledScore?: Maybe<Scalars['Int']['output']>;
  sjtBand?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type UcatOverallStats = {
  __typename?: 'UcatOverallStats';
  correct?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UcatSectionStats = {
  __typename?: 'UcatSectionStats';
  attempted?: Maybe<Scalars['Int']['output']>;
  correct?: Maybe<Scalars['Int']['output']>;
  entitlementId?: Maybe<Scalars['Int']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  marksheets?: Maybe<Array<Maybe<UcatMockStats>>>;
  partial?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  scaledScore?: Maybe<Scalars['Int']['output']>;
  sjtBand?: Maybe<Scalars['Int']['output']>;
};

export type UcatThemeAnalytics = {
  __typename?: 'UcatThemeAnalytics';
  attempted?: Maybe<Scalars['Int']['output']>;
  correct?: Maybe<Scalars['Int']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  marks?: Maybe<Array<Maybe<MarksheetMark>>>;
  stats?: Maybe<Array<Maybe<UcatThemeStats>>>;
  theme?: Maybe<Theme>;
  total?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UcatThemeStats = {
  __typename?: 'UcatThemeStats';
  attempted?: Maybe<Scalars['Int']['output']>;
  avgScore?: Maybe<Scalars['Float']['output']>;
  correct?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

/**
 * A Quesmed area of clinical practice — our own curated grouping, not a GMC one.
 * Items can sit in several areas; their counts here are specific to this area.
 */
export type Ukmla2026Area = {
  __typename?: 'Ukmla2026Area';
  changeType?: Maybe<Scalars['Int']['output']>;
  conditions?: Maybe<Array<Maybe<Ukmla2026AreaCondition>>>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  /** GMC scope note shown under the area name. */
  descriptor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  legacyNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  presentations?: Maybe<Array<Maybe<Ukmla2026AreaPresentation>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

/** A condition as it appears inside one area. */
export type Ukmla2026AreaCondition = {
  __typename?: 'Ukmla2026AreaCondition';
  areaId?: Maybe<Scalars['Int']['output']>;
  changeType?: Maybe<Scalars['Int']['output']>;
  /** The condition's primary concept only: 0 or 1 element. */
  concepts?: Maybe<Array<Maybe<Concept>>>;
  conditionId?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  legacyNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  questionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

/** One item inside one of the Area. */
export type Ukmla2026AreaItemInput = {
  areaId: Scalars['Int']['input'];
  /** A ukmla_2026 condition or presentation id, depending on the argument it is passed in. */
  itemId: Scalars['Int']['input'];
};

/** A presentation as it appears inside one area. No `id` field, for the same reason as Ukmla2026AreaCondition. */
export type Ukmla2026AreaPresentation = {
  __typename?: 'Ukmla2026AreaPresentation';
  areaId?: Maybe<Scalars['Int']['output']>;
  changeType?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  legacyNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  presentationId?: Maybe<Scalars['Int']['output']>;
  questionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

/** A GMC body system — one of the 24 groups the 2026 content map organises conditions under. */
export type Ukmla2026BodySystem = {
  __typename?: 'Ukmla2026BodySystem';
  conditions?: Maybe<Array<Maybe<Ukmla2026Condition>>>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** GMC Appendix A running order, 1-24. Deliberately not alphabetical. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

export type Ukmla2026Condition = {
  __typename?: 'Ukmla2026Condition';
  bodySystemId?: Maybe<Scalars['Int']['output']>;
  /** 0=unchanged, 1=renamed, 2=new. Drives the `NEW FOR 2026` chip. */
  changeType?: Maybe<Scalars['Int']['output']>;
  concepts?: Maybe<Array<Maybe<Concept>>>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  /** Legacy names that differ from this row's name. Drives the `was ...` subtitle and search aliases. */
  legacyNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  questionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

/** A clinical presentation in the 2026 content map. */
export type Ukmla2026Presentation = {
  __typename?: 'Ukmla2026Presentation';
  /** How this row relates to the legacy content map: 0=unchanged, 1=renamed, 2=new. */
  changeType?: Maybe<Scalars['Int']['output']>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  /** Names this row was known by in the legacy map, where they differ from `name`. Empty when nothing was renamed or merged. */
  legacyNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  questionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

/**
 * An A-Z group of presentations. Derived from the presentation name's first
 * character at query time, not stored.
 */
export type Ukmla2026PresentationLetter = {
  __typename?: 'Ukmla2026PresentationLetter';
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  /** A single upper-case letter, or `#` for names that do not start A-Z. */
  letter?: Maybe<Scalars['String']['output']>;
  presentations?: Maybe<Array<Maybe<Ukmla2026Presentation>>>;
  /**
   * Distinct questions reachable from this group. A question tagged to two
   * presentations in the same group counts once, so this is the size of the set
   * the group resolves to. Summing `presentations` instead over-counts shared tags.
   */
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

export type UkmlaTopic = {
  __typename?: 'UkmlaTopic';
  conditions?: Maybe<Array<Maybe<Condition>>>;
  correctQuestions?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** specify if topic available for demo mode */
  demo?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incorrectQuestions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  presentations?: Maybe<Array<Maybe<Presentation>>>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UniversitiesRankingAndSpeciality = {
  __typename?: 'UniversitiesRankingAndSpeciality';
  month?: Maybe<Array<Maybe<UniversityRankData>>>;
  quarter?: Maybe<Array<Maybe<UniversityRankData>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type University = {
  __typename?: 'University';
  country: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UniversityAccount = {
  __typename?: 'UniversityAccount';
  adminCount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  /** false = the account's university admins cannot log in */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Scopes the university dashboards only; grants students no access */
  products: Array<UniversityAccountProduct>;
  studentCount: Scalars['Int']['output'];
  universityId?: Maybe<Scalars['Int']['output']>;
  universityName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type UniversityAccountAddStudentsResult = {
  __typename?: 'UniversityAccountAddStudentsResult';
  added: Array<Scalars['String']['output']>;
  alreadyMember: Array<Scalars['String']['output']>;
  /** No user with this id or email — nothing is created */
  notFound: Array<Scalars['String']['output']>;
  rejected: Array<UniversityAccountRejectedEntry>;
};

export type UniversityAccountAdmin = {
  __typename?: 'UniversityAccountAdmin';
  createdAt: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type UniversityAccountInput = {
  /** Defaults to true on create; false disables the account */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  products: Array<UniversityAccountProduct>;
  universityId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * University accounts for the admin panel (FINALS only). See docs/university-accounts.md.
 * Reads and writes: SUPER_ADMIN only. University admins log in via Mutation.loginUniversityAdmin.
 */
export enum UniversityAccountProduct {
  OSCE = 'OSCE',
  QBANK = 'QBANK'
}

export type UniversityAccountRejectedEntry = {
  __typename?: 'UniversityAccountRejectedEntry';
  entry: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type UniversityAccountStudent = {
  __typename?: 'UniversityAccountStudent';
  addedAt: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type UniversityAccountStudentsPage = {
  __typename?: 'UniversityAccountStudentsPage';
  rows: Array<UniversityAccountStudent>;
  total: Scalars['Int']['output'];
};

export type UniversityRankData = {
  __typename?: 'UniversityRankData';
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  /** Best speciality aka Topic */
  speciality: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UpdateBlogInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<BlogMetaInput>;
  pictureId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChapterInput = {
  assets?: InputMaybe<Array<AssetInput>>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateJobInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  members?: InputMaybe<Array<JobMemberInput>>;
  metadata?: InputMaybe<JobMetaDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  totalRecords?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateJobRemarkInput = {
  remark?: InputMaybe<Scalars['String']['input']>;
  resolvedAt?: InputMaybe<Scalars['Date']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePromptInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<PromptFormat>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Array<AssetInput>>;
  cases?: InputMaybe<Array<InputMaybe<QuestionCaseInput>>>;
  choices?: InputMaybe<Array<InputMaybe<QuestionChoiceInput>>>;
  conceptId?: InputMaybe<Scalars['Int']['input']>;
  conditionAreaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  conditionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  createRevision?: InputMaybe<Scalars['Boolean']['input']>;
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Int']['input']>;
  entitlements?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  learningPoint?: InputMaybe<Scalars['String']['input']>;
  prescriptions?: InputMaybe<Array<InputMaybe<PrescriptionAnswerInput>>>;
  presentationAreaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  presentationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  stem?: InputMaybe<UpdateChapterInput>;
  tutorSuggestions?: InputMaybe<Array<TutorSuggestionInput>>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRecordReportInput = {
  actionedBy?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<RecordReviewMemberInput>>;
  state?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRecordReviewInput = {
  actionedBy?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Array<RecordReviewMemberInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStationInput = {
  actorBrief?: InputMaybe<Scalars['String']['input']>;
  aiConfig?: InputMaybe<Scalars['JSON']['input']>;
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<Array<AssetInput>>;
  candidateBrief?: InputMaybe<Scalars['String']['input']>;
  clinicalData?: InputMaybe<Scalars['JSON']['input']>;
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Int']['input']>;
  entitlementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  examinerBrief?: InputMaybe<Scalars['String']['input']>;
  examinerQuestions?: InputMaybe<Array<ExaminerQuestionInput>>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  hiddenName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  llmActorBrief?: InputMaybe<Scalars['String']['input']>;
  marks?: InputMaybe<Array<JobStationMarkInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  osceTypeId?: InputMaybe<Scalars['Int']['input']>;
  phaseTimers?: InputMaybe<Scalars['JSON']['input']>;
  pictureId?: InputMaybe<Scalars['Int']['input']>;
  topicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  visibility?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWeeklyRecordReviewInput = {
  actionedBy?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<RecordReviewMemberInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['Int']['input']>;
};

/** UpdatedUserAndJWT contains the user jwt and a separate object with the user data */
export type UpdatedUserAndJwt = {
  __typename?: 'UpdatedUserAndJWT';
  jwt?: Maybe<Scalars['JWT']['output']>;
  user?: Maybe<User>;
};

export type UpsertGroupDiscountConfigInput = {
  enabled: Scalars['Boolean']['input'];
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  productTypeId: Scalars['Int']['input'];
  tiers?: InputMaybe<Array<GroupDiscountTierInput>>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};

/** User account data */
export type User = {
  __typename?: 'User';
  accessLevel?: Maybe<Scalars['String']['output']>;
  accsInterviewSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  anaestheticsInterviewSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  anatomyBundleSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  anatomySubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  bundleSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  classYear?: Maybe<Scalars['String']['output']>;
  completeClinicalBundleSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  completedCards?: Maybe<Array<Maybe<UserCompletedCard>>>;
  completedCardsCount?: Maybe<Scalars['Int']['output']>;
  completedCorrectQuestionsCount?: Maybe<Scalars['Int']['output']>;
  completedGreenCardsCount?: Maybe<Scalars['Int']['output']>;
  completedIncorrectQuestionsCount?: Maybe<Scalars['Int']['output']>;
  completedPartialQuestionsCount?: Maybe<Scalars['Int']['output']>;
  completedQuestions?: Maybe<Array<Maybe<UserCompletedQuestion>>>;
  completedQuestionsCount?: Maybe<Scalars['Int']['output']>;
  completedRedCardsCount?: Maybe<Scalars['Int']['output']>;
  completedYellowCardsCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cstInterviewSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  dailyFeed?: Maybe<Todo>;
  dailyProgress?: Maybe<Array<Maybe<DailyProgress>>>;
  displayName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  graduationYear?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imtInterviewSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  marksheets?: Maybe<Array<Maybe<Marksheet>>>;
  marksheetsCount?: Maybe<Scalars['Int']['output']>;
  medicalSciencesSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  mrcpBundleSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  mrcpPart1SubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  mrcpPart2SubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  mrcpPart2VideoSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  mrcpVideoSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  msraSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  /** Notifications of the user */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  osceSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  pacesSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  paediatricsInterviewSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  plab1SubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  plab2SubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  qbankSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  radiologyInterviewSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  referralCount?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<UserSettings>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Subscriptions of the user */
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  tocAccepted?: Maybe<Scalars['Boolean']['output']>;
  totalCardsCount?: Maybe<Scalars['Int']['output']>;
  totalQuestionsCount?: Maybe<Scalars['Int']['output']>;
  ucatSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  undergradBundleSubscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  university?: Maybe<University>;
  universityId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userProgress?: Maybe<UserProgress>;
  username?: Maybe<Scalars['String']['output']>;
};


/** User account data */
export type UserCompletedCardsArgs = {
  marksheetId?: InputMaybe<Scalars['Int']['input']>;
};


/** User account data */
export type UserDailyProgressArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


/** User account data */
export type UserMarksheetsArgs = {
  options: MarksheetOptions;
};


/** User account data */
export type UserNotificationsArgs = {
  filter?: InputMaybe<NotificationFilterInput>;
};


/** User account data */
export type UserSubscriptionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  avgAttempted?: Maybe<Scalars['Float']['output']>;
  avgScore?: Maybe<Scalars['Float']['output']>;
  currentStreak?: Maybe<Scalars['Int']['output']>;
  dailyProgress?: Maybe<Array<Maybe<DailyProgress>>>;
  longestStreak?: Maybe<Scalars['Int']['output']>;
};

export type UserAdminInput = {
  accessLevel?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserBreakdown = {
  __typename?: 'UserBreakdown';
  classYears?: Maybe<Array<Maybe<BreakdownValue>>>;
  countries?: Maybe<Array<Maybe<BreakdownValue>>>;
  devices?: Maybe<Array<Maybe<BreakdownValue>>>;
  graduations?: Maybe<Array<Maybe<BreakdownValue>>>;
  universities?: Maybe<Array<Maybe<BreakdownValue>>>;
};

export type UserCompletedCard = {
  __typename?: 'UserCompletedCard';
  card?: Maybe<Card>;
  cardId?: Maybe<Scalars['Int']['output']>;
  concept?: Maybe<Concept>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  iteration?: Maybe<Scalars['Int']['output']>;
  lastSeen?: Maybe<Scalars['Date']['output']>;
  optimalFactor?: Maybe<Scalars['Float']['output']>;
  reviewDate?: Maybe<Scalars['Date']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserCompletedQuestion = {
  __typename?: 'UserCompletedQuestion';
  concept?: Maybe<Concept>;
  correct?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserConceptChapter = {
  __typename?: 'UserConceptChapter';
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserConceptNote = {
  __typename?: 'UserConceptNote';
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Concept Status By User */
export type UserConceptStatus = {
  __typename?: 'UserConceptStatus';
  concept?: Maybe<Concept>;
  conceptId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** status is based on EUserLearningStatus */
  status?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserFeedback = {
  __typename?: 'UserFeedback';
  createdAt?: Maybe<Scalars['Date']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Entitlement>;
  productId?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<Scalars['String']['output']>;
};

/** UserFlaggedQuestion is used for users to save questions to return to */
export type UserFlaggedQuestion = {
  __typename?: 'UserFlaggedQuestion';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  markId?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserGlobalSettings = {
  __typename?: 'UserGlobalSettings';
  addToDailyFlashcards?: Maybe<Scalars['Boolean']['output']>;
  dailyFeedMax?: Maybe<Scalars['Int']['output']>;
  dailyFeedResetTime?: Maybe<Scalars['Int']['output']>;
  disabledColors?: Maybe<Scalars['Boolean']['output']>;
  expandedReading?: Maybe<Scalars['Boolean']['output']>;
  readingTextScale?: Maybe<Scalars['Float']['output']>;
  theme?: Maybe<Scalars['Int']['output']>;
};

export type UserGlobalSettingsInput = {
  addToDailyFlashcards?: InputMaybe<Scalars['Boolean']['input']>;
  dailyFeedMax?: InputMaybe<Scalars['Int']['input']>;
  dailyFeedResetTime?: InputMaybe<Scalars['Int']['input']>;
  disabledColors?: InputMaybe<Scalars['Boolean']['input']>;
  expandedReading?: InputMaybe<Scalars['Boolean']['input']>;
  readingTextScale?: InputMaybe<Scalars['Float']['input']>;
  theme?: InputMaybe<Scalars['Int']['input']>;
};

/** UserInput is used on the settings view for updating the user */
export type UserInput = {
  classYear?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  tocAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserProductSettings = {
  __typename?: 'UserProductSettings';
  examDate?: Maybe<Scalars['Date']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  nextFeedbackDate?: Maybe<Scalars['Date']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ucatMockAccessArrangement?: Maybe<UcatMockAccessArrangement>;
};

export type UserProductSettingsInput = {
  examDate?: InputMaybe<Scalars['Date']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  ucatMockAccessArrangement?: InputMaybe<UcatMockAccessArrangement>;
};

export type UserProgress = {
  __typename?: 'UserProgress';
  avgAttempted?: Maybe<Scalars['Float']['output']>;
  avgScore?: Maybe<Scalars['Float']['output']>;
  daysInCurrentStreak?: Maybe<Scalars['Int']['output']>;
  daysInLongestStreak?: Maybe<Scalars['Int']['output']>;
  daysInPreviousStreak?: Maybe<Scalars['Int']['output']>;
  marksheetCount?: Maybe<Scalars['Int']['output']>;
  questionsCount?: Maybe<Scalars['Int']['output']>;
  stationsCount?: Maybe<Scalars['Int']['output']>;
};

export type UserSession = {
  __typename?: 'UserSession';
  id?: Maybe<Scalars['Int']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  session_end?: Maybe<Scalars['Date']['output']>;
  session_start?: Maybe<Scalars['Date']['output']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  globalSettings?: Maybe<UserGlobalSettings>;
  id?: Maybe<Scalars['Int']['output']>;
  productSettings?: Maybe<UserProductSettings>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** UserSettingsInput is used on the settings view for updating the user */
export type UserSettingsInput = {
  globalSettings?: InputMaybe<UserGlobalSettingsInput>;
  productSettings?: InputMaybe<UserProductSettingsInput>;
};

export type UserStationNote = {
  __typename?: 'UserStationNote';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  station?: Maybe<OsceStation>;
  stationId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Station Status By User */
export type UserStationStatus = {
  __typename?: 'UserStationStatus';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  osceStationId?: Maybe<Scalars['Int']['output']>;
  station?: Maybe<OsceStation>;
  /** status is based on EUserLearningStatus */
  status?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserStats = {
  __typename?: 'UserStats';
  meanPercentile?: Maybe<Scalars['Float']['output']>;
  meanScore?: Maybe<Scalars['Float']['output']>;
  medianPercentile?: Maybe<Scalars['Float']['output']>;
  /** Graph related data */
  medianScore?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  /** [x, y][] */
  series?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  stddevPercentile?: Maybe<Scalars['Float']['output']>;
  stddevScore?: Maybe<Scalars['Float']['output']>;
  /** User related data */
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserStatus = {
  __typename?: 'UserStatus';
  registered?: Maybe<Scalars['Int']['output']>;
  subscribed?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  unRegistered?: Maybe<Scalars['Int']['output']>;
};

export type UserSubscriptionInput = {
  periodEndAt?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  purchaseSource?: InputMaybe<Scalars['Int']['input']>;
};

/** Video Status By User */
export type UserVideotatus = {
  __typename?: 'UserVideotatus';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** status is based on EUserLearningStatus */
  status?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  video?: Maybe<Video>;
  videoId?: Maybe<Scalars['Int']['output']>;
};

export type ValidUserToken = {
  __typename?: 'ValidUserToken';
  createNewOneOffCheckoutSession?: Maybe<Scalars['String']['output']>;
  createNewSubscriptionCheckoutSession?: Maybe<Scalars['String']['output']>;
  /** Returns the Stripe Checkout session id, like createNewSubscriptionCheckoutSession */
  createStudyGroupCheckoutSession?: Maybe<Scalars['String']['output']>;
  renewToken?: Maybe<Scalars['JWT']['output']>;
};


export type ValidUserTokenCreateNewOneOffCheckoutSessionArgs = {
  additionalPriceId?: InputMaybe<Scalars['String']['input']>;
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  successUrl?: InputMaybe<Scalars['String']['input']>;
};


export type ValidUserTokenCreateNewSubscriptionCheckoutSessionArgs = {
  additionalPriceId?: InputMaybe<Scalars['String']['input']>;
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  successUrl?: InputMaybe<Scalars['String']['input']>;
};


export type ValidUserTokenCreateStudyGroupCheckoutSessionArgs = {
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  successUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateBookInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['Int']['input'];
  entitlementId: Scalars['Int']['input'];
  file: Scalars['FileDataInput']['input'];
  folders: Array<Scalars['String']['input']>;
  forcedChecks?: InputMaybe<ForcedChecks>;
  forcedInserts?: InputMaybe<ForcedInserts>;
  grammarType: Scalars['Int']['input'];
  overWrite?: InputMaybe<OverwriteInput>;
  topicTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateMockTestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['Int']['input'];
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  file: Scalars['FileDataInput']['input'];
  folders: Array<Scalars['String']['input']>;
  forcedChecks?: InputMaybe<ForcedChecks>;
  forcedInserts?: InputMaybe<ForcedInserts>;
  grammarType: Scalars['Int']['input'];
  intro?: InputMaybe<Scalars['String']['input']>;
  mockTypeId: Scalars['Int']['input'];
  overWrite?: InputMaybe<OverwriteInput>;
  passingMark?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  topicTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateQuestionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['Int']['input'];
  difficulty: Scalars['Int']['input'];
  entitlementId: Scalars['Int']['input'];
  file: Scalars['FileDataInput']['input'];
  folders: Array<Scalars['String']['input']>;
  forcedChecks?: InputMaybe<ForcedChecks>;
  forcedInserts?: InputMaybe<ForcedInserts>;
  grammarType: Scalars['Int']['input'];
  overWrite?: InputMaybe<OverwriteInput>;
  topicTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateStationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['Int']['input'];
  difficulty: Scalars['Int']['input'];
  entitlementId: Scalars['Int']['input'];
  file: Scalars['FileDataInput']['input'];
  folders: Array<Scalars['String']['input']>;
  forcedChecks?: InputMaybe<ForcedChecks>;
  forcedInserts?: InputMaybe<ForcedInserts>;
  grammarType: Scalars['Int']['input'];
  overWrite?: InputMaybe<OverwriteInput>;
  stationTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateUcatQuestionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['Int']['input'];
  difficulty: Scalars['Int']['input'];
  entitlementId: Scalars['Int']['input'];
  file: Scalars['FileDataInput']['input'];
  folders: Array<Scalars['String']['input']>;
  forcedChecks?: InputMaybe<ForcedChecks>;
  forcedInserts?: InputMaybe<ForcedInserts>;
  grammarType: Scalars['Int']['input'];
  overWrite?: InputMaybe<OverwriteInput>;
};

export type ValidatorResult = {
  __typename?: 'ValidatorResult';
  batchId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  logFile?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Video = {
  __typename?: 'Video';
  assetId?: Maybe<Scalars['String']['output']>;
  /** Bunny Stream video GUID */
  bunnyId?: Maybe<Scalars['String']['output']>;
  concepts?: Maybe<Array<Maybe<Concept>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  /** Description is used by live=true videos */
  description?: Maybe<Scalars['String']['output']>;
  /** Duration of the video in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['DateLDN']['output']>;
  /** Entitlement this video belongs to — drives the video library category dropdown */
  entitlement?: Maybe<Entitlement>;
  files?: Maybe<Array<Maybe<File>>>;
  id?: Maybe<Scalars['ID']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  /** MuseId linked to muse.ai if live=false otherwise a zoom video ID */
  museId: Scalars['String']['output'];
  osceStation?: Maybe<OsceStation>;
  /** Mux playback ID */
  playbackId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateLDN']['output']>;
  /** Learning status */
  status?: Maybe<Scalars['Int']['output']>;
  /** URL for photo thumbnail */
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tokens?: Maybe<VideoTokens>;
  /** Topic this video belongs to, for non-station products */
  topic?: Maybe<Topic>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Have user viewed this video or not */
  userViewed?: Maybe<Scalars['Boolean']['output']>;
  views: Scalars['Int']['output'];
  viewsToday: Scalars['Int']['output'];
  /** Has the user saved this video to watch later */
  watchLater?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Signed playback assets for a video. List queries return only the Bunny-derived
 * fields (thumbnail, gif, bunnyUrl, hlsUrl); the single-video query returns all six.
 */
export type VideoTokens = {
  __typename?: 'VideoTokens';
  /** Signed Bunny embed-player URL (6h). Null when the video has no bunnyId. */
  bunnyUrl?: Maybe<Scalars['String']['output']>;
  /** Signed Bunny preview.webp URL when bunnyId is set (6h), otherwise a Mux gif JWT in the detail query. */
  gif?: Maybe<Scalars['String']['output']>;
  /** Signed Bunny HLS playlist URL (6h), for native playback via react-native-video. Null when the video has no bunnyId. */
  hlsUrl?: Maybe<Scalars['String']['output']>;
  /** Mux playback JWT (7d). Detail query only — null in list results. */
  playback?: Maybe<Scalars['String']['output']>;
  /** Mux storyboard JWT (7d). Detail query only — null in list results. */
  storyboard?: Maybe<Scalars['String']['output']>;
  /** Signed Bunny CDN URL when bunnyId is set (6h), otherwise a Mux thumbnail JWT in the detail query. */
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type VisibilityInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['Int']['input']>;
  visibility: Scalars['Boolean']['input'];
};

export type WeeklyRecordReview = {
  __typename?: 'WeeklyRecordReview';
  actionedBy?: Maybe<Scalars['Int']['output']>;
  chapter?: Maybe<Chapter>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdByUser?: Maybe<User>;
  id?: Maybe<Scalars['ID']['output']>;
  members?: Maybe<Array<Maybe<WeeklyRecordReviewMember>>>;
  question?: Maybe<Question>;
  reason?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  station?: Maybe<OsceStation>;
  type?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type WeeklyRecordReviewList = {
  __typename?: 'WeeklyRecordReviewList';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  nextCursor?: Maybe<Scalars['Int']['output']>;
  result: Array<WeeklyRecordReview>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type WeeklyRecordReviewMember = {
  __typename?: 'WeeklyRecordReviewMember';
  id?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  weeklyRecordReviewId?: Maybe<Scalars['Int']['output']>;
};

export type WeeklyRecordReviewOptions = {
  actionedBy?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  recordIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type AddToDailyStackData = {
  __typename?: 'addToDailyStackData';
  addedUserCompletedCards?: Maybe<Array<Maybe<UserCompletedCard>>>;
  dailyFeed?: Maybe<Todo>;
  marks?: Maybe<Array<Maybe<MarksheetMark>>>;
};

export type RemoveFromDailyStackData = {
  __typename?: 'removeFromDailyStackData';
  dailyFeed?: Maybe<Todo>;
  marks?: Maybe<Array<Maybe<MarksheetMark>>>;
  removedUserCompletedCards?: Maybe<Array<Maybe<UserCompletedCard>>>;
};
